webpackJsonp([1],{

/***/ 104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return matrix; });
var matrix = [[1, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14.1, 15.1, 16.1, 17.1, 18.1, 19.1, 20.2, 21.2, 22.2, 23.3, 24.3, 25.3, 26.4, 27.4, 28.4, 29.5, 30.5, 31.5, 32.6, 33.6, 34.7, 35.7, 36.8, 37.8, 38.9, 40, 41, 42.1, 43.1, 44.2, 45.3, 46.3, 47.4, 48.5, 49.5], [1, 2, 3, 4, 5, 6, 7.1, 8.1, 9.1, 10.1, 11.1, 12.1, 13.2, 14.2, 15.2, 16.2, 17.3, 18.3, 19.3, 20.4, 21.4, 22.4, 23.5, 24.5, 25.6, 26.6, 27.7, 28.7, 29.8, 30.8, 31.9, 32.9, 34, 35, 36.1, 37.2, 38.2, 39.3, 40.4, 41.4, 42.5, 43.6, 44.7, 45.7, 46.8, 47.9, 49, 50.1, 51.2], [2, 3, 4.1, 5.1, 6.1, 7.1, 8.1, 9.2, 10.2, 11.2, 12.2, 13.3, 14.3, 15.4, 16.4, 17.4, 18.5, 19.5, 20.6, 21.6, 22.7, 23.7, 24.8, 25.8, 26.9, 27.9, 29, 30, 31.1, 32.2, 33.2, 34.3, 35.4, 36.5, 37.5, 38.6, 39.7, 40.8, 41.9, 43, 44, 45.1, 46.2, 47.3, 48.4, 49.5, 50.6, 51.7, 52.8], [3.1, 4.1, 5.1, 6.1, 7.2, 8.2, 9.2, 10.3, 11.3, 12.4, 13.4, 14.5, 15.5, 16.5, 17.6, 18.6, 19.7, 20.8, 21.8, 22.9, 23.9, 25, 26.1, 27.1, 28.2, 29.3, 30.4, 31.4, 32.5, 33.6, 34.7, 35.8, 36.8, 37.9, 39, 40.1, 41.2, 42.3, 43.4, 44.5, 45.6, 46.7, 47.8, 48.9, 50, 51.2, 52.3, 53.4, 54.5], [4.1, 5.2, 6.2, 7.2, 8.3, 9.3, 10.4, 11.4, 12.5, 13.5, 14.6, 15.6, 16.7, 17.8, 18.8, 19.9, 21, 22, 23.1, 24.2, 25.3, 26.3, 27.4, 28.5, 29.6, 30.7, 31.8, 32.8, 33.9, 35, 36.1, 37.2, 38.3, 39.4, 40.5, 41.6, 42.8, 43.9, 45, 46.1, 47.2, 48.3, 49.5, 50.6, 51.7, 52.9, 54, 55.1, 56.3], [5.2, 6.3, 7.3, 8.4, 9.4, 10.5, 11.5, 12.6, 13.7, 14.7, 15.8, 16.9, 17.9, 19, 20.1, 21.2, 22.2, 23.3, 24.4, 25.5, 26.6, 27.7, 28.8, 29.9, 31, 32.1, 33.2, 34.3, 35.4, 36.5, 37.6, 38.7, 39.9, 41, 42.1, 43.2, 44.4, 45.5, 46.6, 47.7, 48.9, 50, 51.2, 52.3, 53.5, 54.6, 55.8, 56.9, 58.1], [6.3, 7.4, 8.4, 9.5, 10.6, 11.6, 12.7, 13.8, 14.9, 16, 17, 18.1, 19.2, 20.3, 21.4, 22.5, 23.6, 24.7, 25.8, 26.9, 28, 29.1, 30.2, 31.3, 32.4, 33.5, 34.7, 35.8, 36.9, 38, 39.2, 40.3, 41.4, 42.6, 43.7, 44.8, 46, 47.1, 48.3, 49.4, 50.6, 51.7, 52.9, 54.1, 55.2, 56.4, 57.6, 58.7, 59.9], [7.5, 8.5, 9.6, 10.7, 11.8, 12.8, 13.9, 15, 16.1, 17.2, 18.3, 19.4, 20.5, 21.6, 22.7, 23.8, 24.9, 26, 27.1, 28.3, 29.4, 30.5, 31.6, 32.8, 33.9, 35, 36.2, 37.3, 38.4, 39.6, 40.7, 41.9, 43, 44.2, 45.3, 46.5, 47.7, 48.8, 50, 51.2, 52.3, 53.5, 54.7, 55.9, 57.1, 58.3, 59.4, 60.6, 61.8], [8.6, 9.7, 10.8, 11.9, 13, 14.1, 15.2, 16.3, 17.4, 18.5, 19.6, 20.7, 21.8, 22.9, 24.1, 25.2, 26.3, 27.4, 28.6, 29.7, 30.8, 32, 33.1, 34.3, 35.4, 36.6, 37.7, 38.9, 40, 41.2, 42.3, 43.5, 44.7, 45.9, 47, 48.2, 49.4, 50.6, 51.8, 53, 54.1, 55.3, 56.5, 57.7, 59, 60.2, 61.4, 62.6, 63.8], [9.8, 10.9, 12, 13.1, 14.2, 15.3, 16.4, 17.6, 18.7, 19.8, 20.9, 22, 23.2, 24.3, 25.4, 26.6, 27.7, 28.9, 30, 31.2, 32.3, 33.5, 34.6, 35.8, 37, 38.1, 39.3, 40.5, 41.6, 42.8, 44, 45.2, 46.4, 47.6, 48.8, 50, 51.2, 52.4, 53.6, 54.8, 56, 57.2, 58.4, 59.7, 60.9, 62.1, 63.4, 64.6, 65.8], [11, 12.1, 13.2, 14.4, 15.5, 16.6, 17.7, 18.9, 20, 21.1, 22.3, 23.4, 24.6, 25.7, 26.9, 28, 29.2, 30.3, 31.5, 32.7, 33.8, 35, 36.2, 37.4, 38.6, 39.7, 40.9, 42.1, 43.3, 44.5, 45.7, 46.9, 48.1, 49.3, 50.6, 51.8, 53, 54.2, 55.5, 56.7, 57.9, 59.2, 60.4, 61.7, 62.9, 64.2, 65.4, 66.7, 67.9], [12.2, 13.4, 14.5, 15.6, 16.8, 17.9, 19.1, 20.2, 21.4, 22.5, 23.7, 24.8, 26, 27.2, 28.3, 29.5, 30.7, 31.9, 33, 34.2, 35.4, 36.6, 37.8, 39, 40.2, 41.4, 42.6, 43.8, 45, 46.3, 47.5, 48.7, 49.9, 51.2, 52.4, 53.7, 54.9, 56.1, 57.4, 58.6, 59.9, 61.2, 62.4, 63.7, 65, 66.3, 67.5, 68.8, 70.1], [13.5, 14.6, 15.8, 16.9, 18.1, 19.3, 20.4, 21.6, 22.8, 23.9, 25.1, 26.3, 27.5, 28.6, 29.8, 31, 32.2, 33.4, 34.6, 35.8, 37, 38.2, 39.5, 40.7, 41.9, 43.1, 44.3, 45.6, 46.8, 48.1, 49.3, 50.6, 51.8, 53.1, 54.3, 55.6, 56.8, 58.1, 59.4, 60.7, 62, 63.2, 64.5, 65.8, 67.1, 68.4, 69.7, 71, 72.4], [14.8, 16, 17.1, 18.3, 19.5, 20.6, 21.8, 23, 24.2, 25.4, 26.6, 27.8, 29, 30.2, 31.4, 32.6, 33.8, 35, 36.2, 37.5, 38.7, 39.9, 41.2, 42.4, 43.6, 44.9, 46.1, 47.4, 48.6, 49.9, 51.2, 52.5, 53.7, 55, 56.3, 57.6, 58.9, 60.2, 61.5, 62.8, 64.1, 65.4, 66.7, 68, 69.3, 70.7, 72, 73.3, 74.7], [16.1, 17.3, 18.5, 19.7, 20.9, 22.1, 23.3, 24.5, 25.7, 26.9, 28.1, 29.3, 30.5, 31.7, 33, 34.2, 35.4, 36.7, 37.9, 39.1, 40.4, 41.6, 42.9, 44.2, 45.4, 46.7, 48, 49.3, 50.5, 51.8, 53.1, 54.4, 55.7, 57, 58.3, 59.6, 60.9, 62.3, 63.6, 64.9, 66.3, 67.6, 68.9, 70.3, 71.6, 73, 74.4, 75.7, 77.1], [17.5, 18.7, 19.9, 21.1, 22.3, 23.5, 24.7, 25.9, 27.2, 28.4, 29.6, 30.9, 32.1, 33.3, 34.6, 35.8, 37.1, 38.4, 39.6, 40.9, 42.2, 43.4, 44.7, 46, 47.3, 48.6, 49.9, 51.2, 52.5, 53.8, 55.1, 56.4, 57.8, 59.1, 60.4, 61.8, 63.1, 64.5, 65.8, 67.2, 68.5, 69.9, 71.3, 72.6, 74, 75.4, 76.8, 78.2, 79.6], [18.9, 20.1, 21.3, 22.6, 23.8, 25, 26.2, 27.5, 28.7, 30, 31.2, 32.5, 33.7, 35, 36.3, 37.5, 38.8, 40.1, 41.4, 42.7, 44, 45.3, 46.6, 47.9, 49.2, 50.5, 51.8, 53.2, 54.5, 55.8, 57.2, 58.5, 59.9, 61.2, 62.6, 64, 65.3, 66.7, 68.1, 69.5, 70.9, 72.3, 73.7, 75.1, 76.5, 77.9, 79.3, 80.8, 82.2], [20.3, 21.6, 22.8, 24.1, 25.3, 26.6, 27.8, 29.1, 30.3, 31.6, 32.9, 34.1, 35.4, 36.7, 38, 39.3, 40.6, 41.9, 43.2, 44.5, 45.9, 47.2, 48.5, 49.8, 51.2, 52.5, 53.9, 55.2, 56.6, 58, 59.3, 60.7, 62.1, 63.5, 64.9, 66.3, 67.7, 69.1, 70.5, 71.9, 73.3, 74.8, 76.2, 77.6, 79.1, 80.5, 82, 83.5, 84.9], [21.8, 23.1, 24.3, 25.6, 26.9, 28.1, 29.4, 30.7, 32, 33.3, 34.6, 35.9, 37.2, 38.5, 39.8, 41.1, 42.4, 43.8, 45.1, 46.5, 47.8, 49.2, 50.5, 51.9, 53.2, 54.6, 56, 57.4, 58.8, 60.2, 61.6, 63, 64.4, 65.8, 67.2, 68.6, 70.1, 71.5, 73, 74.4, 75.9, 77.3, 78.8, 80.3, 81.8, 83.3, 84.8, 86.3, 87.8], [23.3, 24.6, 25.9, 27.2, 28.5, 29.8, 31.1, 32.4, 33.7, 35, 36.3, 37.6, 39, 40.3, 41.6, 43, 44.3, 45.7, 47.1, 48.4, 49.8, 51.2, 52.6, 54, 55.4, 56.8, 58.2, 59.6, 61, 62.4, 63.9, 65.3, 66.8, 68.2, 69.7, 71.1, 72.6, 74.1, 75.5, 77, 78.5, 80, 81.5, 83.1, 84.6, 86.1, 87.6, 89.2, 90.7], [24.9, 26.2, 27.5, 28.8, 30.1, 31.5, 32.8, 34.1, 35.4, 36.8, 38.1, 39.5, 40.8, 42.2, 43.6, 44.9, 46.3, 47.7, 49.1, 50.5, 51.9, 53.3, 54.7, 56.1, 57.6, 59, 60.4, 61.9, 63.3, 64.8, 66.3, 67.7, 69.2, 70.7, 72.2, 73.7, 75.2, 76.7, 78.2, 79.8, 81.3, 82.8, 84.4, 85.9, 87.5, 89.1, 90.7, 92.2, 93.8], [26.5, 27.9, 29.2, 30.5, 31.8, 33.2, 34.5, 35.9, 37.3, 38.6, 40, 41.4, 42.8, 44.1, 45.5, 46.9, 48.4, 49.8, 51.2, 52.6, 54.1, 55.5, 56.9, 58.4, 59.9, 61.3, 62.8, 64.3, 65.8, 67.3, 68.8, 70.3, 71.8, 73.3, 74.9, 76.4, 77.9, 79.5, 81.1, 82.6, 84.2, 85.8, 87.4, 89, 90.6, 92.2, 93.8, 95.4, 97.1], [28.2, 29.5, 30.9, 32.3, 33.6, 35, 36.4, 37.7, 39.1, 40.5, 41.9, 43.3, 44.8, 46.2, 47.6, 49, 50.5, 51.9, 53.4, 54.8, 56.3, 57.8, 59.3, 60.8, 62.3, 63.8, 65.3, 66.8, 68.3, 69.8, 71.4, 72.9, 74.5, 76.1, 77.6, 79.2, 80.8, 82.4, 84, 85.6, 87.2, 88.9, 90.5, 92.1, 93.8, 95.5, 97.1, 98.8, 100.5], [29.9, 31.3, 32.7, 34.1, 35.5, 36.8, 38.3, 39.7, 41.1, 42.5, 43.9, 45.4, 46.8, 48.3, 49.7, 51.2, 52.7, 54.2, 55.6, 57.1, 58.6, 60.2, 61.7, 63.2, 64.7, 66.3, 67.8, 69.4, 71, 72.5, 74.1, 75.7, 77.3, 78.9, 80.5, 82.2, 83.8, 85.4, 87.1, 88.7, 90.4, 92.1, 93.8, 95.5, 97.2, 98.9, 100.6, 102.4, 104.1], [31.7, 33.1, 34.5, 35.9, 37.3, 38.8, 40.2, 41.7, 43.1, 44.6, 46, 47.5, 49, 50.5, 52, 53.5, 55, 56.5, 58, 59.5, 61.1, 62.6, 64.2, 65.8, 67.3, 68.9, 70.5, 72.1, 73.7, 75.3, 77, 78.6, 80.3, 81.9, 83.6, 85.2, 86.9, 88.6, 90.3, 92, 93.8, 95.5, 97.2, 99, 100.7, 102.5, 104.3, 106.1, 107.9], [33.6, 35, 36.4, 37.9, 39.3, 40.8, 42.2, 43.7, 45.2, 46.7, 48.2, 49.7, 51.2, 52.7, 54.3, 55.8, 57.3, 58.9, 60.5, 62, 63.6, 65.2, 66.8, 68.4, 70, 71.7, 73.3, 75, 76.6, 78.3, 80, 81.7, 83.3, 85.1, 86.8, 88.5, 90.2, 92, 93.7, 95.5, 97.3, 99.1, 100.9, 102.7, 104.5, 106.3, 108.2, 110, 111.9], [35.5, 36.9, 38.4, 39.9, 41.4, 42.8, 44.3, 45.9, 47.4, 48.9, 50.4, 52, 53.5, 55.1, 56.7, 58.2, 59.8, 61.4, 63, 64.7, 66.3, 67.9, 69.6, 71.2, 72.9, 74.6, 76.3, 78, 79.7, 81.4, 83.1, 84.8, 86.6, 88.4, 90.1, 91.9, 93.7, 95.5, 97.3, 99.2, 101, 102.9, 104.7, 106.6, 108.5, 110.4, 112.3, 114.2, 116.2], [37.4, 38.9, 40.4, 42, 43.5, 45, 46.5, 48.1, 49.6, 51.2, 52.8, 54.4, 56, 57.6, 59.2, 60.8, 62.4, 64.1, 65.7, 67.4, 69.1, 70.8, 72.5, 74.2, 75.9, 77.6, 79.4, 81.1, 82.9, 84.6, 86.4, 88.2, 90, 91.9, 93.7, 95.5, 97.4, 99.3, 101.2, 103.1, 105, 106.9, 108.8, 110.8, 112.7, 114.7, 116.7, 118.7, 120.7], [39.5, 41, 42.6, 44.1, 45.7, 47.3, 48.8, 50.4, 52, 53.6, 55.2, 56.9, 58.5, 60.2, 61.8, 63.5, 65.2, 66.9, 68.6, 70.3, 72, 73.7, 75.5, 77.3, 79, 80.8, 82.6, 84.4, 86.3, 88.1, 89.9, 91.8, 93.7, 95.6, 97.5, 99.4, 101.3, 103.3, 105.2, 107.2, 109.2, 111.2, 113.2, 115.2, 117.3, 119.3, 121.4, 123.5, 125.6], [41.7, 43.2, 44.8, 46.4, 48, 49.6, 51.2, 52.8, 54.5, 56.1, 57.8, 59.5, 61.2, 62.9, 64.6, 66.3, 68, 69.8, 71.5, 73.3, 75.1, 76.9, 78.7, 80.5, 82.4, 84.2, 86.1, 87.9, 89.8, 91.7, 93.7, 95.6, 97.5, 99.5, 101.5, 103.5, 105.5, 107.5, 109.5, 111.6, 113.7, 115.7, 117.8, 120, 122.1, 124.2, 126.4, 128.6, 130.8], [43.9, 45.5, 47.1, 48.7, 50.4, 52, 53.7, 55.4, 57.1, 58.8, 60.5, 62.2, 64, 65.7, 67.5, 69.3, 71, 72.9, 74.7, 76.5, 78.3, 80.2, 82.1, 84, 85.9, 87.8, 89.7, 91.7, 93.6, 95.6, 97.6, 99.6, 101.6, 103.7, 105.7, 107.8, 109.9, 112, 114.2, 116.3, 118.5, 120.6, 122.8, 125.1, 127.3, 129.5, 131.8, 134.1, 136.4], [46.2, 47.9, 49.5, 51.2, 52.9, 54.6, 56.3, 58.1, 59.8, 61.6, 63.3, 65.1, 66.9, 68.7, 70.5, 72.4, 74.2, 76.1, 78, 79.9, 81.8, 83.7, 85.7, 87.6, 89.6, 91.6, 93.6, 95.6, 97.7, 99.7, 101.8, 103.9, 106, 108.2, 110.3, 112.5, 114.7, 116.9, 119.1, 121.4, 123.6, 125.9, 128.2, 130.5, 132.9, 135.3, 137.7, 140.1, 142.5], [48.7, 50.4, 52.1, 53.8, 55.6, 57.3, 59.1, 60.9, 62.7, 64.5, 66.3, 68.2, 70, 71.9, 73.8, 75.7, 77.6, 79.5, 81.5, 83.5, 85.4, 87.5, 89.5, 91.5, 93.6, 95.7, 97.8, 99.9, 102, 104.2, 106.3, 108.5, 110.7, 113, 115.2, 117.5, 119.8, 122.1, 124.5, 126.8, 129.2, 131.6, 134, 136.5, 139, 141.5, 144, 146.6, 149.1], [51.2, 53, 54.8, 56.5, 58.3, 60.2, 62, 63.8, 65.7, 67.6, 69.5, 71.4, 73.3, 75.2, 77.2, 79.2, 81.2, 83.2, 85.2, 87.3, 89.3, 91.4, 93.6, 95.7, 97.8, 100, 102.2, 104.4, 106.6, 108.9, 111.2, 113.5, 115.8, 118.2, 120.5, 122.9, 125.4, 127.8, 130.3, 132.8, 135.3, 137.8, 140.4, 143, 145.6, 148.3, 150.9, 153.7, 156.4], [53.9, 55.7, 57.6, 59.4, 61.3, 63.1, 65, 67, 68.9, 70.8, 72.8, 74.8, 76.8, 78.8, 80.8, 82.9, 85, 87.1, 89.2, 91.4, 93.5, 95.7, 97.9, 100.2, 102.4, 104.7, 107, 109.3, 111.7, 114, 116.4, 118.9, 121.3, 123.8, 126.3, 128.8, 131.4, 134, 136.6, 139.2, 141.9, 144.6, 147.4, 150.1, 152.9, 155.7, 158.6, 161.5, 164.4], [56.8, 58.6, 60.5, 62.4, 64.4, 66.3, 68.3, 70.3, 72.3, 74.3, 76.3, 78.4, 80.5, 82.6, 84.7, 86.9, 89.1, 91.3, 93.5, 95.7, 98, 100.3, 102.6, 105, 107.3, 109.7, 112.2, 114.6, 117.1, 119.6, 122.2, 124.7, 127.3, 129.9, 132.6, 135.3, 138, 140.8, 143.6, 146.4, 149.2, 152.1, 155, 158, 161, 164, 167.1, 170.2, 173.3], [59.8, 61.7, 63.7, 65.7, 67.7, 69.7, 71.7, 73.8, 75.9, 78, 80.1, 82.3, 84.5, 86.7, 88.9, 91.2, 93.5, 95.8, 98.1, 100.5, 102.9, 105.3, 107.7, 110.2, 112.7, 115.2, 117.8, 120.4, 123, 125.7, 128.4, 131.1, 133.9, 136.7, 139.5, 142.4, 145.3, 148.3, 151.3, 154.3, 157.3, 160.5, 163.6, 166.8, 170, 173.3, 176.6, 179.9, 183.3], [62.9, 65, 67, 69.1, 71.2, 73.3, 75.4, 77.6, 79.8, 82, 84.2, 86.5, 88.8, 91.1, 93.4, 95.8, 98.2, 100.6, 103.1, 105.6, 108.1, 110.7, 113.3, 115.9, 118.6, 121.3, 124, 126.8, 129.6, 132.4, 135.3, 138.2, 141.2, 144.2, 147.3, 150.3, 153.5, 156.7, 159.9, 163.1, 166.5, 169.8, 173.2, 176.7, 180.2, 183.7, 187.3, 191, 194.7], [66.3, 68.4, 70.6, 72.7, 74.9, 77.1, 79.4, 81.6, 83.9, 86.2, 88.6, 91, 93.4, 95.8, 98.3, 100.8, 103.4, 105.9, 108.6, 111.2, 113.9, 116.6, 119.4, 122.2, 125, 127.9, 130.8, 133.8, 136.8, 139.9, 143, 146.2, 149.4, 152.6, 155.9, 159.2, 162.6, 166.1, 169.6, 173.2, 176.8, 180.4, 184.2, 188, 191.8, 195.7, 199.7, 203.7, 207.7], [70, 72.2, 74.4, 76.7, 78.9, 81.3, 83.6, 86, 88.4, 90.9, 93.4, 95.9, 98.4, 101, 103.6, 106.3, 109, 111.8, 114.6, 117.4, 120.3, 123.2, 126.1, 129.2, 132.2, 135.3, 138.5, 141.7, 145, 148.3, 151.7, 155.1, 158.6, 162.1, 165.7, 169.4, 173.1, 176.9, 180.7, 184.7, 188.7, 192.7, 196.8, 201, 205.3, 209.6, 214, 218.5, 223], [73.8, 76.2, 78.5, 80.9, 83.3, 85.7, 88.2, 90.8, 93.3, 95.9, 98.5, 101.2, 103.9, 106.7, 109.5, 112.4, 115.3, 118.2, 121.2, 124.3, 127.4, 130.5, 133.7, 137, 140.3, 143.7, 147.1, 150.6, 154.2, 157.8, 161.5, 165.3, 169.1, 173, 177, 181.1, 185.2, 189.4, 193.7, 198.1, 202.5, 207.1, 211.7, 216.4, 221.1, 226, 231, 236, 241.1], [78, 80.5, 83, 85.5, 88, 90.6, 93.3, 95.9, 98.7, 101.4, 104.3, 107.1, 110, 113, 116, 119.1, 122.2, 125.4, 128.7, 132, 135.4, 138.8, 142.3, 145.9, 149.5, 153.2, 157, 160.9, 164.8, 168.9, 173, 177.2, 181.5, 185.8, 190.3, 194.8, 199.5, 204.2, 209.1, 214, 219.1, 224.2, 229.4, 234.8, 240.2, 245.8, 251.5, 257.2, 263.1], [82.6, 85.2, 87.8, 90.5, 93.2, 96, 98.8, 101.7, 104.6, 107.6, 110.6, 113.7, 116.9, 120.1, 123.4, 126.7, 130.1, 133.6, 137.2, 140.8, 144.5, 148.3, 152.2, 156.1, 160.2, 164.3, 168.6, 172.9, 177.3, 181.9, 186.5, 191.3, 196.1, 201.1, 206.2, 211.4, 216.7, 222.2, 227.7, 233.4, 239.2, 245.2, 251.3, 257.5, 263.8, 270.3, 276.9, 283.6, 290.5], [87.6, 90.4, 93.2, 96, 99, 101.9, 105, 108.1, 111.2, 114.5, 117.8, 121.1, 124.6, 128.1, 131.7, 135.4, 139.1, 143, 147, 151, 155.2, 159.4, 163.8, 168.2, 172.8, 177.5, 182.3, 187.3, 192.4, 197.6, 202.9, 208.4, 214, 219.8, 225.8, 231.8, 238.1, 244.5, 251, 257.7, 264.6, 271.7, 278.9, 286.3, 293.8, 301.5, 309.4, 317.4, 325.7], [93.1, 96.1, 99.1, 102.2, 105.4, 108.6, 111.9, 115.3, 118.7, 122.3, 125.9, 129.6, 133.4, 137.4, 141.4, 145.5, 149.7, 154.1, 158.5, 163.1, 167.9, 172.7, 177.7, 182.9, 188.2, 193.6, 199.3, 205.1, 211, 217.2, 223.5, 230, 236.7, 243.6, 250.8, 258.1, 265.6, 273.3, 281.2, 289.4, 297.8, 306.3, 315.1, 324.1, 333.3, 342.8, 352.4, 362.3, 372.4], [99.3, 102.5, 105.8, 109.2, 112.6, 116.2, 119.8, 123.6, 127.4, 131.4, 135.4, 139.6, 143.9, 148.3, 152.9, 157.6, 162.4, 167.4, 172.6, 178, 183.5, 189.2, 195.1, 201.2, 207.5, 214.1, 220.9, 227.9, 235.2, 242.7, 250.4, 258.4, 266.7, 275.3, 284.1, 293.3, 302.6, 312.3, 322.3, 332.5, 343, 353.8, 364.9, 376.2, 387.9, 399.8, 412, 424.5, 437.4], [106.3, 109.8, 113.4, 117.2, 121, 125, 129.1, 133.3, 137.6, 142.1, 146.7, 151.5, 156.5, 161.6, 167, 172.5, 178.2, 184.2, 190.4, 196.8, 203.5, 210.5, 217.8, 225.4, 233.3, 241.5, 250, 258.9, 268.2, 277.8, 287.8, 298.1, 308.8, 319.9, 331.4, 343.3, 355.5, 368.1, 381.1, 394.5, 408.3, 422.5, 437.1, 452, 467.4, 483.3, 499.6, 516.3, 533.5], [114.3, 118.3, 122.4, 126.6, 130.9, 135.4, 140.1, 145, 150, 155.3, 160.7, 166.4, 172.3, 178.5, 185, 191.8, 198.9, 206.4, 214.2, 222.4, 231, 240, 249.5, 259.5, 270, 280.9, 292.4, 304.4, 316.9, 330, 343.6, 357.8, 372.5, 387.7, 403.4, 419.8, 436.6, 454.1, 472.1, 490.7, 509.9, 529.8, 550.4, 571.7, 593.8, 616.7, 640.5, 665.3, 691], [123.9, 128.4, 133.1, 137.9, 143, 148.3, 153.9, 159.7, 165.8, 172.2, 178.9, 186, 193.5, 201.4, 209.8, 218.7, 228.2, 238.2, 248.9, 260.3, 272.3, 285.1, 298.7, 313, 328.2, 344.1, 360.9, 378.4, 396.8, 416, 436, 456.9, 478.6, 501.2, 524.7, 549.3, 574.8, 601.5, 629.4, 658.6, 689.3, 721.5, 755.6, 791.5, 829.7, 870.4, 913.9, 960.6, 1011.2], [135.5, 140.8, 146.4, 152.3, 158.5, 165, 172, 179.3, 187.2, 195.6, 204.6, 214.3, 224.7, 235.9, 248.1, 261.3, 275.5, 290.9, 307.6, 325.5, 344.8, 365.4, 387.3, 410.6, 435.2, 461.1, 488.4, 517.2, 547.5, 579.4, 613.1, 648.8, 686.7, 727, 770.1, 816.4, 866.4, 920.8, 980.4, 1046.2, 1119.9, 1203.3, 1299.7, 1413.6, 1553.1, 1732.9, 1986.3, 2419.6, 2419.6]];

/***/ }),

/***/ 105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var MathService = {
  decimalPlaces: function decimalPlaces(num) {
    var testNum = num.toString();
    return (testNum.split('.')[1] || []).length > 3;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (MathService);

/***/ }),

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return db; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebaseConfig__ = __webpack_require__(330);



var firebaseApp = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(__WEBPACK_IMPORTED_MODULE_1__firebaseConfig__["a" /* config */]);

var db = firebaseApp.database();

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(449),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(41);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  user: null
};

var mutations = {
  setUser: function setUser(state, value) {
    state.user = value;
  }
};

var getters = {
  getUser: function getUser(state) {
    return state.user;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  getters: getters,
  mutations: mutations
}));

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(402)
__webpack_require__(401)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(447),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(28);



__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('formatDate', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(String(value)).format('MM/DD/YYYY');
  }
});

/***/ }),

/***/ 330:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return config; });
var config = {
  apiKey: 'AIzaSyCrsXbe95HRHnBCrGpnHIe8wlsNtrMvoNo',
  authDomain: 'waterwatch-cb707.firebaseapp.com',
  databaseURL: 'https://waterwatch-cb707.firebaseio.com',
  projectId: 'waterwatch-cb707',
  storageBucket: 'waterwatch-cb707.appspot.com',
  messagingSenderId: '86550912720'
};

/***/ }),

/***/ 331:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MapHelper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);




var MapHelper = function () {
  function MapHelper(selectSiteCallback) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MapHelper);

    this.selectSiteCallback = selectSiteCallback;

    window.mapboxgl.accessToken = 'pk.eyJ1IjoibGNhY2VkYSIsImEiOiIzNmM4MGRlN2I4NDhiY2UxZjA4MmJjZjE5OWEzYjUzNSJ9.Wc5KTJpWxmpxVMZfcuEQNg';
    var map = new window.mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/lcaceda/cj9bqvwwu4kb52smypbx0j8f9',
      center: [-84.057249, 33.15888],
      zoom: 6.5 });

    map.on('load', function () {
      var storageRef = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.storage().ref();
      storageRef.child('sites.geojson').getDownloadURL().then(function (url) {
        map.addSource('sites', {
          'type': 'geojson',
          'data': url,
          'cluster': true,
          'clusterMaxZoom': 14,
          'clusterRadius': 25 });

        map.addSource('basin', {
          'type': 'geojson',
          'data': 'https://firebasestorage.googleapis.com/v0/b/waterwatch-cb707.appspot.com/o/Chatt_River_Basin.geojson?alt=media&token=e0dbd342-97ee-4d7a-9d20-b73f92451da1'
        });

        map.addSource('labs', {
          'type': 'geojson',
          'data': 'https://firebasestorage.googleapis.com/v0/b/waterwatch-cb707.appspot.com/o/labs.geojson?alt=media&token=7690b36f-cdca-43cd-888e-e2bda25b06a8'
        });

        map.addLayer({
          'id': 'Collection Sites Layer',
          'type': 'circle',
          'source': 'sites',
          'paint': {
            'circle-color': '#50869E',
            'circle-radius': {
              'property': 'point_count',
              'type': 'interval',
              'stops': [[0, 10], [15, 15], [30, 20]]
            }
          },
          'properties': {
            'description': 'points!'
          }
        });

        map.addLayer({
          'id': 'site-clicked',
          'type': 'circle',
          'source': 'sites',
          'paint': {
            'circle-color': '#7FBA00',
            'circle-radius': 12
          },
          'filter': ['in', 'Name', '']
        });

        map.addLayer({
          'id': 'sites-count',
          'type': 'symbol',
          'source': 'sites',
          'filter': ['has', 'point_count'],
          'layout': {
            'text-field': '{point_count_abbreviated}',
            'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
            'text-size': 12
          },
          'paint': {
            'text-color': '#FFFFFF'
          }
        });

        map.loadImage('/static/icon-star.png', function (error, image) {
          if (error) throw error;
          map.addImage('star', image);
          map.addLayer({
            'id': 'Labs',
            'type': 'symbol',
            'source': 'labs',
            'layout': {
              'icon-image': 'star',
              'icon-size': 0.8
            },
            'paint': {
              'icon-color': '#FDF1BF'
            }
          });
        });

        map.addLayer({
          'id': 'Basin Layer',
          'type': 'fill',
          'source': 'basin',
          'layout': {},
          'paint': {
            'fill-outline-color': 'rgba(7, 78, 112, 1)',
            'fill-color': 'rgba(80, 134, 158, 0.1)'
          },
          'properties': {
            'description': 'Chattahoochee River Basin'
          }
        });
      }).catch(function (error) {
        console.log(error);
      });
    });

    map.on('click', 'Collection Sites Layer', function (e) {
      var name = e.features[0].properties.Name;
      console.log(e);
      _this.selectSiteCallback(name);
      _this.makeItGreen(name);
    });

    map.on('click', 'Labs', function (e) {
      new window.mapboxgl.Popup().setLngLat(e.lngLat).setHTML(e.features[0].properties.Lab).addTo(map);
    });

    map.on('mouseenter', 'Labs', function () {
      map.getCanvas().style.cursor = 'pointer';
    });

    map.on('mouseleave', 'Labs', function () {
      map.getCanvas().style.cursor = '';
    });

    map.on('mouseenter', 'Collection Sites Layer', function () {
      map.getCanvas().style.cursor = 'pointer';
    });

    map.on('mouseleave', 'Collection Sites Layer', function () {
      map.getCanvas().style.cursor = '';
    });

    map.on('mouseenter', 'sites-count', function () {
      map.getCanvas().style.cursor = 'pointer';
    });

    map.on('mouseleave', 'sites-count', function () {
      map.getCanvas().style.cursor = '';
    });

    var zoomBtn = document.createElement('button');
    zoomBtn.className = 'mapboxgl-ctrl-icon mapboxgl-ctrl-fullextent';
    zoomBtn.type = 'button';
    zoomBtn.setAttribute('aria-label', 'zoom to full extent');
    zoomBtn.onclick = function () {
      map.flyTo({ center: [-84.057249, 33.15888], zoom: 6.5 });
    };

    var zoomContainer = document.getElementById('zoomContainer');
    zoomContainer.appendChild(zoomBtn);

    map.addControl(new window.MapboxGeocoder({
      accessToken: window.mapboxgl.accessToken,
      placeholder: 'Search Address'
    }));
    map.addControl(new window.mapboxgl.FullscreenControl(), 'bottom-right');
    map.addControl(new window.mapboxgl.GeolocateControl({
      positionOptions: {
        enableHighAccuracy: true
      },
      trackUserLocation: true
    }), 'bottom-right');
    map.addControl(new window.mapboxgl.NavigationControl(), 'bottom-right');
    this.map = map;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(MapHelper, [{
    key: 'resizeMap',
    value: function resizeMap() {
      var _this2 = this;

      setTimeout(function () {
        return _this2.map.resize();
      }, 500);
    }
  }, {
    key: 'zoomIn',
    value: function zoomIn(selectedSite) {
      this.makeItGreen(selectedSite.stationName);
      var latLong = [selectedSite.longitude, selectedSite.latitude];
      this.map.flyTo({
        center: latLong,
        zoom: 13
      });
    }
  }, {
    key: 'makeItGreen',
    value: function makeItGreen(name) {
      this.map.setFilter('site-clicked', ['in', 'Name', name]);
    }
  }]);

  return MapHelper;
}();

/***/ }),

/***/ 332:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuefire__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_highcharts__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_highcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_store__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_lodash_dist_vue_lodash_min__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_lodash_dist_vue_lodash_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_lodash_dist_vue_lodash_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_analytics__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_analytics__);













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuefire___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue2_highcharts___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_lodash_dist_vue_lodash_min___default.a, __WEBPACK_IMPORTED_MODULE_7_lodash___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_analytics___default.a, {
  id: 'UA-3008698-3'
});


new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a },
  store: __WEBPACK_IMPORTED_MODULE_6__helpers_store__["a" /* default */]
});

/***/ }),

/***/ 333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_app_nav__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_app_nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_app_nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_footer__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(60);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().onAuthStateChanged(function (user) {
      console.log('Auth state changed');
      _this.$store.commit('setUser', user || false);

      if (_this.$route.meta.requiresAuth && !user) {
        _this.$router.push('/signIn');
      }
    });

    __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].beforeEach(function (to, from, next) {
      if (to.matched.some(function (record) {
        return record.meta.requiresAuth;
      })) {
        if (!__WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().currentUser) {
          next({
            path: '/signIn',
            query: { redirect: to.fullPath }
          });
        } else {
          next();
        }
      } else {
        next();
      }
    });
  },

  components: {
    'app-nav': __WEBPACK_IMPORTED_MODULE_1__components_app_nav___default.a,
    'app-footer': __WEBPACK_IMPORTED_MODULE_2__components_app_footer___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])(['user']))
});

/***/ }),

/***/ 334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_firebase__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_generateGeoJson__ = __webpack_require__(55);





var collectionSitesRef = __WEBPACK_IMPORTED_MODULE_0__helpers_firebase__["a" /* db */].ref('collectionSites');

var labsRef = __WEBPACK_IMPORTED_MODULE_0__helpers_firebase__["a" /* db */].ref('labs');
var partnersRef = __WEBPACK_IMPORTED_MODULE_0__helpers_firebase__["a" /* db */].ref('partners');
var metaRef = __WEBPACK_IMPORTED_MODULE_0__helpers_firebase__["a" /* db */].ref('metaData');
var hucRef = __WEBPACK_IMPORTED_MODULE_0__helpers_firebase__["a" /* db */].ref('hucList');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'add-collection-site',
  firebase: {
    collectionSites: collectionSitesRef,
    labs: labsRef,
    partners: partnersRef,
    metaData: metaRef,
    hucList: hucRef
  },
  watch: {
    labs: {
      handler: function handler() {
        this.labSet = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(this.labs, '.value');
      }
    },
    partners: {
      handler: function handler() {
        this.partnerSet = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(this.partners, '.value');
      }
    },
    hucList: {
      handler: function handler() {
        this.hucSet = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(this.hucList, '.value');
      }
    }
  },
  data: function data() {
    return {
      labs: [],
      labSet: [],
      hucList: [],
      hucSet: [],
      partners: [],
      partnerSet: [],
      controls: {
        showDialog: false
      },
      newCollectionSite: {
        adoptAStreamName: '',
        aasNumber: '',
        collectionPartner: '',
        hucName: '',
        lab: '',
        latitude: '',
        logbookAbbv: '',
        longitude: '',
        stationName: '',
        storetName: '',
        storetId: '',
        numSamples: 0,
        isPrivate: false
      },
      snackbar: {
        errorVisible: false,
        successVisible: false,
        successMessage: 'Collection Site saved successfully!',
        errorMessage: 'There was an issue saving your Collection Site',
        timeout: 6000
      }
    };
  },
  methods: {
    submitForm: function submitForm() {
      try {
        this.$firebaseRefs.collectionSites.push(this.newCollectionSite);

        this.uploadNewJsonFile();

        this.snackbar.successVisible = true;
        this.controls.showDialog = false;
      } catch (e) {
        console.log(e);
        this.snackbar.errorVisible = true;
      }
    },
    resetCollectionForm: function resetCollectionForm() {
      this.newCollectionSite = {
        adoptAStreamName: '',
        collectionPartner: '',
        hucName: '',
        lab: '',
        latitude: '',
        logbookAbbv: '',
        longitude: '',
        stationName: '',
        storetName: '',
        numSamples: 0
      };
    },
    close: function close() {
      this.controls.showDialog = false;
    },
    uploadNewJsonFile: function uploadNewJsonFile() {
      var _this = this;

      this.$bindAsArray('jsonSites', collectionSitesRef, null, function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_generateGeoJson__["a" /* uploadNewGeoJsonFile */])(_this.jsonSites);
      });
    }
  }
});

/***/ }),

/***/ 335:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_firebase__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditLogData__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditLogData___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__EditLogData__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__json_excel_JsonExcel__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__json_excel_JsonExcel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__json_excel_JsonExcel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);









var collectionSitesRef = __WEBPACK_IMPORTED_MODULE_0__helpers_firebase__["a" /* db */].ref('collectionSites');
var todaysDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(new Date()).format('YYYY-MM-DD');
var oldDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(new Date()).subtract(1, 'months').format('YYYY-MM-DD');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'collection-sites',
  components: {
    EditLogData: __WEBPACK_IMPORTED_MODULE_3__EditLogData___default.a,
    JsonExcel: __WEBPACK_IMPORTED_MODULE_4__json_excel_JsonExcel___default.a
  },
  firebase: function firebase() {
    return {
      firebaseSite: {
        source: collectionSitesRef.orderByKey().equalTo(this.$route.params.siteId)
      },
      reports: __WEBPACK_IMPORTED_MODULE_0__helpers_firebase__["a" /* db */].ref('reports/' + this.$route.params.siteId).orderByChild('collectionDate').startAt(oldDate).endAt(todaysDate)
    };
  },

  computed: {
    getGoogleMapsUrl: function getGoogleMapsUrl() {
      if (this.site && this.site.longitude && this.site.latitude) {
        return 'https://www.google.com/maps/place/' + this.site.latitude + ',' + this.site.longitude;
      } else {
        return null;
      }
    }
  },
  watch: {
    firebaseSite: {
      deep: true,
      handler: function handler(newArray) {
        this.site = newArray[0];
      }
    },
    startDate: function startDate(val) {
      this.filterByDate();
    },
    endDate: function endDate(val) {
      this.filterByDate();
    }
  },
  data: function data() {
    return {
      firebaseSite: [],
      startDate: oldDate,
      endDate: todaysDate,
      site: {},
      pagination: {
        sortBy: 'logbookNumber',
        descending: 'asc',
        totalItems: 0,
        loading: true
      },
      controls: {
        search: '',
        startDateModal: false,
        endDateModal: false,
        exportAction: { label: 'Export' },
        showDeleteDialog: false
      },
      headers: [{ text: 'Logbook #', value: 'logbookNumber' }, { text: 'Collection Date', value: 'collectionDate' }, { text: 'Collection Time', value: 'collectionTime' }, { text: 'Analyst', value: 'analyst' }, { text: 'Total Coliform (MPN/100mL)', value: 'totalColiform' }, { text: 'E. coli (MPN/100mL)', value: 'totalEcoli' }, { text: 'Fluorometry', value: 'fluorometry' }, { text: 'Turbidity (NTU)', value: 'turbidity' }, { text: 'Conductivity (uS)', value: 'specificConductivity' }, { text: 'Rainfall (in)', value: 'precipitation' }, { text: 'Incubation In Time', value: 'incubationTime' }, { text: '# mL/100mL (Dilution)', value: 'dilution' }, { text: 'Incubation Temp', value: 'incubationTemp' }, { text: 'Incubation Out Time', value: 'incubationOut' }, { text: 'Notes', value: 'notes' }],
      selected: [],
      json_meta: [[{
        'key': 'charset',
        'value': 'utf-8'
      }]],
      jsonFields: {
        'logbookNumber': 'site ID #',
        'logbookAbbv': 'Site Name',
        'collectionDate': 'Collection Date',
        'collectionTime': 'Collection Time',
        'precipitation': 'Rainfall (in.)',
        'dilution': 'Dilution (mL / 100mL)',
        'totalColiform': 'Total Coliform (MPN / 100mL)',
        'totalEcoli': 'E. coli (MPN/100mL)',
        'fluorometry': 'Fluorometry',
        'turbidity': 'Turbidity (NTU)',
        'specificConductivity': 'Specific Conductivity (µS)',
        'analyst': 'Analyst',
        'notes': 'Notes'
      },
      jsonFieldsAdopt: {
        'aasSiteName': 'Site S-',
        'collectionDate': 'Event date (mm/dd/yyyy)',
        'collectionTime': 'Time sample collected (hh:mm)',
        'participation': 'Total # of particip',
        'samplingTime': 'Time spent sampling (minutes)',
        'monitor': 'Adopt-A-Stream monitors',
        'precipitation': 'Amount of rain (inches)',
        'hours': 'In last (hours)',
        'specificConductivity': 'Conductivity (µS/cm)',
        'turbidity': 'Turbidity (NTU)',
        'film': 'Other than Petri film?',
        'totalEcoli': 'E.coli IDEXX (MPN / 100mL)'
      },
      jsonFieldsStoret: {
        'projectID': 'Project ID',
        'stationName': 'Monitoring Location ID',
        'lField': 'L',
        'activityType': 'Activity Type',
        'water': 'Activity Media Name',
        'collectionDate': 'Activity Start Date',
        'collectionTime': 'Activity Start Time',
        'timeZone': 'Activity Start Time Zone',
        'activityMeasure': 'Activity Depth/Height Measure',
        'activityUnit': 'Activity Depth/Height Unit',
        'collectionMethod': 'Sample Collection Method ID',
        'equipment': 'Sample Collection Equipment Name',
        'equipComment': 'Sample Collection Equipment Comment',
        'loggerLine': 'Data Logger Line',
        'characteristic': 'Characteristic Name',
        'methodSpeciation': 'Method Speciation',
        'resultDetection': 'Result Detection Condition',
        'totalEcoli': 'Result Value',
        'resultUnit': 'Result Unit',
        'qualifier': 'Result Measure Qualifier',
        'resultSampleFraction': 'Result Sample Fraction',
        'resultStatus': 'Result Status ID',
        'baseCode': 'Statistical Base Code',
        'valueType': 'Result Value Type',
        'analyticalMethod': 'Result Analytical Method ID',
        'analyticalMethodContext': 'Result Analytical Method Context',
        'startDate': 'Analysis Start Date',
        'limitMeasure': 'Result Detection/Quantitation Limit Type',
        'limitUnit': 'Result Detection/Quantitation Limit Unit',
        'comments': 'Result Comment'
      },
      snackbar: {
        deleteVisible: false,
        successVisible: false,
        successMessage: 'Data logged successfully!',
        deleteSuccessMessage: 'Reports deleted successfully',
        timeout: 6000
      }
    };
  },
  methods: {
    toggleAll: function toggleAll() {
      if (this.selected.length) this.selected = [];else this.selected = this.reports.slice();
    },
    changeSort: function changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    filterByDate: function filterByDate() {
      this.$unbind('reports');
      this.$bindAsArray('reports', __WEBPACK_IMPORTED_MODULE_0__helpers_firebase__["a" /* db */].ref('reports/' + this.$route.params.siteId).orderByChild('collectionDate').startAt(this.startDate).endAt(this.endDate));
    },
    resetSelected: function resetSelected() {
      this.selected = [];
    },
    postSubmitForm: function postSubmitForm() {
      this.snackbar.successVisible = true;
      this.resetSelected();
    },
    deleteSelected: function deleteSelected() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(this.selected, function (item) {
        var key = item['.key'];
        _this.$firebaseRefs.reports.child(key).remove();
      });

      this.selected = [];
      this.snackbar.deleteVisible = true;
      this.controls.showDeleteDialog = false;
    },
    adpotExport: function adpotExport() {
      this.postToAPI('adopt_report', 'NWW_Adopt-A-Stream-Report.csv');
    },
    exportXls: function exportXls() {
      this.postToAPI('regular_report', 'NWW_Director_Report.csv');
    },
    storetExport: function storetExport() {
      this.postToAPI('storet_report', 'NWW_STORET_Report.csv');
    },
    postToAPI: function postToAPI(exportType, exportName) {
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: 'https://waterwatch-cb707.firebaseapp.com/export',
        method: 'POST',
        data: {
          'export_type': exportType,
          'start_date': this.startDate,
          'end_date': this.endDate,
          'collection_sites': [this.$route.params.siteId]
        }
      }).then(function (response) {
        var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = exportName;
        link.click();
      });
    }
  }
});

/***/ }),

/***/ 336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_firebase__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AddCollectionSite__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AddCollectionSite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AddCollectionSite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditCollectionSite__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditCollectionSite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__EditCollectionSite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_generateGeoJson__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);











var collectionSitesRef = __WEBPACK_IMPORTED_MODULE_1__helpers_firebase__["a" /* db */].ref('collectionSites');
var archivedRef = __WEBPACK_IMPORTED_MODULE_1__helpers_firebase__["a" /* db */].ref('archivedSites');
var metaRef = __WEBPACK_IMPORTED_MODULE_1__helpers_firebase__["a" /* db */].ref('metaData');
var todaysDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(new Date()).format('YYYY-MM-DD');
var oldDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(new Date()).subtract(1, 'weeks').format('YYYY-MM-DD');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'site-reports',
  components: {
    AddCollectionSite: __WEBPACK_IMPORTED_MODULE_2__AddCollectionSite___default.a,
    EditCollectionSite: __WEBPACK_IMPORTED_MODULE_3__EditCollectionSite___default.a
  },
  firebase: function firebase() {
    return {
      collectionSites: collectionSitesRef.orderByChild('stationName'),
      metaData: metaRef
    };
  },

  data: function data() {
    return {
      startDate: oldDate,
      endDate: todaysDate,
      showArchived: false,
      pagination: {
        sortBy: 'stationName',
        descending: false,
        totalItems: 0,
        loading: true
      },
      controls: {
        search: '',
        startDateModal: false,
        endDateModal: false
      },
      headers: [{ text: 'Station Name', value: 'stationName' }, { text: 'Logbook abv', value: 'logbookAbbv' }, { text: 'Lab', value: 'lab' }, { text: 'Last Collection Date', value: 'lastCollectionDate' }, { text: 'Last E. coli Result', value: 'lastEColi' }, { text: 'Collection Partner', value: 'collectionPartner' }, { text: 'Subwatershed (HUC12)', value: 'hucName' }, { text: 'Adopt-A-Stream Name', value: 'adoptAStreamName' }, { text: 'Adopt-A-Stream Number', value: 'aasNumber' }, { text: 'STORET Name', value: 'storetName' }, { text: 'STORET Location ID', value: 'storetId' }, { text: '# Samples Collected', value: 'numSamples' }, { text: 'First Collection Date', value: 'firstCollectionDate' }, { text: 'Google Maps URL', value: 'googleMapsUrl' }, { text: 'Latitude', value: 'latitude' }, { text: 'Longitude', value: 'longitude' }, { text: 'Is Private', value: 'isPrivate' }],
      selected: [],
      snackbar: {
        successVisible: false,
        successMessage: 'Collection Site saved successfully!',
        timeout: 6000
      }
    };
  },
  methods: {
    postSubmitForm: function postSubmitForm() {
      this.snackbar.successVisible = true;
      this.selected = [];
    },
    toggleAll: function toggleAll() {
      if (this.selected.length) {
        this.selected = [];
      } else {
        this.selected = this.collectionSites.slice();
      }
    },
    changeSort: function changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    archiveSite: function archiveSite(item) {
      this.$bindAsArray('setArchivedSites', archivedRef);
      this.$bindAsArray('setCollectionSites', collectionSitesRef);

      var itemCopy = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item);
      delete itemCopy['.key'];
      itemCopy.archived = true;
      this.$firebaseRefs.setArchivedSites.child(item['.key']).set(itemCopy);
      this.$firebaseRefs.setCollectionSites.child(item['.key']).remove();

      this.selected = [];
      this.uploadNewJsonFile();

      this.$unbind('setArchivedSites');
      this.$unbind('setCollectionSites');
    },
    unArchiveSite: function unArchiveSite(item) {
      this.$bindAsArray('setArchivedSites', archivedRef);
      this.$bindAsArray('setCollectionSites', collectionSitesRef);

      var itemCopy = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item);
      delete itemCopy['.key'];
      itemCopy.archived = false;
      this.$firebaseRefs.setCollectionSites.child(item['.key']).set(itemCopy);
      this.$firebaseRefs.setArchivedSites.child(item['.key']).remove();

      this.selected = [];
      this.uploadNewJsonFile();

      this.$unbind('setArchivedSites');
      this.$unbind('setCollectionSites');
    },
    uploadNewJsonFile: function uploadNewJsonFile() {
      var _this = this;

      this.$bindAsArray('jsonSites', collectionSitesRef, null, function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers_generateGeoJson__["a" /* uploadNewGeoJsonFile */])(_this.jsonSites);
      });
    },
    toggleArchived: function toggleArchived() {
      this.showArchived = !this.showArchived;
      this.selected = [];

      if (this.showArchived) {
        this.$unbind('collectionSites');
        this.$bindAsArray('collectionSites', archivedRef.orderByChild('lastCollectionDate'));
      } else if (!this.showArchived) {
        this.$unbind('collectionSites');
        this.$bindAsArray('collectionSites', collectionSitesRef.orderByChild('lastCollectionDate'));
      }
    },
    archivedText: function archivedText() {
      return this.showArchived ? 'Hide Archived' : 'View Archived';
    },
    adpotExport: function adpotExport() {
      this.postToAPI('adopt_report', 'NWW_Adopt-A-Stream-Report.csv');
    },
    exportXls: function exportXls() {
      this.postToAPI('regular_report', 'NWW_Director_Report.csv');
    },
    storetExport: function storetExport() {
      this.postToAPI('storet_report', 'NWW_STORET_Report.csv');
    },
    getCollectionSitesArray: function getCollectionSitesArray(selected) {
      return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(selected, function (collectionSite) {
        return collectionSite['.key'];
      });
    },
    postToAPI: function postToAPI(exportType, exportName) {
      var csIdArray = this.getCollectionSitesArray(this.selected);
      __WEBPACK_IMPORTED_MODULE_7_axios___default()({
        url: 'https://waterwatch-cb707.firebaseapp.com/export',
        method: 'POST',
        data: {
          'export_type': exportType,
          'start_date': this.startDate,
          'end_date': this.endDate,
          'collection_sites': csIdArray
        }
      }).then(function (response) {
        var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = exportName;
        link.click();
      });
    }
  }
});

/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_firebase__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_generateGeoJson__ = __webpack_require__(55);







var collectionSitesRef = __WEBPACK_IMPORTED_MODULE_1__helpers_firebase__["a" /* db */].ref('collectionSites');
var labsRef = __WEBPACK_IMPORTED_MODULE_1__helpers_firebase__["a" /* db */].ref('labs');
var partnersRef = __WEBPACK_IMPORTED_MODULE_1__helpers_firebase__["a" /* db */].ref('partners');
var metaRef = __WEBPACK_IMPORTED_MODULE_1__helpers_firebase__["a" /* db */].ref('metaData');
var hucRef = __WEBPACK_IMPORTED_MODULE_1__helpers_firebase__["a" /* db */].ref('hucList');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'edit-collection-site',
  props: ['collectionSite', 'postSubmitForm'],
  beforeMount: function beforeMount() {
    this.targetCollectionSite = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(this.collectionSite);
    this.$bindAsArray('reports', __WEBPACK_IMPORTED_MODULE_1__helpers_firebase__["a" /* db */].ref('reports/' + this.collectionSite['.key']));
  },

  firebase: {
    collectionSites: collectionSitesRef,
    labs: labsRef,
    partners: partnersRef,
    metaData: metaRef,
    hucList: hucRef
  },
  watch: {
    labs: {
      handler: function handler() {
        this.labSet = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(this.labs, '.value');
      }
    },
    partners: {
      handler: function handler() {
        this.partnerSet = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(this.partners, '.value');
      }
    },
    hucList: {
      handler: function handler() {
        this.hucSet = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(this.hucList, '.value');
      }
    }
  },
  data: function data() {
    return {
      targetCollectionSite: {},
      labs: [],
      labSet: [],
      hucList: [],
      hucSet: [],
      partners: [],
      partnerSet: [],
      controls: {
        showDialog: false
      },
      snackbar: {
        errorVisible: false,
        errorMessage: 'There was an issue saving your Collection Site',
        timeout: 6000
      }
    };
  },

  methods: {
    submitForm: function submitForm() {
      try {
        var itemCopy = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.targetCollectionSite);
        delete itemCopy['.key'];
        this.$firebaseRefs.collectionSites.child(this.targetCollectionSite['.key']).set(itemCopy);

        this.applyUpdatesToReports(this.targetCollectionSite);

        this.uploadNewJsonFile();

        this.controls.showDialog = false;
        this.postSubmitForm();
      } catch (e) {
        console.log(e);
        this.snackbar.errorVisible = true;
      }
    },
    close: function close() {
      this.controls.showDialog = false;
    },
    applyUpdatesToReports: function applyUpdatesToReports(targetCollectionSite) {
      var _this = this;

      console.log(targetCollectionSite);
      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(this.reports, function (item) {
        var itemCopy = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item);
        delete itemCopy['.key'];
        itemCopy.stationName = targetCollectionSite.stationName;
        itemCopy.aasNumber = targetCollectionSite.aasNumber || '';
        itemCopy.storetId = targetCollectionSite.storetId || '';
        itemCopy.logbookAbbv = targetCollectionSite.logbookAbbv;

        console.log(itemCopy);
        _this.$firebaseRefs.reports.child(item['.key']).set(itemCopy);
        __WEBPACK_IMPORTED_MODULE_1__helpers_firebase__["a" /* db */].ref('allReports/' + item['.key']).set(itemCopy);
      });
    },
    uploadNewJsonFile: function uploadNewJsonFile() {
      var _this2 = this;

      this.$bindAsArray('jsonSites', collectionSitesRef, null, function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_generateGeoJson__["a" /* uploadNewGeoJsonFile */])(_this2.jsonSites);
      });
    }
  }
});

/***/ }),

/***/ 338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_firebase__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_coeffecient__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_MathService__ = __webpack_require__(105);










var collectionSitesRef = __WEBPACK_IMPORTED_MODULE_2__helpers_firebase__["a" /* db */].ref('collectionSites');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'edit-log-data',
  props: ['tableLogData', 'routeCollectionSiteId', 'resetSelected', 'postSubmitForm'],
  firebase: {
    collectionSites: collectionSitesRef.orderByChild('stationName')
  },
  watch: {
    collectionSites: {
      handler: function handler(newSites) {
        var _this = this;

        this.selectedSite = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(newSites, function (obj) {
          return obj['.key'] === _this.routeCollectionSiteId;
        }, this.routeCollectionSiteId);
      }
    },
    selectedSite: {
      handler: function handler(newSite) {
        if (newSite) {
          if (this.$firebaseRefs.reports) {
            this.$unbind('reports');
          }
          this.$bindAsArray('reports', __WEBPACK_IMPORTED_MODULE_2__helpers_firebase__["a" /* db */].ref('reports/' + newSite['.key']));
        }
      }
    }
  },
  beforeMount: function beforeMount() {
    this.targetLogData = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(this.tableLogData);
  },
  mounted: function mounted() {
    this.ecoliLargeCells = this.targetLogData.ecoliLargeCells;
    this.ecoliSmallCells = this.targetLogData.ecoliSmallCells;
  },

  computed: {
    getTotalColiform: function getTotalColiform() {
      try {
        if (this.targetLogData.coliformLargeCells && this.targetLogData.coliformSmallCells && this.targetLogData.dilution) {
          var matrixValue = __WEBPACK_IMPORTED_MODULE_5__helpers_coeffecient__["a" /* matrix */][this.targetLogData.coliformLargeCells][this.targetLogData.coliformSmallCells];
          var dilutionFactor = this.targetLogData.dilution === 0 ? 0 : 100 / this.targetLogData.dilution;
          var computedValue = matrixValue * dilutionFactor;
          var roundedValue = Math.max(Math.round(computedValue * 10) / 10).toFixed(1);

          if (this.targetLogData.coliformLargeCells === '0' && this.targetLogData.coliformSmallCells === '0') {
            return roundedValue;
          } else if (this.targetLogData.coliformLargeCells === '49' && this.targetLogData.coliformSmallCells === '48') {
            return roundedValue;
          }

          return roundedValue;
        }
      } catch (e) {
        return 0;
      }
    },
    getTotalEcoli: function getTotalEcoli() {
      try {
        if (this.ecoliLargeCells && this.ecoliSmallCells && this.targetLogData.dilution) {
          var matrixValue = __WEBPACK_IMPORTED_MODULE_5__helpers_coeffecient__["a" /* matrix */][this.ecoliLargeCells][this.ecoliSmallCells];
          var dilutionFactor = this.targetLogData.dilution === 0 ? 0 : 100 / this.targetLogData.dilution;
          var computedValue = matrixValue * dilutionFactor;
          var roundedValue = Math.max(Math.round(computedValue * 10) / 10).toFixed(1);

          if (this.ecoliLargeCells === '0' && this.ecoliSmallCells === '0') {
            return roundedValue;
          } else if (this.ecoliLargeCells === '49' && this.ecoliSmallCells === '48') {
            return roundedValue;
          }

          return roundedValue;
        }
      } catch (e) {
        return 0;
      }
    }
  },
  data: function data() {
    var _this2 = this;

    return {
      targetLogData: {},
      collectionSites: [],
      selectedSite: null,
      formValid: false,
      ecoliLargeCells: null,
      ecoliSmallCells: null,
      controls: {
        showAdditionalParams: false,
        showConfirmDialog: false,
        showDatepicker: false,
        showDialog: false,
        incubationInMenu: false,
        incubationOutMenu: false
      },
      formRules: {
        conductivityRules: [function (input) {
          var conductivity = parseFloat(input);
          if (isNaN(conductivity)) {
            return true;
          }
          return typeof conductivity === 'number' && conductivity >= 0 || 'Conductivity must be greater than or equal to 0';
        }],
        dilutionRules: [function (input) {
          var dilution = parseFloat(input);
          if (isNaN(dilution)) {
            return true;
          }
          return typeof dilution === 'number' && dilution >= 0.25 && dilution <= 100 || 'Dilution must be between 0.25-100';
        }],
        fluorometryRules: [function (input) {
          var fluorometry = parseFloat(input);
          if (isNaN(fluorometry)) {
            return true;
          }
          if (__WEBPACK_IMPORTED_MODULE_6__services_MathService__["a" /* default */].decimalPlaces(fluorometry)) {
            return 'Please limit to 3 decimal places';
          }
          return fluorometry >= 0 && fluorometry <= 200 || 'Typical range is 0 - 200';
        }],
        incubationTempRules: [function (input) {
          var temp = parseFloat(input);
          if (isNaN(temp)) {
            return true;
          }
          return temp >= 34.5 && temp <= 35.5 || 'Required Temp is 35°C +/- 0.5';
        }],
        incubationTimeRules: [function (startTime) {
          if (!_this2.targetLogData) {
            return true;
          }
          if (startTime === null || startTime === undefined || /^\s*$/.test(startTime)) {
            return true;
          }
          var startDate = dateObj(startTime);
          var testStartDate = dateObj(_this2.targetLogData.collectionTime);
          var testEndDate = dateObj(_this2.targetLogData.collectionTime).add(8, 'hours');

          function dateObj(d) {
            var date = __WEBPACK_IMPORTED_MODULE_4_moment___default()();
            var parts = d.split(/:|\s/);
            date.hour(+parts.shift());
            date.minutes(+parts.shift());
            return date;
          }

          return startDate.isBetween(testStartDate, testEndDate) || 'Should be within 6 hours of Collection Time';
        }],
        incubationOutTimeRules: [function (outTime) {
          if (!_this2.targetLogData) {
            return true;
          }
          if (outTime === null || outTime === undefined || /^\s*$/.test(outTime)) {
            return true;
          }

          var startDate = dateObj(_this2.targetLogData.incubationTime);

          var endDateMin = startDate.clone().add(18, 'hours');
          var endDateMax = startDate.clone().add(22, 'hours');
          var outMoment = dateObj(outTime).date(endDateMax.date()).month(endDateMax.month()).year(endDateMax.year());

          function dateObj(d) {
            var date = __WEBPACK_IMPORTED_MODULE_4_moment___default()();
            var parts = d.split(/:|\s/);
            date.hour(+parts.shift());
            date.minutes(+parts.shift());
            return date;
          }

          return outMoment.isBetween(endDateMin, endDateMax) || 'Should be within 18 to 22 hours of Incubation In';
        }],
        noNegatives: [function (v) {
          var value = parseFloat(v);
          if (isNaN(value)) {
            return true;
          }
          return value >= 0 || 'Should be greater than 0 (Leave empty if not recorded)';
        }],
        largeCellsRules: [function (v) {
          var value = parseFloat(v);
          if (isNaN(value)) {
            return true;
          }
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(value) && value >= 0 && value <= 49 || 'Should be between 0-49 (Leave empty if not recorded)';
        }],
        required: [function (v) {
          return v !== '' || 'Value is required';
        }],
        smallCellsRules: [function (v) {
          var value = parseFloat(v);
          if (isNaN(value)) {
            return true;
          }
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(value) && value >= 0 && value <= 48 || 'Should be between 0-48 (Leave empty if not recorded)';
        }],
        turbidityRules: [function (input) {
          var turbidity = parseFloat(input);
          if (isNaN(turbidity)) {
            return true;
          }
          return turbidity >= 0 && turbidity <= 1500 || 'Typical range is 0 - 1500';
        }],
        precipitation: [function (v) {
          var value = parseFloat(v);
          if (isNaN(value)) {
            return true;
          }
          return value >= 0 || 'Should be greater than or equal to 0 (Leave empty if not recorded)';
        }]
      },
      snackbar: {
        errorVisible: false,
        successVisible: false,
        successMessage: 'Data logged successfully!',
        errorMessage: 'There was an issue logging your data',
        timeout: 6000
      }
    };
  },
  methods: {
    close: function close() {
      this.resetSelected();
      this.controls.showDialog = false;
    },

    toggleAdditionalParmas: function toggleAdditionalParmas() {
      this.controls.showAdditionalParams = !this.controls.showAdditionalParams;
    },
    submitLog: function submitLog() {
      if (this.$refs.form.validate()) {
        this.updateExistingLog();
      } else {
        this.controls.showConfirmDialog = false;
        this.snackbar.errorVisible = true;
      }
    },
    updateExistingLog: function updateExistingLog() {
      var _this3 = this;

      try {
        this.$bindAsObject('firebaseLogObject', __WEBPACK_IMPORTED_MODULE_2__helpers_firebase__["a" /* db */].ref('reports/' + this.routeCollectionSiteId + '/' + this.targetLogData['.key']));
        this.$bindAsObject('allReportsLogObject', __WEBPACK_IMPORTED_MODULE_2__helpers_firebase__["a" /* db */].ref('allReports/' + this.targetLogData['.key']));

        if (this.ecoliLargeCells) {
          this.targetLogData.ecoliLargeCells = this.ecoliLargeCells;
        }
        if (this.ecoliSmallCells) {
          this.targetLogData.ecoliSmallCells = this.ecoliSmallCells;
        }
        if (this.getTotalEcoli !== undefined) {
          this.targetLogData.totalEcoli = this.getTotalEcoli;
        }
        if (this.getTotalColiform !== undefined) {
          this.targetLogData.totalColiform = this.getTotalColiform;
        }
        this.targetLogData.collectionSite = null;

        var itemCopy = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.targetLogData);
        delete itemCopy['.key'];

        if (this.tableLogData.collectionSite !== this.selectedSite['.key']) {
          var _itemCopy = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.targetLogData);
          delete _itemCopy['.key'];
          _itemCopy.stationName = this.selectedSite.stationName;
          _itemCopy.aasNumber = this.selectedSite.aasNumber || '';
          _itemCopy.storetId = this.selectedSite.storetId || '';
          _itemCopy.logbookAbbv = this.selectedSite.logbookAbbv;
          _itemCopy.collectionSiteId = this.selectedSite['.key'];

          this.$firebaseRefs.reports.push(_itemCopy).on('value', function () {
            _this3.$firebaseRefs.firebaseLogObject.remove();
          });
        } else {
          this.$firebaseRefs.firebaseLogObject.set(itemCopy);
        }

        this.$firebaseRefs.allReportsLogObject.set(itemCopy);
        this.$unbind('firebaseLogObject');
        this.$unbind('allReportsLogObject');

        this.controls.showDialog = false;
        this.postSubmitForm();
      } catch (e) {
        console.log(e);
        this.snackbar.errorVisible = true;
        this.controls.showConfirmDialog = false;
      }
    },
    updateCollectionSite: function updateCollectionSite(collDate, key) {
      var newNumberSamples = this.selectedSite.numSamples ? this.selectedSite.numSamples + 1 : 1;
      this.$firebaseRefs.collectionSites.child(key).child('numSamples').set(newNumberSamples);

      this.$firebaseRefs.collectionSites.child(key).child('lastCollectionDate').set(collDate);

      if (this.getTotalEcoli) {
        this.$firebaseRefs.collectionSites.child(key).child('lastEColiResult').set(this.getTotalEcoli);
      }

      if (this.targetLogData.turbidity) {
        this.$firebaseRefs.collectionSites.child(key).child('lastTurbidityResult').set(this.targetLogData.turbidity);
      }

      if (this.targetLogData.precipitation) {
        this.$firebaseRefs.collectionSites.child(key).child('lastRainfallResult').set(this.targetLogData.precipitation);
      }

      if (this.targetLogData.specificConductivity) {
        this.$firebaseRefs.collectionSites.child(key).child('lastConductivityResult').set(this.targetLogData.specificConductivity);
      }
    }
  }
});

/***/ }),

/***/ 339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_firebase__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_coeffecient__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_MathService__ = __webpack_require__(105);










var collectionSitesRef = __WEBPACK_IMPORTED_MODULE_2__helpers_firebase__["a" /* db */].ref('collectionSites');
var logbookNumberRef = __WEBPACK_IMPORTED_MODULE_2__helpers_firebase__["a" /* db */].ref('metaData/logbookNumber');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'log-data',
  firebase: {
    collectionSites: collectionSitesRef.orderByChild('stationName'),
    logbookNumber: logbookNumberRef
  },
  watch: {
    logbookNumber: {
      deep: true,
      handler: function handler() {
        this.setLogbookNumber();
      }
    },
    selectedSite: {
      handler: function handler(newSite) {
        if (newSite) {
          if (this.$firebaseRefs.reports) {
            this.$unbind('reports');
          }
          this.$bindAsArray('reports', __WEBPACK_IMPORTED_MODULE_2__helpers_firebase__["a" /* db */].ref('reports/' + newSite['.key']));
        }
      }
    },
    collectionSites: {
      handler: function handler() {
        if (this.collectionSites.length !== 0 && this.$route.params.id && !this.controls.initialSiteSet) {
          this.selectedSite = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.collectionSites, ['.key', this.$route.params.id]);
          this.controls.initialSiteSet = true;
        }
      }
    }
  },
  mounted: function mounted() {
    this.setLogbookNumber();
  },

  computed: {
    getTotalColiform: function getTotalColiform() {
      try {
        if (this.newLogData.coliformLargeCells && this.newLogData.coliformSmallCells && this.newLogData.dilution) {
          var matrixValue = __WEBPACK_IMPORTED_MODULE_5__helpers_coeffecient__["a" /* matrix */][this.newLogData.coliformLargeCells][this.newLogData.coliformSmallCells];
          var dilutionFactor = this.newLogData.dilution === 0 ? 0 : 100 / this.newLogData.dilution;
          var computedValue = matrixValue * dilutionFactor;
          var roundedValue = Math.max(Math.round(computedValue * 10) / 10).toFixed(1);

          if (this.newLogData.coliformLargeCells === '0' && this.newLogData.coliformSmallCells === '0') {
            return roundedValue;
          } else if (this.newLogData.coliformLargeCells === '49' && this.newLogData.coliformSmallCells === '48') {
            return roundedValue;
          }

          return roundedValue;
        }
      } catch (e) {
        return 0;
      }
    },
    getTotalEcoli: function getTotalEcoli() {
      try {
        if (this.ecoliLargeCells && this.ecoliSmallCells && this.newLogData.dilution) {
          var matrixValue = __WEBPACK_IMPORTED_MODULE_5__helpers_coeffecient__["a" /* matrix */][this.ecoliLargeCells][this.ecoliSmallCells];
          var dilutionFactor = this.newLogData.dilution === 0 ? 0 : 100 / this.newLogData.dilution;
          var computedValue = matrixValue * dilutionFactor;
          var roundedValue = Math.max(Math.round(computedValue * 10) / 10).toFixed(1);
          if (this.ecoliLargeCells === '0' && this.ecoliSmallCells === '0') {
            return roundedValue;
          } else if (this.ecoliLargeCells === '49' && this.ecoliSmallCells === '48') {
            return roundedValue;
          }

          return roundedValue;
        }
      } catch (e) {
        return 0;
      }
    }
  },
  data: function data() {
    var _this = this;

    return {
      testData: null,
      collectionSites: [],
      selectedSite: null,
      logbookNumber: null,
      formValid: false,
      ecoliLargeCells: null,
      ecoliSmallCells: null,
      controls: {
        showAdditionalParams: false,
        showDialog: false,
        showDatepicker: false,
        initialSiteSet: false,
        incubationInMenu: false,
        incubationOutMenu: false
      },
      formRules: {
        conductivityRules: [function (input) {
          var conductivity = parseFloat(input);
          if (isNaN(conductivity)) {
            return true;
          }
          return typeof conductivity === 'number' && conductivity >= 0 || 'Conductivity must be greater than or equal to 0';
        }],
        dilutionRules: [function (input) {
          var dilution = parseFloat(input);
          if (isNaN(dilution)) {
            return true;
          }
          return typeof dilution === 'number' && dilution >= 0.25 && dilution <= 100 || 'Dilution must be between 0.25-100';
        }],
        fluorometryRules: [function (input) {
          var fluorometry = parseFloat(input);
          if (isNaN(fluorometry)) {
            return true;
          }
          if (__WEBPACK_IMPORTED_MODULE_6__services_MathService__["a" /* default */].decimalPlaces(fluorometry)) {
            return 'Please limit to 3 decimal places';
          }
          return fluorometry >= 0 && fluorometry <= 200 || 'Typical range is 0 - 200';
        }],
        incubationTempRules: [function (input) {
          var temp = parseFloat(input);
          if (isNaN(temp)) {
            return true;
          }
          return temp >= 34.5 && temp <= 35.5 || 'Required Temp is 35°C +/- 0.5';
        }],
        incubationTimeRules: [function (startTime) {
          if (startTime === null || startTime === undefined || /^\s*$/.test(startTime)) {
            return true;
          }
          var startDate = dateObj(startTime);
          var testStartDate = dateObj(_this.newLogData.collectionTime);
          var testEndDate = dateObj(_this.newLogData.collectionTime).add(8, 'hours');

          function dateObj(d) {
            var date = __WEBPACK_IMPORTED_MODULE_4_moment___default()();
            var parts = d.split(/:|\s/);
            date.hour(+parts.shift());
            date.minutes(+parts.shift());
            return date;
          }

          return startDate.isBetween(testStartDate, testEndDate) || 'Should be within 6 hours of Collection Time';
        }],
        incubationOutTimeRules: [function (outTime) {
          if (outTime === null || outTime === undefined || /^\s*$/.test(outTime)) {
            return true;
          }

          var startDate = dateObj(_this.newLogData.incubationTime);

          var endDateMin = startDate.clone().add(18, 'hours');
          var endDateMax = startDate.clone().add(22, 'hours');
          var outMoment = dateObj(outTime).date(endDateMax.date()).month(endDateMax.month()).year(endDateMax.year());

          function dateObj(d) {
            var date = __WEBPACK_IMPORTED_MODULE_4_moment___default()();
            var parts = d.split(/:|\s/);
            date.hour(+parts.shift());
            date.minutes(+parts.shift());
            return date;
          }

          return outMoment.isBetween(endDateMin, endDateMax) || 'Should be within 18 to 22 hours of Incubation In';
        }],
        noNegatives: [function (v) {
          var value = parseFloat(v);
          if (isNaN(value)) {
            return true;
          }
          return value >= 0 || 'Should be greater than 0 (Leave empty if not recorded)';
        }],
        largeCellsRules: [function (v) {
          var value = parseFloat(v);
          if (isNaN(value)) {
            return true;
          }
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(value) && value >= 0 && value <= 49 || 'Should be between 0-49 (Leave empty if not recorded)';
        }],
        required: [function (v) {
          return v !== '' || 'Value is required';
        }],
        smallCellsRules: [function (v) {
          var value = parseFloat(v);
          if (isNaN(value)) {
            return true;
          }
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(value) && value >= 0 && value <= 48 || 'Should be between 0-48 (Leave empty if not recorded)';
        }],
        turbidityRules: [function (input) {
          var turbidity = parseFloat(input);
          if (isNaN(turbidity)) {
            return true;
          }
          return turbidity >= 0 && turbidity <= 1500 || 'Typical range is 0 - 1500';
        }],
        precipitation: [function (v) {
          var value = parseFloat(v);
          if (isNaN(value)) {
            return true;
          }
          return value >= 0 || 'Should be greater than or equal to 0 (Leave empty if not recorded)';
        }]
      },
      newLogData: {
        airTemp: null,
        ammonium: null,
        analyst: '',
        chlorophyll: null,
        coliformLargeCells: '',
        coliformSmallCells: '',
        collectionDate: __WEBPACK_IMPORTED_MODULE_4_moment___default()(new Date().toISOString()).format('YYYY-MM-DD'),
        collectionSite: null,
        collectionTime: '',
        dilution: null,
        dissolvedOxygen: null,
        ecoliLargeCells: null,
        ecoliSmallCells: null,
        fluorometry: null,
        incubationOut: null,
        incubationTemp: null,
        incubationTime: null,
        logbookNumber: 1,
        nitrate: null,
        phosphate: null,
        precipitation: null,
        secchiDepth: null,
        specificConductivity: null,
        turbidity: null,
        totalChlorine: null,
        notes: '',
        waterTemp: null
      },
      snackbar: {
        errorVisible: false,
        successVisible: false,
        successMessage: 'Data logged successfully!',
        errorMessage: 'There was an issue logging your data',
        timeout: 6000
      }
    };
  },
  methods: {
    toggleAdditionalParmas: function toggleAdditionalParmas() {
      this.controls.showAdditionalParams = !this.controls.showAdditionalParams;
    },
    submitLog: function submitLog() {
      if (this.$refs.form.validate()) {
        this.saveNewLog();
      } else {
        this.controls.showDialog = false;
        this.snackbar.errorVisible = true;
      }
    },

    saveNewLog: function saveNewLog() {
      try {
        var collDate = this.newLogData.collectionDate;
        var key = this.selectedSite['.key'];

        this.newLogData.stationName = this.selectedSite.stationName;
        this.newLogData.aasNumber = this.selectedSite.aasNumber || '';
        this.newLogData.adoptAStreamName = this.selectedSite.adoptAStreamName || '';
        this.newLogData.storetId = this.selectedSite.storetId || '';
        this.newLogData.logbookAbbv = this.selectedSite.logbookAbbv;
        this.newLogData.ecoliLargeCells = this.ecoliLargeCells;
        this.newLogData.ecoliSmallCells = this.ecoliSmallCells;
        this.newLogData.totalEcoli = this.getTotalEcoli ? this.getTotalEcoli : null;
        this.newLogData.totalColiform = this.getTotalColiform ? this.getTotalColiform : null;
        this.newLogData.collectionSiteId = key;
        this.newLogData.collectionDate = collDate;
        this.newLogData.collectionSite = null;

        this.updateCollectionSite(collDate, key);

        this.$firebaseRefs.reports.push(this.newLogData).on('value', function (snap) {
          var snapcopy = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, snap.val());
          var key = snap.key;
          __WEBPACK_IMPORTED_MODULE_2__helpers_firebase__["a" /* db */].ref('allReports/' + key).set(snapcopy);
        });

        this.incrementLogbookNumber(this.newLogData.logbookNumber);

        this.snackbar.successVisible = true;
        this.controls.showDialog = false;

        this.resetForm();
      } catch (e) {
        console.log(e);
        this.snackbar.errorVisible = true;
        this.controls.showDialog = false;
      }
    },
    resetForm: function resetForm() {
      var oldLog = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.newLogData);
      this.ecoliLargeCells = null;
      this.ecoliSmallCells = null;

      this.newLogData = {
        airTemp: null,
        ammonium: null,
        analyst: oldLog.analyst,
        chlorophyll: null,
        coliformLargeCells: '',
        coliformSmallCells: '',
        collectionDate: oldLog.collectionDate,
        collectionSite: null,
        collectionTime: '',
        dilution: null,
        dissolvedOxygen: null,
        ecoliLargeCells: null,
        ecoliSmallCells: null,
        fluorometry: null,
        incubationOut: '',
        incubationTemp: oldLog.incubationTemp,
        incubationTime: '',
        logbookNumber: 0,
        nitrate: null,
        phosphate: null,
        precipitation: oldLog.precipitation,
        secchiDepth: null,
        specificConductivity: null,
        turbidity: null,
        totalChlorine: null,
        notes: '',
        waterTemp: null
      };

      this.setLogbookNumber();
    },
    setLogbookNumber: function setLogbookNumber(logbookObject) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(this.logbookNumber, function (currentLogbookNumber) {
        _this2.newLogData.logbookNumber = currentLogbookNumber['.value'] + 1;
      });
    },
    updateCollectionSite: function updateCollectionSite(collDate, key) {
      var newNumberSamples = this.selectedSite.numSamples ? this.selectedSite.numSamples + 1 : 1;
      this.$firebaseRefs.collectionSites.child(key).child('numSamples').set(newNumberSamples);

      this.$firebaseRefs.collectionSites.child(key).child('lastCollectionDate').set(collDate);

      if (this.getTotalEcoli) {
        this.$firebaseRefs.collectionSites.child(key).child('lastEColiResult').set(this.getTotalEcoli);
      }

      if (this.newLogData.turbidity) {
        this.$firebaseRefs.collectionSites.child(key).child('lastTurbidityResult').set(this.newLogData.turbidity);
      }

      if (this.newLogData.precipitation) {
        this.$firebaseRefs.collectionSites.child(key).child('lastRainfallResult').set(this.newLogData.precipitation);
      }

      if (this.newLogData.specificConductivity) {
        this.$firebaseRefs.collectionSites.child(key).child('lastConductivityResult').set(this.newLogData.specificConductivity);
      }

      if (!this.selectedSite.firstCollectionDate) {
        this.$firebaseRefs.collectionSites.child(key).child('firstCollectionDate').set(collDate);
      }
    },
    incrementLogbookNumber: function incrementLogbookNumber(newLogbookNum) {
      this.$firebaseRefs.logbookNumber.child('currentLogbookNumber').set(newLogbookNum);
    }
  }
});

/***/ }),

/***/ 340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-footer'
});

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(41);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-nav',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])(['user'])),
  data: function data() {
    return {
      controls: {
        sidebarOpen: false
      },
      arrNav: [{
        title: 'Log Data',
        id: '1',
        auth: true,
        path: '/logData',
        icon: 'format_align_left'
      }, {
        title: 'Collection Sites',
        id: '2',
        auth: true,
        path: '/collectionSites',
        icon: 'location_on'
      }, {
        title: 'Data',
        id: '3',
        auth: false,
        path: '/dataPage',
        icon: 'data_usage'
      }, {
        title: 'About',
        id: '4',
        auth: false,
        path: '/about',
        icon: 'info_about'
      }]
    };
  },

  methods: {
    logout: function logout() {
      __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().signOut().then(function () {
        window.location.href = '/*';
      }, function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'json-excel',
  data: function data() {
    return {
      animate: true,
      animation: ''
    };
  },
  props: {
    'type': {
      type: String,
      default: "xls"
    },
    'button_text': {
      type: String,
      default: "Download Excel"
    },
    'data': {
      type: Array,
      required: true
    },
    'fields': {
      type: Object,
      required: true
    },
    'name': {
      type: String,
      default: "data.xls"
    },
    'meta': {
      type: Array,
      default: []
    }
  },
  computed: {
    id_name: function id_name() {
      var now = new Date().getTime();
      return 'export_' + now;
    }
  },
  methods: {
    generate: function generate() {
      if (this.type == 'csv') {
        return this.exportCSV(this.data, this.name, this.fields);
      }
      return this.exportXLS(this.data, this.name, this.fields);
    },

    generate_excel: function generate_excel() {
      this.exportXLS(this.data, this.name, this.fields);
    },
    jsonToXLS: function jsonToXLS(data, header) {
      var xlsTemp = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta name=ProgId content=Excel.Sheet> <meta name=Generator content="Microsoft Excel 11"><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>${table}</table></body></html>';

      var xlsData = '',
          keys = [];
      if (header) {
        xlsData += '<thead>';
        for (var key in header) {
          keys.push(key);
          xlsData += '<th>' + header[key] + '</th>';
        }
        xlsData += '</thead>';
        xlsData += '<tbody>';
        data.map(function (item, index) {
          xlsData += '<tr>';
          for (var i = 0; i < keys.length; i++) {
            if (keys[i].indexOf(".") !== -1) {
              var keyNestedSplit = keys[i].split(".");
              var valueFromNestedKey = item[keyNestedSplit[0]];

              for (var j = 1; j < keyNestedSplit.length; j++) {
                valueFromNestedKey = valueFromNestedKey[keyNestedSplit[j]];
              }

              xlsData += '<td>' + valueFromNestedKey + '</td>';
            } else {
              xlsData += '<td>' + item[keys[i]] + '</td>';
            }
          }
          xlsData += '</tr>';
        });
        xlsData += '</tbody>';
        return xlsTemp.replace('${table}', xlsData);
      }
      data.map(function (item, index) {
        xlsData += '<tbody><tr>';
        for (var key in item) {
          xlsData += '<td>' + item[key] + '</td>';
        }
        xlsData += '</tr></tbody>';
      });
      return xlsTemp.replace('${table}', xlsData);
    },
    jsonToCSV: function jsonToCSV(data, header) {
      var csvData = '';

      if (header) {
        for (var key in header) {
          csvData += header[key] + ',';
        }
        csvData = csvData.slice(0, csvData.length - 1);
        csvData += '\r\n';
      }
      data.map(function (item) {
        for (var k in item) {
          csvData += item[k] + ',';
        }
        csvData = csvData.slice(0, csvData.length - 1);
        csvData += '\r\n';
      });
      return csvData;
    },
    base64: function base64(s) {
      return window.btoa(window.unescape(encodeURIComponent(s)));
    },
    exportXLS: function exportXLS(data, fileName, header) {
      var XLSData = 'data:application/vnd.ms-excel;base64,' + this.base64(this.jsonToXLS(data, header));
      this.download(XLSData, fileName);
    },
    exportCSV: function exportCSV(data, fileName, keys) {
      var CSVData = 'data:application/csv;base64,' + this.base64(this.jsonToCSV(data, keys));
      this.download(CSVData, fileName);
    },
    base64ToBlob: function base64ToBlob(base64Data) {
      var arr = base64Data.split(',');
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8ClampedArray(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    download: function download(base64data, fileName) {
      if (window.navigator.msSaveBlob) {
        var blob = this.base64ToBlob(base64data);
        window.navigator.msSaveBlob(blob, filename);
        return false;
      }

      var a = document.getElementById(this.id_name);

      if (window.URL.createObjectURL) {
        var blob = this.base64ToBlob(base64data);
        var blobUrl = window.URL.createObjectURL(blob);

        a.href = blobUrl;
        a.download = fileName;
        return;
      }
      if (alink.download === '') {
        a.href = base64data;
        a.download = fileName;
        return;
      }
    } }
});

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about'
});

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_firebase__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_mapHelper__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_highcharts__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_highcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__panels_EcoliChart__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__panels_EcoliChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__panels_EcoliChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__panels_TurbidityChart__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__panels_TurbidityChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__panels_TurbidityChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__panels_RainfallChart__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__panels_RainfallChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__panels_RainfallChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__panels_ConductivityChart__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__panels_ConductivityChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__panels_ConductivityChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__panels_FilterSidebar__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__panels_FilterSidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__panels_FilterSidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__map_DataMapBanner__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__map_DataMapBanner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__map_DataMapBanner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__json_excel_JsonExcel__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__json_excel_JsonExcel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__json_excel_JsonExcel__);

















var collectionSitesRef = __WEBPACK_IMPORTED_MODULE_0__helpers_firebase__["a" /* db */].ref('collectionSites');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'data-page',
  components: {
    VueHighcharts: __WEBPACK_IMPORTED_MODULE_4_vue2_highcharts___default.a,
    EcoliChart: __WEBPACK_IMPORTED_MODULE_6__panels_EcoliChart___default.a,
    TurbidityChart: __WEBPACK_IMPORTED_MODULE_7__panels_TurbidityChart___default.a,
    RainfallChart: __WEBPACK_IMPORTED_MODULE_8__panels_RainfallChart___default.a,
    ConductivityChart: __WEBPACK_IMPORTED_MODULE_9__panels_ConductivityChart___default.a,
    FilterSidebar: __WEBPACK_IMPORTED_MODULE_10__panels_FilterSidebar___default.a,
    DataMapBanner: __WEBPACK_IMPORTED_MODULE_11__map_DataMapBanner___default.a,
    'download-excel': __WEBPACK_IMPORTED_MODULE_12__json_excel_JsonExcel___default.a
  },
  firebase: {
    collectionSites: collectionSitesRef
  },
  watch: {
    startDate: function startDate(val) {
      this.getReports();
    },
    endDate: function endDate(val) {
      this.getReports();
    },

    'sharedState.Selected': 'styleMap'
  },
  data: function data() {
    return {
      selectedSite: null,
      reports: null,
      collectionSites: [],
      startDate: __WEBPACK_IMPORTED_MODULE_3_moment___default()(new Date()).subtract(3, 'months').format('YYYY-MM-DD'),
      endDate: __WEBPACK_IMPORTED_MODULE_3_moment___default()(new Date()).format('YYYY-MM-DD'),
      controls: {
        sidebar: false,
        selectedControlDates: false,
        selectedControlReport: true
      },
      jsonFields: {
        'stationName': 'Site Name',
        'collectionDate': 'Collection Date',
        'collectionTime': 'Collection Time',
        'precipitation': 'Rain (in)',
        'totalColiform': 'Total Coliform (MPN / 100mL)',
        'totalEcoli': 'E.Coli (MPN / 100mL)',
        'fluorometry': 'Fluorometry',
        'turbidity': 'Turbidity (NTU)',
        'specificConductivity': 'Specifc Conductivity (µS)'
      }
    };
  },

  methods: {
    toggleSidebar: function toggleSidebar() {
      this.controls.sidebar = !this.controls.sidebar;
      this.mapy.resizeMap();
    },
    setActiveSite: function setActiveSite(site) {
      this.selectedSite = site;
      this.getReports();
      this.mapy.zoomIn(this.selectedSite);
    },
    getReports: function getReports() {
      if (this.$firebaseRefs.reports) {
        this.$unbind('reports');
      }

      if (this.startDate && this.endDate) {
        this.$bindAsArray('reports', __WEBPACK_IMPORTED_MODULE_0__helpers_firebase__["a" /* db */].ref('reports/' + this.selectedSite['.key']).orderByChild('collectionDate').startAt(this.startDate).endAt(this.endDate));
      } else {
        this.$bindAsArray('reports', __WEBPACK_IMPORTED_MODULE_0__helpers_firebase__["a" /* db */].ref('reports/' + this.selectedSite['.key']).orderByChild('collectionDate').limitToLast(10));
      }
    },
    selectedSiteCallbackFunc: function selectedSiteCallbackFunc(name) {
      var site = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.collectionSites, { 'stationName': name });
      if (site) {
        this.setActiveSite(site);
      }
    },
    initializeMap: function initializeMap() {
      this.mapy = new __WEBPACK_IMPORTED_MODULE_1__helpers_mapHelper__["a" /* MapHelper */](this.selectedSiteCallbackFunc);
    },
    exportXls: function exportXls() {
      if (this.selectedSite) {
        this.postToAPI('regular_report', 'NWW_Director_Report.csv');
      }
    },
    postToAPI: function postToAPI(exportType, exportName) {
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: 'https://waterwatch-cb707.firebaseapp.com/export',
        method: 'POST',
        data: {
          'export_type': exportType,
          'start_date': this.startDate,
          'end_date': this.endDate,
          'collection_sites': [this.selectedSite['.key']]
        }
      }).then(function (response) {
        var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = exportName;
        link.click();
      });
    }
  },
  mounted: function mounted() {
    this.initializeMap();
  }
});

/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(41);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sign-in',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])(['user'])),
  watch: {
    user: function user() {
      if (__WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser) {
        this.$router.replace('/logData');
      }
    }
  },
  data: function data() {
    return {
      showResetPassword: false,
      passVisible: false,
      formUser: {
        email: '',
        password: ''
      },
      errorSnackbar: {
        visible: false,
        errorMessage: 'There was an issue signing in to Admin',
        timeout: 6000
      },
      passwordSnackbar: {
        visible: false,
        errorMessage: 'Password email reset sent!',
        timeout: 6000
      }
    };
  },

  methods: {
    submitForm: function submitForm(evnt) {
      this.signInWithPassword();
      evnt.preventDefault();
    },
    signInWithPassword: function signInWithPassword() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().signInWithEmailAndPassword(this.formUser.email, this.formUser.password).then(function (userData) {
        _this.onSignedIn();
      }).catch(function () {
        _this.errorSnackbar.visible = true;
      });
    },
    onSignedIn: function onSignedIn() {
      this.$router.replace('/logData');
    },
    resetPassword: function resetPassword() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().sendPasswordResetEmail(this.formUser.email).then(function () {
        _this2.showResetPassword = false;
        _this2.passwordSnackbar.visible = true;
      });
    }
  }
});

/***/ }),

/***/ 346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filters_formatDateFilter__ = __webpack_require__(329);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'data-map-banner',
  props: ['selectedSite'],
  filters: {
    formatDateFilter: __WEBPACK_IMPORTED_MODULE_0__filters_formatDateFilter__["default"]
  }
});

/***/ }),

/***/ 347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_highcharts__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_highcharts__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'conductivity-chart',
  props: ['selectedSite', 'reports'],
  components: {
    VueHighcharts: __WEBPACK_IMPORTED_MODULE_2_vue2_highcharts___default.a
  },
  data: function data() {
    return {
      chartData: null,
      controls: {
        conductiveDialog: false
      },
      options: {
        chart: {
          type: 'column',
          width: 290,
          height: 220
        },
        legend: {
          enabled: false
        },
        title: {
          text: null
        },
        credits: {
          enabled: false
        },
        xAxis: {
          type: 'datetime',
          dateTimeLabelFormats: {
            day: '%m/%d/%y',
            month: '%m/%d/%y',
            week: '%m/%d/%y',
            year: '%m/%d/%y'
          },
          title: {
            text: 'Collection Date'
          }
        },
        yAxis: {
          title: {
            text: '(µS)',
            margin: 2
          },
          min: 0,
          ceiling: 6000
        },
        tooltip: {
          crosshairs: true,
          shared: true,
          pointFormat: '{point.y} (µS)'
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            groupPadding: 0,
            shadow: false,
            color: '#4D86A0'
          }
        },
        series: []
      }
    };
  },

  watch: {
    reports: function reports(newVal) {
      if (newVal) {
        this.renderChart();
      }
    }
  },
  methods: {
    renderChart: function renderChart() {
      var conductivityChart = this.$refs.conductivityChart;

      if (this.chartData) {
        conductivityChart.removeSeries(this.chartData);
        this.chartData = null;
      }

      conductivityChart.delegateMethod('showLoading', 'Loading...');

      this.chartData = this.parseChartData(this.reports);

      conductivityChart.addSeries(this.chartData);
      conductivityChart.hideLoading();
    },
    parseChartData: function parseChartData(reports) {
      var chartObj = {
        data: []
      };

      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(reports, function (report) {
        var conductivity = parseInt(report.specificConductivity);
        var date = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.utc(report.collectionDate).valueOf();

        chartObj.data.push([date, conductivity]);
      });

      return chartObj;
    }
  }
});

/***/ }),

/***/ 348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_highcharts__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_highcharts__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ecoli-chart',
  props: ['selectedSite', 'reports'],
  components: {
    VueHighcharts: __WEBPACK_IMPORTED_MODULE_2_vue2_highcharts___default.a
  },
  data: function data() {
    return {
      chartData: null,
      controls: {
        ecoliDialog: false
      },
      options: {
        chart: {
          type: 'column',
          width: 290,
          height: 220
        },
        legend: {
          enabled: false
        },
        title: {
          text: null
        },
        credits: {
          enabled: false
        },
        xAxis: {
          type: 'datetime',
          dateTimeLabelFormats: {
            day: '%m/%d/%y',
            month: '%m/%d/%y',
            week: '%m/%d/%y',
            year: '%m/%d/%y'
          },
          title: {
            text: 'Collection Date'
          }
        },
        yAxis: {
          title: {
            text: '(MPN/100mL)',
            margin: 2
          },
          min: 0,
          ceiling: 6000
        },
        tooltip: {
          crosshairs: true,
          shared: true,
          pointFormat: '{point.y:,.0f} (MPN/100mL)'
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            groupPadding: 0,
            shadow: false,
            color: '#4D86A0'
          }
        },
        series: []
      }
    };
  },
  watch: {
    reports: function reports(newVal) {
      if (newVal) {
        this.renderChart();
      }
    }
  },
  methods: {
    renderChart: function renderChart() {
      var ecoliChart = this.$refs.ecoliChart;
      if (this.chartData) {
        ecoliChart.removeSeries(this.chartData);
        this.chartData = null;
      }

      ecoliChart.delegateMethod('showLoading', 'Loading...');

      this.chartData = this.parseChartData(this.reports);

      ecoliChart.addSeries(this.chartData);
      ecoliChart.hideLoading();
    },
    parseChartData: function parseChartData(reports) {
      var chartObj = {
        data: []
      };

      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(reports, function (report) {
        var fakeEcoliData = parseInt(report.totalEcoli);
        var date = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.utc(report.collectionDate).valueOf();

        chartObj.data.push([date, fakeEcoliData]);
      });

      return chartObj;
    }
  }
});

/***/ }),

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_firebase__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);





var collectionSitesRef = __WEBPACK_IMPORTED_MODULE_0__helpers_firebase__["a" /* db */].ref('collectionSites');
var labsRef = __WEBPACK_IMPORTED_MODULE_0__helpers_firebase__["a" /* db */].ref('labs');
var hucRef = __WEBPACK_IMPORTED_MODULE_0__helpers_firebase__["a" /* db */].ref('hucList');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'data-page',
  props: ['collectionSites', 'selectedSite', 'selectSite', 'showSidebar'],
  firebase: {
    collectionSites: collectionSitesRef,
    labs: labsRef,
    hucList: hucRef
  },
  computed: {
    filteredResults: function filteredResults() {
      var _this = this;

      var sites = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.orderBy(this.collectionSites, 'stationName');
      sites = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(sites, function (site) {
        var isPrivate = site.isPrivate;
        var containsSearch = site.stationName.toLowerCase().includes(_this.filters.search);
        var containsHuc = _this.filters.hucFilters.length ? _this.filters.hucFilters.indexOf(site.hucName) : 0;
        var containsLab = _this.filters.labFilters.length ? _this.filters.labFilters.indexOf(site.lab) : 0;

        return containsSearch && !isPrivate && !(containsHuc === -1) && !(containsLab === -1);
      });

      return sites;
    }
  },
  data: function data() {
    return {
      controls: {
        showFilters: false,
        filterSites: ['HUC', 'Lab']
      },
      filters: {
        search: '',
        huc: false,
        hucFilters: [],
        lab: false,
        labFilters: []
      }
    };
  },

  methods: {
    toggleSidebar: function toggleSidebar() {
      this.$emit('toggleside');
    },
    selectActiveSite: function selectActiveSite(site) {
      this.$emit('selected', site);
    },

    debounceInput: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (e) {
      this.filters.search = e.target.value;
    }, 500)
  }
});

/***/ }),

/***/ 350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_highcharts__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_highcharts__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rainfall-chart',
  props: ['selectedSite', 'reports'],
  components: {
    VueHighcharts: __WEBPACK_IMPORTED_MODULE_2_vue2_highcharts___default.a
  },
  data: function data() {
    return {
      chartData: null,
      controls: {
        rainDialog: false
      },
      options: {
        chart: {
          type: 'column',
          width: 290,
          height: 220
        },
        legend: {
          enabled: false
        },
        title: {
          text: null
        },
        credits: {
          enabled: false
        },
        xAxis: {
          type: 'datetime',
          dateTimeLabelFormats: {
            day: '%m/%d/%y',
            month: '%m/%d/%y',
            week: '%m/%d/%y',
            year: '%m/%d/%y'
          },
          title: {
            text: 'Collection Date'
          }
        },
        yAxis: {
          title: {
            text: '(in)',
            margin: 2
          },
          tickInterval: '0.5',
          min: 0,
          ceiling: 6000
        },
        tooltip: {
          crosshairs: true,
          shared: true,
          pointFormat: '{point.y} (in)'
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            groupPadding: 0,
            shadow: false,
            color: '#4D86A0'
          }
        },
        series: []
      }
    };
  },

  watch: {
    reports: function reports(newVal) {
      if (newVal) {
        this.renderChart();
      }
    }
  },
  methods: {
    renderChart: function renderChart() {
      var rainfallChart = this.$refs.rainfallChart;

      if (this.chartData) {
        rainfallChart.removeSeries(this.chartData);
        this.chartData = null;
      }

      rainfallChart.delegateMethod('showLoading', 'Loading...');

      this.chartData = this.parseChartData(this.reports);

      rainfallChart.addSeries(this.chartData);
      rainfallChart.hideLoading();
    },
    parseChartData: function parseChartData(reports) {
      var chartObj = {
        data: []
      };

      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(reports, function (report) {
        var rainfall = parseFloat(report.precipitation);
        var date = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.utc(report.collectionDate).valueOf();

        chartObj.data.push([date, rainfall]);
      });

      return chartObj;
    }
  }
});

/***/ }),

/***/ 351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_highcharts__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_highcharts__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'turbidity-chart',
  props: ['selectedSite', 'reports'],
  components: {
    VueHighcharts: __WEBPACK_IMPORTED_MODULE_2_vue2_highcharts___default.a
  },
  data: function data() {
    return {
      chartData: null,
      controls: {
        turbidityDialog: false
      },
      options: {
        chart: {
          type: 'column',
          width: 290,
          height: 220
        },
        legend: {
          enabled: false
        },
        title: {
          text: null
        },
        credits: {
          enabled: false
        },
        xAxis: {
          type: 'datetime',
          dateTimeLabelFormats: {
            day: '%m/%d/%y',
            month: '%m/%d/%y',
            week: '%m/%d/%y',
            year: '%m/%d/%y'
          },
          title: {
            text: 'Collection Date'
          }
        },
        yAxis: {
          title: {
            text: '(NTU)',
            margin: 2
          },
          min: 0,
          ceiling: 6000
        },
        tooltip: {
          crosshairs: true,
          shared: true,
          pointFormat: '{point.y} (NTU)'
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            groupPadding: 0,
            shadow: false,
            color: '#4D86A0'
          }
        },
        series: []
      }
    };
  },

  watch: {
    reports: function reports(newVal) {
      if (newVal) {
        this.renderChart();
      }
    }
  },
  methods: {
    renderChart: function renderChart() {
      var turbidityChart = this.$refs.turbidityChart;

      if (this.chartData) {
        turbidityChart.removeSeries(this.chartData);
        this.chartData = null;
      }

      turbidityChart.delegateMethod('showLoading', 'Loading...');

      this.chartData = this.parseChartData(this.reports);

      turbidityChart.addSeries(this.chartData);
      turbidityChart.hideLoading();
    },
    parseChartData: function parseChartData(reports) {
      var chartObj = {
        data: []
      };

      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(reports, function (report) {
        var turbidity = parseInt(report.turbidity);
        var date = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.utc(report.collectionDate).valueOf();

        chartObj.data.push([date, turbidity]);
      });

      return chartObj;
    }
  }
});

/***/ }),

/***/ 388:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 389:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 390:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 391:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 392:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 393:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 394:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 395:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 396:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 397:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 398:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 399:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 400:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 401:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 402:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 403:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 404:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 405:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 406:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 112,
	"./af.js": 112,
	"./ar": 119,
	"./ar-dz": 113,
	"./ar-dz.js": 113,
	"./ar-kw": 114,
	"./ar-kw.js": 114,
	"./ar-ly": 115,
	"./ar-ly.js": 115,
	"./ar-ma": 116,
	"./ar-ma.js": 116,
	"./ar-sa": 117,
	"./ar-sa.js": 117,
	"./ar-tn": 118,
	"./ar-tn.js": 118,
	"./ar.js": 119,
	"./az": 120,
	"./az.js": 120,
	"./be": 121,
	"./be.js": 121,
	"./bg": 122,
	"./bg.js": 122,
	"./bm": 123,
	"./bm.js": 123,
	"./bn": 124,
	"./bn.js": 124,
	"./bo": 125,
	"./bo.js": 125,
	"./br": 126,
	"./br.js": 126,
	"./bs": 127,
	"./bs.js": 127,
	"./ca": 128,
	"./ca.js": 128,
	"./cs": 129,
	"./cs.js": 129,
	"./cv": 130,
	"./cv.js": 130,
	"./cy": 131,
	"./cy.js": 131,
	"./da": 132,
	"./da.js": 132,
	"./de": 135,
	"./de-at": 133,
	"./de-at.js": 133,
	"./de-ch": 134,
	"./de-ch.js": 134,
	"./de.js": 135,
	"./dv": 136,
	"./dv.js": 136,
	"./el": 137,
	"./el.js": 137,
	"./en-au": 138,
	"./en-au.js": 138,
	"./en-ca": 139,
	"./en-ca.js": 139,
	"./en-gb": 140,
	"./en-gb.js": 140,
	"./en-ie": 141,
	"./en-ie.js": 141,
	"./en-nz": 142,
	"./en-nz.js": 142,
	"./eo": 143,
	"./eo.js": 143,
	"./es": 146,
	"./es-do": 144,
	"./es-do.js": 144,
	"./es-us": 145,
	"./es-us.js": 145,
	"./es.js": 146,
	"./et": 147,
	"./et.js": 147,
	"./eu": 148,
	"./eu.js": 148,
	"./fa": 149,
	"./fa.js": 149,
	"./fi": 150,
	"./fi.js": 150,
	"./fo": 151,
	"./fo.js": 151,
	"./fr": 154,
	"./fr-ca": 152,
	"./fr-ca.js": 152,
	"./fr-ch": 153,
	"./fr-ch.js": 153,
	"./fr.js": 154,
	"./fy": 155,
	"./fy.js": 155,
	"./gd": 156,
	"./gd.js": 156,
	"./gl": 157,
	"./gl.js": 157,
	"./gom-latn": 158,
	"./gom-latn.js": 158,
	"./gu": 159,
	"./gu.js": 159,
	"./he": 160,
	"./he.js": 160,
	"./hi": 161,
	"./hi.js": 161,
	"./hr": 162,
	"./hr.js": 162,
	"./hu": 163,
	"./hu.js": 163,
	"./hy-am": 164,
	"./hy-am.js": 164,
	"./id": 165,
	"./id.js": 165,
	"./is": 166,
	"./is.js": 166,
	"./it": 167,
	"./it.js": 167,
	"./ja": 168,
	"./ja.js": 168,
	"./jv": 169,
	"./jv.js": 169,
	"./ka": 170,
	"./ka.js": 170,
	"./kk": 171,
	"./kk.js": 171,
	"./km": 172,
	"./km.js": 172,
	"./kn": 173,
	"./kn.js": 173,
	"./ko": 174,
	"./ko.js": 174,
	"./ky": 175,
	"./ky.js": 175,
	"./lb": 176,
	"./lb.js": 176,
	"./lo": 177,
	"./lo.js": 177,
	"./lt": 178,
	"./lt.js": 178,
	"./lv": 179,
	"./lv.js": 179,
	"./me": 180,
	"./me.js": 180,
	"./mi": 181,
	"./mi.js": 181,
	"./mk": 182,
	"./mk.js": 182,
	"./ml": 183,
	"./ml.js": 183,
	"./mr": 184,
	"./mr.js": 184,
	"./ms": 186,
	"./ms-my": 185,
	"./ms-my.js": 185,
	"./ms.js": 186,
	"./my": 187,
	"./my.js": 187,
	"./nb": 188,
	"./nb.js": 188,
	"./ne": 189,
	"./ne.js": 189,
	"./nl": 191,
	"./nl-be": 190,
	"./nl-be.js": 190,
	"./nl.js": 191,
	"./nn": 192,
	"./nn.js": 192,
	"./pa-in": 193,
	"./pa-in.js": 193,
	"./pl": 194,
	"./pl.js": 194,
	"./pt": 196,
	"./pt-br": 195,
	"./pt-br.js": 195,
	"./pt.js": 196,
	"./ro": 197,
	"./ro.js": 197,
	"./ru": 198,
	"./ru.js": 198,
	"./sd": 199,
	"./sd.js": 199,
	"./se": 200,
	"./se.js": 200,
	"./si": 201,
	"./si.js": 201,
	"./sk": 202,
	"./sk.js": 202,
	"./sl": 203,
	"./sl.js": 203,
	"./sq": 204,
	"./sq.js": 204,
	"./sr": 206,
	"./sr-cyrl": 205,
	"./sr-cyrl.js": 205,
	"./sr.js": 206,
	"./ss": 207,
	"./ss.js": 207,
	"./sv": 208,
	"./sv.js": 208,
	"./sw": 209,
	"./sw.js": 209,
	"./ta": 210,
	"./ta.js": 210,
	"./te": 211,
	"./te.js": 211,
	"./tet": 212,
	"./tet.js": 212,
	"./th": 213,
	"./th.js": 213,
	"./tl-ph": 214,
	"./tl-ph.js": 214,
	"./tlh": 215,
	"./tlh.js": 215,
	"./tr": 216,
	"./tr.js": 216,
	"./tzl": 217,
	"./tzl.js": 217,
	"./tzm": 219,
	"./tzm-latn": 218,
	"./tzm-latn.js": 218,
	"./tzm.js": 219,
	"./uk": 220,
	"./uk.js": 220,
	"./ur": 221,
	"./ur.js": 221,
	"./uz": 223,
	"./uz-latn": 222,
	"./uz-latn.js": 222,
	"./uz.js": 223,
	"./vi": 224,
	"./vi.js": 224,
	"./x-pseudo": 225,
	"./x-pseudo.js": 225,
	"./yo": 226,
	"./yo.js": 226,
	"./zh-cn": 227,
	"./zh-cn.js": 227,
	"./zh-hk": 228,
	"./zh-hk.js": 228,
	"./zh-tw": 229,
	"./zh-tw.js": 229
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 413;

/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/crk-logo.8785f03.png";

/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(393)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(439),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(405)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(451),
  /* scopeId */
  "data-v-f83df118",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(397)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(443),
  /* scopeId */
  "data-v-6757368e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(404)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(450),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(403)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(448),
  /* scopeId */
  "data-v-dbff8662",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(394)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(440),
  /* scopeId */
  "data-v-20718eb9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(395)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(441),
  /* scopeId */
  "data-v-2d19bdcc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(391)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(437),
  /* scopeId */
  "data-v-10ce147c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 425:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(390)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(436),
  /* scopeId */
  "data-v-0e6fb69c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 426:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(406)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(452),
  /* scopeId */
  "data-v-ffc74dcc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 427:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(388)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(434),
  /* scopeId */
  "data-v-033fdd43",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(400)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(446),
  /* scopeId */
  "data-v-7da11c16",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(392)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(438),
  /* scopeId */
  "data-v-12a78774",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(398)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(444),
  /* scopeId */
  "data-v-6f28acfb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(396)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(442),
  /* scopeId */
  "data-v-647b7c6e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(389)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(435),
  /* scopeId */
  "data-v-06572394",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(399)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(445),
  /* scopeId */
  "data-v-7c6d1232",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 434:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-in"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "sign-in-body"
  }, [_c('form', {
    staticClass: "sign-in-body__form",
    on: {
      "submit": _vm.submitForm
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Email"
    },
    model: {
      value: (_vm.formUser.email),
      callback: function($$v) {
        _vm.$set(_vm.formUser, "email", $$v)
      },
      expression: "formUser.email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Password",
      "type": _vm.passVisible ? 'text' : 'password',
      "append-icon": _vm.passVisible ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.passVisible = !_vm.passVisible); }
    },
    model: {
      value: (_vm.formUser.password),
      callback: function($$v) {
        _vm.$set(_vm.formUser, "password", $$v)
      },
      expression: "formUser.password"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": ""
    },
    model: {
      value: (_vm.showResetPassword),
      callback: function($$v) {
        _vm.showResetPassword = $$v
      },
      expression: "showResetPassword"
    }
  }, [_c('a', {
    staticClass: "form-input-sub-text",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("Forget Password?")]), _vm._v(" "), _c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Reset Password")]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Email Address",
      "single-line": ""
    },
    model: {
      value: (_vm.formUser.email),
      callback: function($$v) {
        _vm.$set(_vm.formUser, "email", $$v)
      },
      expression: "formUser.email"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "primary": "",
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showResetPassword = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "md-raised btn-nww",
    nativeOn: {
      "click": function($event) {
        _vm.resetPassword($event)
      }
    }
  }, [_vm._v("Send Reset Email")])], 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "md-raised btn-nww sign-in-body__btn",
    attrs: {
      "type": "submit"
    },
    nativeOn: {
      "click": function($event) {
        _vm.signInWithPassword()
      }
    }
  }, [_vm._v("\n        Sign In\n      ")])], 1)]), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.errorSnackbar.timeout,
      "error": true
    },
    model: {
      value: (_vm.errorSnackbar.visible),
      callback: function($$v) {
        _vm.$set(_vm.errorSnackbar, "visible", $$v)
      },
      expression: "errorSnackbar.visible"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.errorSnackbar.errorMessage) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.errorSnackbar.visible = false
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.passwordSnackbar.timeout,
      "info": true
    },
    model: {
      value: (_vm.passwordSnackbar.visible),
      callback: function($$v) {
        _vm.$set(_vm.passwordSnackbar, "visible", $$v)
      },
      expression: "passwordSnackbar.visible"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.passwordSnackbar.errorMessage) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.passwordSnackbar.visible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-in-header"
  }, [_c('span', {
    staticClass: "sign-in-header__text"
  }, [_vm._v("\n      ADMIN\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "sign-in-header__text--large"
  }, [_vm._v("\n      Sign In\n    ")])])
}]}

/***/ }),

/***/ 435:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "graph-card"
  }, [_c('div', {
    staticClass: "graph-card-title"
  }, [_c('span', {
    staticClass: "graph-card-title__primary"
  }, [_vm._v("\n      Rainfall (inches)\n      "), _c('v-dialog', {
    attrs: {
      "content-class": "nww-dialog",
      "persistent": ""
    },
    model: {
      value: (_vm.controls.rainDialog),
      callback: function($$v) {
        _vm.$set(_vm.controls, "rainDialog", $$v)
      },
      expression: "controls.rainDialog"
    }
  }, [_c('i', {
    staticClass: "material-icons graph-card-title__icon",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("\n          info_outline\n        ")]), _vm._v(" "), _c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Rainfall")]), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("Rain water reaches a stream, river, lake, or ocean, via overland runoff during and immediately after a rain event, and by a much slower route by soaking into the ground. Much of the rain that enters the ground filters down into subsurface water-bearing rocks (aquifers) and eventually reaches lakes, streams, and rivers where these surface-water bodies intercept the aquifers. The hard surfaces in our urban landscape dramatically increase the volume of overland flow, which leads to flooding, and erosion, and runoff of pollutants, as well as decreased groundwater recharge.")])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-nww btn btn--raised",
    nativeOn: {
      "click": function($event) {
        _vm.controls.rainDialog = false
      }
    }
  }, [_vm._v("Okay")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "graph-card-title__secondary--strong"
  }, [_vm._v("\n        Last Result:\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "graph-card-title__secondary"
  }, [_vm._v("\n        " + _vm._s(_vm.selectedSite ? _vm.selectedSite.lastRainfallResult : null) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "graph-card__graph-wrapper"
  }, [_c('vue-highcharts', {
    ref: "rainfallChart",
    attrs: {
      "id": "chart3",
      "options": _vm.options
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 436:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-content-header"
  }, [_c('div', {
    staticClass: "page-content-header__text"
  }, [_vm._v("\n      About\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "page-content-body"
  }, [_c('h3', [_vm._v("About Chattahoochee Riverkeeper")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://chattahoochee.org/about-us/",
      "target": "_blank"
    }
  }, [_vm._v("Chattahoochee Riverkeeper")]), _vm._v(" (CRK) is a nonprofit organization dedicated to protecting and preserving the Chattahoochee River, its lakes and tributaries for the people, fish and wildlife that depend upon them.")]), _vm._v(" "), _c('h3', [_vm._v("About Neighborhood Water Watch")]), _vm._v(" "), _c('p', [_vm._v("CRK’s rapidly expanding and highly successful water monitoring program, Neighborhood Water Watch (NWW), is a collaborative program between CRK and neighborhood groups, schools and citizens in our watershed. The goal: improved water quality in urban streams and protection of human health in the surrounding communities.")]), _vm._v(" "), _c('p', [_vm._v("Concerned citizens from all reaches of north Georgia bring water samples from their respective stations to CRK’s laboratories, as part of NWW. Water samples are promptly analyzed for turbidity, conductivity, optical brighteners, and E.coli. (Meet one of our NWW volunteers "), _c('a', {
    attrs: {
      "href": "https://vimeo.com/52027083",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("in this video")]), _vm._v(".)")]), _vm._v(" "), _c('p', [_vm._v("Elevated E. coli levels are a common indicator of sewage leaks and spills into waterways, and the data can indicate the number and type of pathogens present in the water. Any threats indicated are addressed by CRK, as we work with local governments, neighborhood groups, and leaders to stop public health threats and restore our streams.")]), _vm._v(" "), _c('p', [_vm._v("Interested in starting your own Neighborhood Water Watch program? "), _c('a', {
    attrs: {
      "href": "https://chattahoochee.org/wp-content/uploads/2013/05/NWW-guide_FINALFINAL.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Take a look at our Manual")]), _vm._v(".")]), _vm._v(" "), _c('h3', [_vm._v("E. coli Frequently Asked Questions")]), _vm._v(" "), _c('h4', [_vm._v("What is E. coli?")]), _vm._v(" "), _c('p', [_vm._v("Escherichia coli (E. coli) is a bacteria that is commonly found in the gastrointestinal tract and feces of warm-blooded animals and humans. According to the U.S. EPA, E. coli is the best indicator of the presence of pathogens in surface waters and its presence provides direct evidence of fecal contamination of the water.")]), _vm._v(" "), _c('h4', [_vm._v("How are the E. coli results interpreted to determine if they are acceptable?")]), _vm._v(" "), _c('p', [_vm._v("EPA recommends an E. coli recreational safety level for primary contact of a geometric average of 126 cfu/100ml or less. Because it is common to find high bacteria counts in urban areas, Georgia Adopt-A-Stream advises that counts that exceed a 1000 cfu/100 ml threshold may warrant special attention. NWW results that show a “high” bacterial count may be a one-time event or occurrence or may be a part of a chronic problem. This information is useful, but before taking further action additional sampling is necessary to document bacterial levels over a long period to determine seasonal fluctuations and in response to rain events. This long term information is vital in assessing the overall health of the stream and determining if special attention is warranted to investigate potential pollution sources.")]), _vm._v(" "), _c('h4', [_vm._v("What do the E. coli results tell us about safety?")]), _vm._v(" "), _c('p', [_vm._v("The most recent recommendations developed by the US EPA for recreational primary contact state that surface waters should not exceed an E. coli level of 126 cfu/100mL on an average. Primary contact recreation includes swimming, bathing, diving, surfing, water skiing, tubing, water play by children, and similar water contact activities where a high degree of bodily contact with the water and immersion and ingestion are likely. Studies conducted by the EPA indicate that for surface waters with an average E. coli level of 126 cfu/100mL, the estimated rate of illness is 36/1000 for people having primary contact.")]), _vm._v(" "), _c('p', [_vm._v("Bacteria are a natural component of all rivers, lakes and streams and most bacteria are harmless, however, certain species of bacteria in groups such as Campylobacter, Salmonella, and Shigella can cause sickness in humans. The most common side effects of these sicknesses may include a short period of vomiting and/or acute diarrhea but can also cause much more serious complications in rarer circumstances. Those most at risk for the serious side effects associated with these waterborne diseases are the very young, old, and immuno-compromised.")]), _vm._v(" "), _c('h4', [_vm._v("What is an indicator organism and why do we measure indicators instead of pathogens?")]), _vm._v(" "), _c('p', [_vm._v("A microbial indicator organism is a single celled organism that is usually harmless, found in high numbers, and originates from the same sources as the pathogens whose numbers you are interested in obtaining. Monitoring for indicator organisms is usually much easier and more cost effective than actually monitoring for the disease causing organisms. Pathogens are disease-causing organisms such as some types of bacteria, viruses, and protozoans and typically occur in very small concentrations, so routinely monitoring for these pathogens is comparable to looking for a needle in a haystack. Field sampling and laboratory methods for measuring pathogens are very time consuming, expensive, and sometimes put the analyst at more risk for being infected by the pathogen.")]), _vm._v(" "), _c('h4', [_vm._v("How do waters become contaminated?")]), _vm._v(" "), _c('p', [_vm._v("Many of the rivers, streams, and lakes throughout the Chattahoochee Watershed are vulnerable to increased bacterial contamination especially during heavy rains which can convey bacteria from various sources to susceptible waterways. Common sources of bacteria and other pollutants include cracked and overflowing septic systems, leaking septic systems, failing infrastructure, agriculture, wildlife, and pet waste.")]), _vm._v(" "), _c('h4', [_vm._v("What makes bacteria levels go up and down?")]), _vm._v(" "), _c('p', [_vm._v("Levels of bacteria in a river or stream can be influenced by many factors. The most common causes for elevated levels of bacteria are due to runoff associated with storms, however, leaking sewage lines or spills from treatment plants can also cause levels to increase. E. coli concentrations are typically higher (1) during and after rain events, (2) on tributary streams than in the Chattahoochee River, (3) during the summer season than during the winter months, and (4) at night rather than during daylight hours.")]), _vm._v(" "), _c('h4', [_vm._v("How is E. coli measured?")]), _vm._v(" "), _c('p', [_vm._v("There are several ways of measuring numbers of E. coli bacteria in streams. The method used to determine the numbers reported on CRK’s web site involves a relatively new method recently approved by the EPA called the IDEXX Colilert-18 system. It involves the collection of water from a stream or river using sterile equipment and adding a chemical called MUG. This mixture is then poured into a container that separates the sample water into equal-sized compartments. The container is sealed and incubated for 18-22 hours. The sample water in the compartments containing coliform bacteria and E. coli will change color. The number of compartments which turn yellow indicates the most probable number (MPN, which is a similar value to CFU) of total coliform bacteria in the stream while the number compartments which fluoresce under ultraviolet light indicates the number of E. coli present in the stream at the time that it was sampled.")]), _vm._v(" "), _c('h4', [_vm._v("Are the fish safe to eat?")]), _vm._v(" "), _c('p', [_vm._v("The presence of E. coli in waters does not directly affect fish consumption, however, when fishing it is often difficult to avoid some contact with the water. Any primary contact with water that has elevated E. coli levels increases the likelihood that a person may be exposed to or accidentally ingest water from the river or stream. This is especially true if the person has open cuts or wounds or if eating or drinking is involved. Fish consumption advisories are issued by the Georgia Department of Natural Resources (GA DNR) and are based on an analysis of chemical and metal concentrations in fish tissue: "), _c('a', {
    attrs: {
      "href": "http://www.gaepd.org/Files_PDF/gaenviron/GADNR_FishConsumptionGuidelines_Y2012.pdf",
      "target": "_blank"
    }
  }, [_vm._v("http://www.gaepd.org/Files_PDF/gaenviron/GADNR_FishConsumptionGuidelines_Y2012.pdf")])])])])
}]}

/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('v-navigation-drawer', {
    staticClass: "pb-0 app-sidebar",
    attrs: {
      "floating": "",
      "absolute": "",
      "height": "calc(100vh - 64px)",
      "clipped": "",
      "enable-resize-watcher": ""
    },
    model: {
      value: (_vm.controls.sidebarOpen),
      callback: function($$v) {
        _vm.$set(_vm.controls, "sidebarOpen", $$v)
      },
      expression: "controls.sidebarOpen"
    }
  }, [_vm._l((_vm.arrNav), function(item, index) {
    return (item.auth === !!_vm.user) ? _c('router-link', {
      key: index,
      staticClass: "app-sidebar__link list__tile--active",
      attrs: {
        "to": item.path
      }
    }, [_c('i', {
      staticClass: "material-icons app-sidebar__icon"
    }, [_vm._v(_vm._s(item.icon))]), _vm._v("\n      " + _vm._s(item.title) + "\n    ")]) : _vm._e()
  }), _vm._v(" "), (_vm.user) ? _c('a', {
    staticClass: "app-sidebar__link list__tile--active",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons app-sidebar__icon"
  }, [_vm._v("lock")]), _vm._v("\n      Sign Out\n    ")]) : _c('router-link', {
    staticClass: "app-sidebar__link list__tile--active",
    attrs: {
      "to": "/signIn"
    }
  }, [_c('i', {
    staticClass: "material-icons app-sidebar__icon"
  }, [_vm._v("lock")]), _vm._v("\n      Admin\n    ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "app-nav"
  }, [_c('div', {
    staticClass: "app-nav__primary-section"
  }, [_c('v-toolbar-title', {
    staticClass: "app-sidebar-toggle"
  }, [_c('v-toolbar-side-icon', {
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.controls.sidebarOpen = !_vm.controls.sidebarOpen
      }
    }
  })], 1), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _vm._m(1, false, false)], 1), _vm._v(" "), _c('div', {
    staticClass: "app-nav__secondary-section"
  }, [_vm._l((_vm.arrNav), function(item, index) {
    return _c('router-link', {
      key: index,
      staticClass: "app-nav__link",
      attrs: {
        "to": item.path
      }
    }, [(item.auth === !!_vm.user) ? _c('v-btn', {
      staticClass: "app-nav__button",
      attrs: {
        "flat": ""
      }
    }, [_vm._v("\n          " + _vm._s(item.title) + "\n        ")]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.user) ? _c('a', {
    staticClass: "app-nav__link"
  }, [_c('v-btn', {
    staticClass: "app-nav__button--small",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("lock")]), _vm._v("\n          Sign Out\n        ")])], 1) : _c('router-link', {
    staticClass: "app-nav__link",
    attrs: {
      "to": "/signIn"
    }
  }, [_c('v-btn', {
    staticClass: "app-nav__button--small",
    attrs: {
      "flat": ""
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("lock")]), _vm._v("\n          Admin\n        ")])], 1)], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "app-nav__crk",
    attrs: {
      "href": "http://www.chattahoochee.org",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "app-nav__crk-logo",
    attrs: {
      "src": __webpack_require__(416)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "app-nav__nww",
    attrs: {
      "href": "https://chattahoochee.org/our-work/water-monitoring/neighborhood-water-watch/",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "app-nav__nww-logo"
  })])
}]}

/***/ }),

/***/ 438:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "graph-card"
  }, [_c('div', {
    staticClass: "graph-card-title"
  }, [_c('span', {
    staticClass: "graph-card-title__primary"
  }, [_vm._v("\n      Specific Conductivity (µS)\n      "), _c('v-dialog', {
    attrs: {
      "content-class": "nww-dialog",
      "persistent": ""
    },
    model: {
      value: (_vm.controls.conductiveDialog),
      callback: function($$v) {
        _vm.$set(_vm.controls, "conductiveDialog", $$v)
      },
      expression: "controls.conductiveDialog"
    }
  }, [_c('i', {
    staticClass: "material-icons graph-card-title__icon",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("\n          info_outline\n        ")]), _vm._v(" "), _c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Specific Conductivity (µS)")]), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("Specific Conductivity (conductivity) is a measure of the water’s ability to pass an electrical current and indicates the presence of ions. Sources of ions in streams include nutrients, heavy metals, and salts from urban and agricultural runoff, or minerals from rock weathering. Background levels of conductivity in streams in Georgia range from 50 – 1500 µS/cm. We closely monitor any deviations in conductivity at each site we monitor.")])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-nww btn btn--raised",
    nativeOn: {
      "click": function($event) {
        _vm.controls.conductiveDialog = false
      }
    }
  }, [_vm._v("Okay")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "graph-card-title__secondary--strong"
  }, [_vm._v("\n        Last Result:\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "graph-card-title__secondary"
  }, [_vm._v("\n        " + _vm._s(_vm.selectedSite ? _vm.selectedSite.lastConductivityResult : null) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "graph-card__graph-wrapper"
  }, [_c('vue-highcharts', {
    ref: "conductivityChart",
    attrs: {
      "id": "chart4",
      "options": _vm.options
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 439:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "overlay": false
    },
    model: {
      value: (_vm.controls.showDialog),
      callback: function($$v) {
        _vm.$set(_vm.controls, "showDialog", $$v)
      },
      expression: "controls.showDialog"
    }
  }, [_c('v-btn', {
    staticClass: "btn-nww--light",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("Add New Site")]), _vm._v(" "), _c('v-card', [_c('div', {
    staticClass: "page-content-header"
  }, [_c('div', {
    staticClass: "page-content-header__text"
  }, [_vm._v("\n          New Collection Site\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "page-content-body"
  }, [_c('form', {
    staticClass: "add-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitForm($event)
      }
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Station Name",
      "required": ""
    },
    model: {
      value: (_vm.newCollectionSite.stationName),
      callback: function($$v) {
        _vm.$set(_vm.newCollectionSite, "stationName", $$v)
      },
      expression: "newCollectionSite.stationName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Logbook Abbreviation",
      "required": ""
    },
    model: {
      value: (_vm.newCollectionSite.logbookAbbv),
      callback: function($$v) {
        _vm.$set(_vm.newCollectionSite, "logbookAbbv", $$v)
      },
      expression: "newCollectionSite.logbookAbbv"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.labSet,
      "item-text": ".value",
      "item-value": ".value",
      "label": "Lab",
      "required": "",
      "bottom": ""
    },
    model: {
      value: (_vm.newCollectionSite.lab),
      callback: function($$v) {
        _vm.$set(_vm.newCollectionSite, "lab", $$v)
      },
      expression: "newCollectionSite.lab"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Latitude (eg. 34.004401)",
      "required": ""
    },
    model: {
      value: (_vm.newCollectionSite.latitude),
      callback: function($$v) {
        _vm.$set(_vm.newCollectionSite, "latitude", $$v)
      },
      expression: "newCollectionSite.latitude"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Longitude (eg. -84.350555)",
      "required": ""
    },
    model: {
      value: (_vm.newCollectionSite.longitude),
      callback: function($$v) {
        _vm.$set(_vm.newCollectionSite, "longitude", $$v)
      },
      expression: "newCollectionSite.longitude"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.hucSet,
      "label": "Subwatershed (HUC 12) Name",
      "autocomplete": "",
      "bottom": ""
    },
    model: {
      value: (_vm.newCollectionSite.hucName),
      callback: function($$v) {
        _vm.$set(_vm.newCollectionSite, "hucName", $$v)
      },
      expression: "newCollectionSite.hucName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Adopt-A-Stream Name"
    },
    model: {
      value: (_vm.newCollectionSite.adoptAStreamName),
      callback: function($$v) {
        _vm.$set(_vm.newCollectionSite, "adoptAStreamName", $$v)
      },
      expression: "newCollectionSite.adoptAStreamName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Adopt-A-Stream 'S' ID (eg. S-4475)",
      "rules": [function (v) { return !!v || 'Enter the 4 numbers after S- only (Leave blank if no ID)'; }]
    },
    model: {
      value: (_vm.newCollectionSite.aasNumber),
      callback: function($$v) {
        _vm.$set(_vm.newCollectionSite, "aasNumber", $$v)
      },
      expression: "newCollectionSite.aasNumber"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "STORET Name"
    },
    model: {
      value: (_vm.newCollectionSite.storetName),
      callback: function($$v) {
        _vm.$set(_vm.newCollectionSite, "storetName", $$v)
      },
      expression: "newCollectionSite.storetName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "STORET Location ID (eg. NWW24)"
    },
    model: {
      value: (_vm.newCollectionSite.storetId),
      callback: function($$v) {
        _vm.$set(_vm.newCollectionSite, "storetId", $$v)
      },
      expression: "newCollectionSite.storetId"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.partnerSet,
      "item-text": ".value",
      "item-value": ".value",
      "label": "Collection Partner",
      "bottom": ""
    },
    model: {
      value: (_vm.newCollectionSite.collectionPartner),
      callback: function($$v) {
        _vm.$set(_vm.newCollectionSite, "collectionPartner", $$v)
      },
      expression: "newCollectionSite.collectionPartner"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": ("" + (_vm.newCollectionSite.isPrivate ? 'Check this box to hide from map (make private)' : 'Check this box to hide from map (make private)')),
      "success": ""
    },
    model: {
      value: (_vm.newCollectionSite.isPrivate),
      callback: function($$v) {
        _vm.$set(_vm.newCollectionSite, "isPrivate", $$v)
      },
      expression: "newCollectionSite.isPrivate"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-nww",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save Site")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn",
    attrs: {
      "flat": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.close($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)])])], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbar.timeout,
      "error": false
    },
    model: {
      value: (_vm.snackbar.errorVisible),
      callback: function($$v) {
        _vm.$set(_vm.snackbar, "errorVisible", $$v)
      },
      expression: "snackbar.errorVisible"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbar.errorMessage) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar.errorVisible = false
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbar.timeout,
      "info": true
    },
    model: {
      value: (_vm.snackbar.successVisible),
      callback: function($$v) {
        _vm.$set(_vm.snackbar, "successVisible", $$v)
      },
      expression: "snackbar.successVisible"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbar.successMessage) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar.successVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 440:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "log-data"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "page-content-body"
  }, [_c('v-form', {
    ref: "form",
    staticClass: "page-content-body__form",
    attrs: {
      "autocomplete": "false"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.controls.showDialog = true
      }
    },
    model: {
      value: (_vm.formValid),
      callback: function($$v) {
        _vm.formValid = $$v
      },
      expression: "formValid"
    }
  }, [_c('div', {
    staticClass: "page-content-body__column"
  }, [_c('div', {
    staticClass: "page-content-body__header"
  }, [_vm._v("\n          Collection Details\n        ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Logbook Number",
      "disabled": ""
    },
    model: {
      value: (_vm.newLogData.logbookNumber),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "logbookNumber", $$v)
      },
      expression: "newLogData.logbookNumber"
    }
  }), _vm._v(" "), _c('v-menu', {
    staticClass: "input-group--limit-height",
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 0,
      "max-width": "290px"
    },
    model: {
      value: (_vm.controls.showDatepicker),
      callback: function($$v) {
        _vm.$set(_vm.controls, "showDatepicker", $$v)
      },
      expression: "controls.showDatepicker"
    }
  }, [_c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "slot": "activator",
      "label": "Collection Date(YYYY-MM-DD)",
      "append-icon": "event",
      "rules": [function (v) { return !!v || 'Collection Date is required'; }],
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.newLogData.collectionDate),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "collectionDate", $$v)
      },
      expression: "newLogData.collectionDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "actions": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          staticClass: "btn-nww",
          nativeOn: {
            "click": function($event) {
              save()
            }
          }
        }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "primary": "",
            "flat": ""
          },
          nativeOn: {
            "click": function($event) {
              cancel()
            }
          }
        }, [_vm._v("Cancel")])], 1)]
      }
    }]),
    model: {
      value: (_vm.newLogData.collectionDate),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "collectionDate", $$v)
      },
      expression: "newLogData.collectionDate"
    }
  })], 1), _vm._v(" "), _c('v-select', {
    staticClass: "input-group--limit-height",
    attrs: {
      "items": _vm.collectionSites,
      "label": "Collection Site",
      "autocomplete": "",
      "item-text": "logbookAbbv",
      "rules": [function (v) { return !!v || 'Collection Site is required'; }],
      "required": "",
      "bottom": ""
    },
    model: {
      value: (_vm.selectedSite),
      callback: function($$v) {
        _vm.selectedSite = $$v
      },
      expression: "selectedSite"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "name": "input-5-1",
      "label": "Notes"
    },
    model: {
      value: (_vm.newLogData.notes),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "notes", $$v)
      },
      expression: "newLogData.notes"
    }
  }), _vm._v(" "), _c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px"
    },
    model: {
      value: (_vm.controls.collectionTimeMenu),
      callback: function($$v) {
        _vm.$set(_vm.controls, "collectionTimeMenu", $$v)
      },
      expression: "controls.collectionTimeMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Collection Time",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.newLogData.collectionTime),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "collectionTime", $$v)
      },
      expression: "newLogData.collectionTime"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    attrs: {
      "autosave": "",
      "format": "24hr"
    },
    model: {
      value: (_vm.newLogData.collectionTime),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "collectionTime", $$v)
      },
      expression: "newLogData.collectionTime"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Rainfall (in) [trace = 0.001]",
      "type": "number",
      "step": "0.01",
      "rules": _vm.formRules.precipitation
    },
    model: {
      value: (_vm.newLogData.precipitation),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "precipitation", $$v)
      },
      expression: "newLogData.precipitation"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "form-input-sub-text",
    attrs: {
      "target": "_blank",
      "href": "https://www.wunderground.com/history/"
    }
  }, [_vm._v("Rainfall value from Weather Underground")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Analyst (Initials)",
      "required": "",
      "rules": _vm.formRules.required
    },
    model: {
      value: (_vm.newLogData.analyst),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "analyst", $$v)
      },
      expression: "newLogData.analyst"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content-body__column"
  }, [_c('div', {
    staticClass: "page-content-body__header"
  }, [_vm._v("\n          Incubation and Parameters\n        ")]), _vm._v(" "), _c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px"
    },
    model: {
      value: (_vm.controls.incubationInMenu),
      callback: function($$v) {
        _vm.$set(_vm.controls, "incubationInMenu", $$v)
      },
      expression: "controls.incubationInMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Incubation In Time",
      "rules": _vm.formRules.incubationTimeRules
    },
    slot: "activator",
    model: {
      value: (_vm.newLogData.incubationTime),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "incubationTime", $$v)
      },
      expression: "newLogData.incubationTime"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    attrs: {
      "autosave": "",
      "format": "24hr"
    },
    model: {
      value: (_vm.newLogData.incubationTime),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "incubationTime", $$v)
      },
      expression: "newLogData.incubationTime"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Incubation Temp (*C)",
      "type": "number",
      "rules": _vm.formRules.incubationTempRules
    },
    model: {
      value: (_vm.newLogData.incubationTemp),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "incubationTemp", $$v)
      },
      expression: "newLogData.incubationTemp"
    }
  }), _vm._v(" "), _c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px"
    },
    model: {
      value: (_vm.controls.incubationOutMenu),
      callback: function($$v) {
        _vm.$set(_vm.controls, "incubationOutMenu", $$v)
      },
      expression: "controls.incubationOutMenu"
    }
  }, [_c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "slot": "activator",
      "label": "Incubation Out Time",
      "rules": _vm.formRules.incubationOutTimeRules
    },
    slot: "activator",
    model: {
      value: (_vm.newLogData.incubationOut),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "incubationOut", $$v)
      },
      expression: "newLogData.incubationOut"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    attrs: {
      "autosave": "",
      "format": "24hr"
    },
    model: {
      value: (_vm.newLogData.incubationOut),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "incubationOut", $$v)
      },
      expression: "newLogData.incubationOut"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "# mL/100mL (Dilution)",
      "type": "number",
      "rules": _vm.formRules.dilutionRules
    },
    model: {
      value: (_vm.newLogData.dilution),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "dilution", $$v)
      },
      expression: "newLogData.dilution"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Fluorometry",
      "type": "number",
      "step": "0.01",
      "rules": _vm.formRules.fluorometryRules
    },
    model: {
      value: (_vm.newLogData.fluorometry),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "fluorometry", $$v)
      },
      expression: "newLogData.fluorometry"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Turbidity (NTU)",
      "type": "number",
      "step": "0.01",
      "rules": _vm.formRules.turbidityRules
    },
    model: {
      value: (_vm.newLogData.turbidity),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "turbidity", $$v)
      },
      expression: "newLogData.turbidity"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Conductivity (µS)",
      "type": "number",
      "step": "0.01",
      "rules": _vm.formRules.conductivityRules
    },
    model: {
      value: (_vm.newLogData.specificConductivity),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "specificConductivity", $$v)
      },
      expression: "newLogData.specificConductivity"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Typical range for Conductivity is 0 - 750")])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content-body__column page-content-body__column--end"
  }, [_c('div', {
    staticClass: "log-data-section-wrapper"
  }, [_c('div', {
    staticClass: "page-content-body__header"
  }, [_vm._v("\n            Total Coliform\n          ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Large Cells",
      "type": "number",
      "rules": _vm.formRules.largeCellsRules
    },
    model: {
      value: (_vm.newLogData.coliformLargeCells),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "coliformLargeCells", $$v)
      },
      expression: "newLogData.coliformLargeCells"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Small Cells",
      "type": "number",
      "rules": _vm.formRules.smallCellsRules
    },
    model: {
      value: (_vm.newLogData.coliformSmallCells),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "coliformSmallCells", $$v)
      },
      expression: "newLogData.coliformSmallCells"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "log-data-total"
  }, [_vm._v("Total Coliform (MPN/100mL) = " + _vm._s(_vm.getTotalColiform))]), _vm._v(" "), _c('div', {
    staticClass: "log-data-section-wrapper"
  }, [_c('div', {
    staticClass: "page-content-body__header"
  }, [_vm._v("\n            E. coli\n          ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Large Cells",
      "type": "number",
      "rules": _vm.formRules.largeCellsRules
    },
    model: {
      value: (_vm.ecoliLargeCells),
      callback: function($$v) {
        _vm.ecoliLargeCells = $$v
      },
      expression: "ecoliLargeCells"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Small Cells",
      "type": "number",
      "rules": _vm.formRules.smallCellsRules
    },
    model: {
      value: (_vm.ecoliSmallCells),
      callback: function($$v) {
        _vm.ecoliSmallCells = $$v
      },
      expression: "ecoliSmallCells"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "log-data-total"
  }, [_vm._v("E. coli (MPN/100mL) = " + _vm._s(_vm.getTotalEcoli))]), _vm._v(" "), (_vm.controls.showAdditionalParams === false) ? _c('div', {
    staticClass: "form-input-sub-text",
    on: {
      "click": _vm.toggleAdditionalParmas
    }
  }, [_vm._v("\n          See More Parameters\n        ")]) : _vm._e(), _vm._v(" "), (_vm.controls.showAdditionalParams === true) ? _c('div', {
    staticClass: "form-input-sub-text",
    on: {
      "click": _vm.toggleAdditionalParmas
    }
  }, [_vm._v("\n          Hide More Parameters\n        ")]) : _vm._e(), _vm._v(" "), (_vm.controls.showAdditionalParams === true) ? _c('div', {
    staticClass: "log-data-section-wrapper"
  }, [_c('div', {
    staticClass: "page-content-body__header page-content-body__header--space-above"
  }, [_vm._v("\n            Additional Parameters\n          ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Air Temperature (*C)",
      "type": "number"
    },
    model: {
      value: (_vm.newLogData.airTemp),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "airTemp", $$v)
      },
      expression: "newLogData.airTemp"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Ammonium (mg/L)",
      "type": "number",
      "rules": _vm.formRules.noNegatives
    },
    model: {
      value: (_vm.newLogData.ammonium),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "ammonium", $$v)
      },
      expression: "newLogData.ammonium"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Chlorophyll a (µg/L)",
      "type": "number",
      "rules": _vm.formRules.noNegatives
    },
    model: {
      value: (_vm.newLogData.chlorophyll),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "chlorophyll", $$v)
      },
      expression: "newLogData.chlorophyll"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Dissolved Oxygen (mg/L)",
      "type": "number",
      "rules": _vm.formRules.noNegatives
    },
    model: {
      value: (_vm.newLogData.dissolvedOxygen),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "dissolvedOxygen", $$v)
      },
      expression: "newLogData.dissolvedOxygen"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Nitrate (mg/L)",
      "type": "number",
      "rules": _vm.formRules.noNegatives
    },
    model: {
      value: (_vm.newLogData.nitrate),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "nitrate", $$v)
      },
      expression: "newLogData.nitrate"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Phosphate (mg/L)",
      "type": "number",
      "rules": _vm.formRules.noNegatives
    },
    model: {
      value: (_vm.newLogData.phosphate),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "phosphate", $$v)
      },
      expression: "newLogData.phosphate"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Secchi Depth (meters)",
      "type": "number",
      "rules": _vm.formRules.noNegatives
    },
    model: {
      value: (_vm.newLogData.secchiDepth),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "secchiDepth", $$v)
      },
      expression: "newLogData.secchiDepth"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Total Chlorine (mg/L)",
      "type": "number",
      "rules": _vm.formRules.noNegatives
    },
    model: {
      value: (_vm.newLogData.totalChlorine),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "totalChlorine", $$v)
      },
      expression: "newLogData.totalChlorine"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Water Temperature (*C)",
      "type": "number",
      "rules": _vm.formRules.noNegatives
    },
    model: {
      value: (_vm.newLogData.waterTemp),
      callback: function($$v) {
        _vm.$set(_vm.newLogData, "waterTemp", $$v)
      },
      expression: "newLogData.waterTemp"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": ""
    },
    model: {
      value: (_vm.controls.showDialog),
      callback: function($$v) {
        _vm.$set(_vm.controls, "showDialog", $$v)
      },
      expression: "controls.showDialog"
    }
  }, [_c('v-btn', {
    staticClass: "btn-nww log-data-submit-btn",
    attrs: {
      "slot": "activator",
      "type": "submit"
    },
    slot: "activator"
  }, [_vm._v("\n            " + _vm._s("Log Data") + "\n          ")]), _vm._v(" "), _c('v-card', {
    staticClass: "card-alert"
  }, [_c('v-card-title', [_c('div', {
    staticClass: "headline log-data-confirm__header"
  }, [_vm._v("Log Data?")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Please confirm that you would like to log data")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "primary": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.controls.showDialog = false
      }
    }
  }, [_vm._v("\n                Cancel\n              ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-nww",
    attrs: {
      "type": "submit"
    },
    nativeOn: {
      "click": function($event) {
        _vm.submitLog($event)
      }
    }
  }, [_vm._v("\n                Confirm\n              ")])], 1)], 1)], 1)], 1)])], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbar.timeout,
      "error": true
    },
    model: {
      value: (_vm.snackbar.errorVisible),
      callback: function($$v) {
        _vm.$set(_vm.snackbar, "errorVisible", $$v)
      },
      expression: "snackbar.errorVisible"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbar.errorMessage) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar.errorVisible = false
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbar.timeout,
      "info": true
    },
    model: {
      value: (_vm.snackbar.successVisible),
      callback: function($$v) {
        _vm.$set(_vm.snackbar, "successVisible", $$v)
      },
      expression: "snackbar.successVisible"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbar.successMessage) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar.successVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-header"
  }, [_c('div', {
    staticClass: "page-content-header__text"
  }, [_vm._v("\n      Log Data\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "page-content-header__subtext--dark"
  }, [_vm._v("\n      Log new data for a collection site\n    ")])])
}]}

/***/ }),

/***/ 441:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "app__footer"
  }, [_c('div', {
    staticClass: "icon-group"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/chattahoocheeriverkeeper/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook icon-group__facebook"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://twitter.com/CRKeeper",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter icon-group__twitter"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/crkeeper/#",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram icon-group__instagram"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://vimeo.com/crkeeper",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-vimeo icon-group__vimeo"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/user/UCRiverkeeperVideos",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-youtube-play icon-group__youtube"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "footer-info"
  }, [_c('div', {
    staticClass: "footer-info__text"
  }, [_vm._v("\n      Copyright\n      "), _c('i', {
    staticClass: "fa fa-copyright",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n      2017 Chattahoochee Riverkeeper | All Rights Reserved\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "footer-info__text"
  }, [_vm._v("\n      Phone (404) 352-9828 |\n      "), _c('a', {
    staticClass: "footer-info__text--underline footer-info__text--active",
    attrs: {
      "href": "mailto:info@chattahoochee.org"
    }
  }, [_vm._v("info@chattahoochee.org")])])])])
}]}

/***/ }),

/***/ 442:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "data-sidebar",
    class: {
      'data-sidebar--collapsed': _vm.showSidebar
    }
  }, [_c('div', {
    staticClass: "data-sidebar__header"
  }, [_c('div', {
    staticClass: "data-sidebar-toggle",
    on: {
      "click": _vm.toggleSidebar
    }
  }, [_c('i', {
    staticClass: "data-sidebar-toggle__caret material-icons"
  }, [_vm._v("arrow_drop_down")])]), _vm._v(" "), _c('div', {
    staticClass: "data-sidebar-search"
  }, [_c('input', {
    staticClass: "data-sidebar-search__input",
    attrs: {
      "placeholder": "Search collection sites"
    },
    on: {
      "input": _vm.debounceInput
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "data-sidebar-search__icon material-icons"
  }, [_vm._v("search")])]), _vm._v(" "), _c('div', {
    staticClass: "filters-toggle",
    on: {
      "click": function($event) {
        _vm.controls.showFilters = !_vm.controls.showFilters
      }
    }
  }, [_c('span', {
    staticClass: "filters-toggle__title"
  }, [_vm._v("\n        Filter\n      ")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons filters-toggle__icon",
    class: {
      'filters-toggle__icon--collapsed': !_vm.controls.showFilters
    }
  }, [_vm._v("\n        arrow_drop_down\n      ")])])]), _vm._v(" "), (_vm.controls.showFilters) ? _c('div', {
    staticClass: "filters"
  }, [_c('div', {
    staticClass: "filters__section"
  }, [_c('div', {
    staticClass: "filters-toggle--secondary",
    on: {
      "click": function($event) {
        _vm.filters.huc = !_vm.filters.huc
      }
    }
  }, [_c('span', {
    staticClass: "filters-toggle__title"
  }, [_vm._v("\n          Subwatersheds (HUC12)\n        ")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons filters-toggle__icon",
    class: {
      'filters-toggle__icon--collapsed': !_vm.filters.huc
    }
  }, [_vm._v("\n          arrow_drop_down\n        ")])]), _vm._v(" "), (_vm.filters.huc) ? _c('div', {
    staticClass: "filter-body"
  }, _vm._l((_vm.hucList), function(huc) {
    return _c('div', {
      key: huc.key,
      staticClass: "filter-body__list-item"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filters.hucFilters),
        expression: "filters.hucFilters"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": huc['.value'],
        "checked": Array.isArray(_vm.filters.hucFilters) ? _vm._i(_vm.filters.hucFilters, huc['.value']) > -1 : (_vm.filters.hucFilters)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.filters.hucFilters,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = huc['.value'],
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.filters.hucFilters = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.filters.hucFilters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.filters, "hucFilters", $$c)
          }
        }
      }
    }), _vm._v("\n          " + _vm._s(huc['.value']) + "\n        ")])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "filters__section"
  }, [_c('div', {
    staticClass: "filters-toggle--secondary",
    on: {
      "click": function($event) {
        _vm.filters.lab = !_vm.filters.lab
      }
    }
  }, [_c('span', {
    staticClass: "filters-toggle__title"
  }, [_vm._v("\n          Lab\n        ")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons filters-toggle__icon",
    class: {
      'filters-toggle__icon--collapsed': !_vm.filters.lab
    }
  }, [_vm._v("\n          arrow_drop_down\n        ")])]), _vm._v(" "), (_vm.filters.lab) ? _c('div', {
    staticClass: "filter-body"
  }, _vm._l((_vm.labs), function(lab) {
    return _c('div', {
      key: lab.key,
      staticClass: "filter-body__list-item"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filters.labFilters),
        expression: "filters.labFilters"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": lab['.value'],
        "checked": Array.isArray(_vm.filters.labFilters) ? _vm._i(_vm.filters.labFilters, lab['.value']) > -1 : (_vm.filters.labFilters)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.filters.labFilters,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = lab['.value'],
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.filters.labFilters = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.filters.labFilters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.filters, "labFilters", $$c)
          }
        }
      }
    }), _vm._v("\n          " + _vm._s(lab['.value']) + "\n        ")])
  })) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "data-sidebar__body"
  }, _vm._l((_vm.filteredResults), function(site) {
    return _c('div', {
      key: site.key,
      staticClass: "data-sidebar-list-item",
      class: {
        'data-sidebar-list-item--active': _vm.selectedSite === site
      },
      on: {
        "click": function($event) {
          _vm.selectActiveSite(site)
        }
      }
    }, [_vm._v("\n       " + _vm._s(site.stationName) + "\n    ")])
  }))])
},staticRenderFns: []}

/***/ }),

/***/ 443:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "site-reports-wrapper"
  }, [_c('div', {
    staticClass: "collection-sites-header"
  }, [_c('div', {
    staticClass: "collection-sites-header__primary-content"
  }, [_c('div', {
    staticClass: "collection-sites-header__header"
  }, [_vm._v("\n        Collection Sites\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "collection-sites-header__subheader--bold"
  }, [_vm._v("\n        " + _vm._s(this.collectionSites.length) + " total sites\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "collection-sites-header__subheader"
  }, [_vm._v("\n        Select a site to view logged data. Create and export reports of logged data for one or many collection sites.\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "collection-sites-header__secondary-content"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "flat-action",
    attrs: {
      "slot": "activator",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleArchived()
      }
    },
    slot: "activator"
  }, [_vm._v("\n            " + _vm._s(_vm.archivedText()) + "\n        ")]), _vm._v(" "), _c('add-collection-site')], 1)], 1)]), _vm._v(" "), _c('v-card', [_c('div', {
    staticClass: "site-reports-body"
  }, [_c('div', {
    staticClass: "site-reports-body-toolbar"
  }, [_c('div', {
    staticClass: "site-reports-body-toolbar__primary-content"
  }, [_c('div', {
    staticClass: "site-reports-toolbar-search"
  }, [_c('i', {
    staticClass: "site-reports-toolbar-search__icon material-icons"
  }, [_vm._v("search")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.controls.search),
      expression: "controls.search"
    }],
    staticClass: "site-reports-toolbar-search__input",
    attrs: {
      "placeholder": "Search collection sites"
    },
    domProps: {
      "value": (_vm.controls.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.controls, "search", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.selected.length > 0) ? _c('div', {
    staticClass: "site-reports-datepickers"
  }, [_c('span', {
    staticClass: "site-reports-body-toolbar__text-content"
  }, [_vm._v("Select export date range:")]), _vm._v(" "), _c('div', {
    staticClass: "site-reports-toolbar-datepicker"
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 0,
      "max-width": "290px"
    },
    model: {
      value: (_vm.controls.startDateModal),
      callback: function($$v) {
        _vm.$set(_vm.controls, "startDateModal", $$v)
      },
      expression: "controls.startDateModal"
    }
  }, [_c('div', {
    staticClass: "site-reports-toolbar-datepicker__activator",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('span', {
    staticClass: "site-reports-toolbar-datepicker__activator-text"
  }, [_vm._v(_vm._s(_vm.startDate ? _vm.startDate : "Start Date"))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-calendar"
  })]), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "actions": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          staticClass: "btn-nww",
          nativeOn: {
            "click": function($event) {
              save()
            }
          }
        }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              cancel()
            }
          }
        }, [_vm._v("Cancel")])], 1)]
      }
    }]),
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "site-reports-toolbar-datepicker"
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 0,
      "max-width": "290px"
    },
    model: {
      value: (_vm.controls.endDateModal),
      callback: function($$v) {
        _vm.$set(_vm.controls, "endDateModal", $$v)
      },
      expression: "controls.endDateModal"
    }
  }, [_c('div', {
    staticClass: "site-reports-toolbar-datepicker__activator",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('span', {
    staticClass: "site-reports-toolbar-datepicker__activator-text"
  }, [_vm._v(_vm._s(_vm.endDate ? _vm.endDate : "Start Date"))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-calendar"
  })]), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "actions": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          staticClass: "btn-nww",
          nativeOn: {
            "click": function($event) {
              save()
            }
          }
        }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              cancel()
            }
          }
        }, [_vm._v("Cancel")])], 1)]
      }
    }]),
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  })], 1)], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "site-reports-body-toolbar__secondary-content"
  }, [_c('div', {
    staticClass: "site-reports-actions"
  }, [(_vm.selected.length === 1) ? _c('edit-collection-site', {
    staticClass: "site-reports-actions__action",
    attrs: {
      "collection-site": _vm.selected[0],
      "post-submit-form": _vm.postSubmitForm
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selected.length === 1 && !_vm.showArchived) ? _c('v-btn', {
    staticClass: "site-reports-actions__action btn btn-nww",
    nativeOn: {
      "click": function($event) {
        _vm.archiveSite(_vm.selected[0])
      }
    }
  }, [_vm._v("\n              Archive\n              "), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("archive")])], 1) : _vm._e(), _vm._v(" "), (_vm.selected.length === 1 && _vm.showArchived) ? _c('v-btn', {
    staticClass: "site-reports-actions__action btn-nww--light btn btn--raised",
    nativeOn: {
      "click": function($event) {
        _vm.unArchiveSite(_vm.selected[0])
      }
    }
  }, [_vm._v("\n              Unarchive\n              "), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("unarchive")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.selected.length > 0) ? _c('div', {
    staticClass: "site-reports-toolbar-export"
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    }
  }, [_c('div', {
    staticClass: "site-reports-toolbar-export__activator",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('div', {
    staticClass: "site-reports-toolbar-export__activator-text"
  }, [_vm._v("\n                  Export\n                ")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_drop_down")])]), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    on: {
      "click": _vm.exportXls
    }
  }, [_c('v-list-tile-title', [_vm._v("\n                    Export as XLS\n                  ")])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.adpotExport
    }
  }, [_c('v-list-tile-title', [_vm._v("\n                    Export for Adopt-A-Stream\n                  ")])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.storetExport
    }
  }, [_c('v-list-tile-title', [_vm._v("\n                    Export for STORET\n                  ")])], 1)], 1)], 1)], 1) : _vm._e()])]), _vm._v(" "), _c('v-card', {
    staticClass: "nww-table nww-table--left-align"
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.collectionSites,
      "pagination": _vm.pagination,
      "search": _vm.controls.search,
      "select-all": "",
      "item-key": "stationName"
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "headerCell",
      fn: function(props) {
        return [_c('span', {
          attrs: {
            "slot": "activator"
          },
          slot: "activator"
        }, [_vm._v("\n              " + _vm._s(props.header.text) + "\n            ")])]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          attrs: {
            "active": props.selected
          },
          on: {
            "click": function($event) {
              props.selected = !props.selected
            }
          }
        }, [_c('td', [_c('v-checkbox', {
          attrs: {
            "primary": "",
            "hide-details": "",
            "input-value": props.selected
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "col-long table-cell__truncate--long"
        }, [_c('router-link', {
          staticClass: "nww-table__primary-link",
          attrs: {
            "to": {
              name: 'Collection Site Data',
              params: {
                siteId: props.item['.key']
              }
            }
          }
        }, [_vm._v("\n                  " + _vm._s(props.item.stationName) + "\n                ")])], 1), _vm._v(" "), _c('td', {
          staticClass: "col-med table-cell__truncate-med"
        }, [_vm._v(_vm._s(props.item.logbookAbbv))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.lab))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.lastCollectionDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.lastEColiResult))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.collectionPartner))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.hucName))]), _vm._v(" "), _c('td', {
          staticClass: "col-long table-cell__truncate--long"
        }, [_vm._v(_vm._s(props.item.adoptAStreamName))]), _vm._v(" "), _c('td', {
          staticClass: "col-long table-cell__truncate--long"
        }, [_vm._v(_vm._s(props.item.aasNumber))]), _vm._v(" "), _c('td', {
          staticClass: "col-long table-cell__truncate--long"
        }, [_vm._v(_vm._s(props.item.storetName))]), _vm._v(" "), _c('td', {
          staticClass: "col-long table-cell__truncate--long"
        }, [_vm._v(_vm._s(props.item.storetId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.numSamples))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.firstCollectionDate))]), _vm._v(" "), _c('td', {
          staticClass: "table-cell__truncate--long"
        }, [_c('a', {
          staticClass: "nww-table__primary-link",
          attrs: {
            "href": props.item.googleMapsUrl,
            "target": "_blank"
          }
        }, [_vm._v("\n                  " + _vm._s(props.item.googleMapsUrl) + "\n                ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.latitude))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.longitude))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.isPrivate))])])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', [_c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbar.timeout,
      "info": true
    },
    model: {
      value: (_vm.snackbar.successVisible),
      callback: function($$v) {
        _vm.$set(_vm.snackbar, "successVisible", $$v)
      },
      expression: "snackbar.successVisible"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.snackbar.successMessage) + "\n      "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar.successVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 444:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "graph-card"
  }, [_c('div', {
    staticClass: "graph-card-title"
  }, [_c('span', {
    staticClass: "graph-card-title__primary"
  }, [_vm._v("\n      E. coli (MPN/100mL)\n      "), _c('v-dialog', {
    attrs: {
      "content-class": "nww-dialog",
      "persistent": ""
    },
    model: {
      value: (_vm.controls.ecoliDialog),
      callback: function($$v) {
        _vm.$set(_vm.controls, "ecoliDialog", $$v)
      },
      expression: "controls.ecoliDialog"
    }
  }, [_c('i', {
    staticClass: "material-icons graph-card-title__icon",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("\n          info_outline\n        ")]), _vm._v(" "), _c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("E. coli")]), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("Escherichia coli (E. coli) is a bacteria that is commonly found in the gastrointestinal tract and feces of warm-blooded animals and humans. According to the U.S. EPA, E. coli is the best indicator of the presence of pathogens in surface waters and its presence provides direct evidence of fecal contamination of the water.")]), _vm._v(" "), _c('p', [_vm._v("EPA recommends an E. coli recreational safety level for primary contact of a geometric average of 126 cfu/100 mL* or less. Because it is common to find high bacteria counts in urban areas, Georgia Adopt-A-Stream advises that counts that exceed a 1000 cfu/100 mL threshold may warrant special attention. NWW results that show a “high” bacterial count may be a one-time event or occurrence or may be a part of a chronic problem. This information is useful, but before taking further action additional sampling is necessary to document bacterial levels over a long period to determine seasonal fluctuations and in response to rain events. This long term information is vital in assessing the overall health of the stream and determining if special attention is warranted to investigate potential pollution sources.")]), _vm._v(" "), _c('p', [_vm._v("*Note that our E. coli results are reported with the units MPN/100mL. The units used by the EPA (cfu/100 mL) are directly correlated to MPN/100 mL (ex. 126 cfu/100 mL = 126 MPN/100 mL).")])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-nww btn btn--raised",
    nativeOn: {
      "click": function($event) {
        _vm.controls.ecoliDialog = false
      }
    }
  }, [_vm._v("\n              Okay\n            ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "graph-card-title__secondary--strong"
  }, [_vm._v("\n        Last Result:\n      ")]), _vm._v(" "), (_vm.selectedSite) ? _c('span', {
    staticClass: "graph-card-title__secondary"
  }, [_vm._v("\n        " + _vm._s(_vm.selectedSite.lastEColiResult) + "\n        on\n        " + _vm._s(_vm._f("formatDate")(_vm.selectedSite.lastCollectionDate)) + "\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "graph-card__graph-wrapper"
  }, [_c('vue-highcharts', {
    ref: "ecoliChart",
    attrs: {
      "id": "chart1",
      "options": _vm.options
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 445:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "graph-card"
  }, [_c('div', {
    staticClass: "graph-card-title"
  }, [_c('span', {
    staticClass: "graph-card-title__primary"
  }, [_vm._v("\n      Turbidity (NTU)\n      "), _c('v-dialog', {
    attrs: {
      "content-class": "nww-dialog",
      "persistent": ""
    },
    model: {
      value: (_vm.controls.turbidityDialog),
      callback: function($$v) {
        _vm.$set(_vm.controls, "turbidityDialog", $$v)
      },
      expression: "controls.turbidityDialog"
    }
  }, [_c('i', {
    staticClass: "material-icons graph-card-title__icon",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("\n          info_outline\n        ")]), _vm._v(" "), _c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Turbidity")]), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("Turbidity is the measure of the relative clarity of water. High levels of turbidity are a result of the presence of suspended and dissolved matter, such as clay, silt, finely divided organic matter, plankton and other microscopic organisms, organic acids, and dyes. We typically see the highest turbidity levels during and after heavy rain events. During a rainstorm, particles from the surrounding land are washed into the river making the water a muddy brown color, indicating water that has higher turbidity values. Also, during high flows, water velocities are faster and water volumes are higher, which can more easily stir up and suspend material from the stream bed, causing higher turbidity levels.")])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-nww btn btn--raised",
    nativeOn: {
      "click": function($event) {
        _vm.controls.turbidityDialog = false
      }
    }
  }, [_vm._v("Okay")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "graph-card-title__secondary--strong"
  }, [_vm._v("\n        Last Result:\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "graph-card-title__secondary"
  }, [_vm._v("\n        " + _vm._s(_vm.selectedSite ? _vm.selectedSite.lastTurbidityResult : null) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "graph-card__graph-wrapper"
  }, [_c('vue-highcharts', {
    ref: "turbidityChart",
    attrs: {
      "id": "chart2",
      "options": _vm.options
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 446:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.selectedSite) ? _c('div', {
    staticClass: "data-map-banner"
  }, [_c('div', {
    staticClass: "data-map-banner__header"
  }, [_vm._v("\n    " + _vm._s(_vm.selectedSite.stationName) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "data-map-banner__row"
  }, [_c('div', {
    staticClass: "data-map-banner__text data-map-banner__text--strong"
  }, [_vm._v("\n      Collected by:\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "data-map-banner__text"
  }, [_vm._v("\n      " + _vm._s(_vm.selectedSite.collectionPartner) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "data-map-banner__row"
  }, [_c('div', {
    staticClass: "data-map-banner__text data-map-banner__text--strong"
  }, [_vm._v("\n      Watershed Unit (HUC):\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "data-map-banner__text"
  }, [_vm._v("\n      " + _vm._s(_vm.selectedSite.hucName) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "data-map-banner__row"
  }, [_c('div', {
    staticClass: "data-map-banner__text data-map-banner__text--strong"
  }, [_vm._v("\n      First collected:\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "data-map-banner__text"
  }, [_vm._v("\n      " + _vm._s(_vm._f("formatDate")(_vm.selectedSite.firstCollectionDate)) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "data-map-banner__row data-map-banner__row--top-space"
  }, [_c('div', {
    staticClass: "data-map-banner__text data-map-banner__text--nww data-map-banner__text--strong"
  }, [_vm._v("\n      Last E. coli Result:\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "data-map-banner__text data-map-banner__text--nww"
  }, [_vm._v("\n      " + _vm._s(_vm.selectedSite.lastEColiResult) + " (MPN/100mL) on " + _vm._s(_vm._f("formatDate")(_vm.selectedSite.lastCollectionDate)) + "\n    ")])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 447:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('div', {
    staticClass: "app",
    attrs: {
      "id": "app"
    }
  }, [_c('app-nav'), _vm._v(" "), _c('div', {
    staticClass: "app__wrapper"
  }, [_c('div', {
    staticClass: "app__body"
  }, [_c('router-view')], 1)]), _vm._v(" "), _c('app-footer')], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 448:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "full-width": "",
      "overlay": true
    },
    model: {
      value: (_vm.controls.showDialog),
      callback: function($$v) {
        _vm.$set(_vm.controls, "showDialog", $$v)
      },
      expression: "controls.showDialog"
    }
  }, [_c('v-btn', {
    staticClass: "site-reports-actions__action site-reports-actions__action--no-margin btn btn-nww",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("\n      Edit\n      "), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-card', [_c('div', {
    staticClass: "page-content-header"
  }, [_c('div', {
    staticClass: "page-content-header__text"
  }, [_vm._v("\n            Edit Log Data\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "page-content-header__subtext--dark"
  }, [_vm._v("\n            Log new data for a collection site\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "page-content-body"
  }, [_c('v-form', {
    ref: "form",
    staticClass: "page-content-body__form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.controls.showConfirmDialog = true
      }
    },
    model: {
      value: (_vm.formValid),
      callback: function($$v) {
        _vm.formValid = $$v
      },
      expression: "formValid"
    }
  }, [_c('div', {
    staticClass: "page-content-body__column"
  }, [_c('div', {
    staticClass: "page-content-body__header"
  }, [_vm._v("\n                Collection Details\n              ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Logbook Number",
      "disabled": ""
    },
    model: {
      value: (_vm.targetLogData.logbookNumber),
      callback: function($$v) {
        _vm.$set(_vm.targetLogData, "logbookNumber", $$v)
      },
      expression: "targetLogData.logbookNumber"
    }
  }), _vm._v(" "), _c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 0,
      "max-width": "290px"
    },
    model: {
      value: (_vm.controls.showDatepicker),
      callback: function($$v) {
        _vm.$set(_vm.controls, "showDatepicker", $$v)
      },
      expression: "controls.showDatepicker"
    }
  }, [_c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "slot": "activator",
      "label": "Date",
      "append-icon": "event",
      "rules": [function (v) { return !!v || 'Collection Date is required'; }],
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.targetLogData.collectionDate),
      callback: function($$v) {
        _vm.$set(_vm.targetLogData, "collectionDate", $$v)
      },
      expression: "targetLogData.collectionDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "actions": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          staticClass: "btn btn-nww",
          nativeOn: {
            "click": function($event) {
              save()
            }
          }
        }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "color": "primary"
          },
          nativeOn: {
            "click": function($event) {
              cancel()
            }
          }
        }, [_vm._v("Cancel")])], 1)]
      }
    }]),
    model: {
      value: (_vm.targetLogData.collectionDate),
      callback: function($$v) {
        _vm.$set(_vm.targetLogData, "collectionDate", $$v)
      },
      expression: "targetLogData.collectionDate"
    }
  })], 1), _vm._v(" "), _c('v-select', {
    staticClass: "input-group--limit-height",
    attrs: {
      "items": _vm.collectionSites,
      "item-disabled": "true",
      "label": "Collection Site",
      "autocomplete": "",
      "item-text": "stationName",
      "rules": [function (v) { return !!v || 'Collection Site is required'; }],
      "bottom": ""
    },
    model: {
      value: (_vm.selectedSite),
      callback: function($$v) {
        _vm.selectedSite = $$v
      },
      expression: "selectedSite"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "name": "input-5-1",
      "label": "Notes"
    },
    model: {
      value: (_vm.targetLogData.notes),
      callback: function($$v) {
        _vm.$set(_vm.targetLogData, "notes", $$v)
      },
      expression: "targetLogData.notes"
    }
  }), _vm._v(" "), _c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px"
    },
    model: {
      value: (_vm.controls.collectionTimeMenu),
      callback: function($$v) {
        _vm.$set(_vm.controls, "collectionTimeMenu", $$v)
      },
      expression: "controls.collectionTimeMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Collection Time"
    },
    slot: "activator",
    model: {
      value: (_vm.targetLogData.collectionTime),
      callback: function($$v) {
        _vm.$set(_vm.targetLogData, "collectionTime", $$v)
      },
      expression: "targetLogData.collectionTime"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    attrs: {
      "autosave": "",
      "format": "24hr"
    },
    model: {
      value: (_vm.targetLogData.collectionTime),
      callback: function($$v) {
        _vm.$set(_vm.targetLogData, "collectionTime", $$v)
      },
      expression: "targetLogData.collectionTime"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Rainfall (in) [trace = 0.001]",
      "type": "number",
      "step": "0.01",
      "rules": _vm.formRules.precipitation
    },
    model: {
      value: (_vm.targetLogData.precipitation),
      callback: function($$v) {
        _vm.$set(_vm.targetLogData, "precipitation", $$v)
      },
      expression: "targetLogData.precipitation"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "form-input-sub-text",
    attrs: {
      "target": "_blank",
      "href": "https://www.wunderground.com/history/"
    }
  }, [_vm._v("Rainfall value from Weather Underground")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Analyst (Initials)",
      "required": "",
      "rules": _vm.formRules.required
    },
    model: {
      value: (_vm.targetLogData.analyst),
      callback: function($$v) {
        _vm.$set(_vm.targetLogData, "analyst", $$v)
      },
      expression: "targetLogData.analyst"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content-body__column"
  }, [_c('div', {
    staticClass: "page-content-body__header"
  }, [_vm._v("\n                Incubation and Parameters\n              ")]), _vm._v(" "), _c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px"
    },
    model: {
      value: (_vm.controls.incubationInMenu),
      callback: function($$v) {
        _vm.$set(_vm.controls, "incubationInMenu", $$v)
      },
      expression: "controls.incubationInMenu"
    }
  }, [_c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "slot": "activator",
      "label": "Incubation In Time",
      "readonly": "",
      "rules": _vm.formRules.incubationTimeRules
    },
    slot: "activator",
    model: {
      value: (_vm.targetLogData.incubationTime),
      callback: function($$v) {
        _vm.$set(_vm.targetLogData, "incubationTime", $$v)
      },
      expression: "targetLogData.incubationTime"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    attrs: {
      "format": "24hr"
    },
    model: {
      value: (_vm.targetLogData.incubationTime),
      callback: function($$v) {
        _vm.$set(_vm.targetLogData, "incubationTime", $$v)
      },
      expression: "targetLogData.incubationTime"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Incubation Temp (*C)",
      "type": "number",
      "rules": _vm.formRules.incubationTempRules
    },
    model: {
      value: (_vm.targetLogData.incubationTemp),
      callback: function($$v) {
        _vm.$set(_vm.targetLogData, "incubationTemp", $$v)
      },
      expression: "targetLogData.incubationTemp"
    }
  }), _vm._v(" "), _c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px"
    },
    model: {
      value: (_vm.controls.incubationOutMenu),
      callback: function($$v) {
        _vm.$set(_vm.controls, "incubationOutMenu", $$v)
      },
      expression: "controls.incubationOutMenu"
    }
  }, [_c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "slot": "activator",
      "label": "Incubation Out Time",
      "readonly": "",
      "rules": _vm.formRules.incubationOutTimeRules
    },
    slot: "activator",
    model: {
      value: (_vm.targetLogData.incubationOut),
      callback: function($$v) {
        _vm.$set(_vm.targetLogData, "incubationOut", $$v)
      },
      expression: "targetLogData.incubationOut"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    attrs: {
      "format": "24hr"
    },
    model: {
      value: (_vm.targetLogData.incubationOut),
      callback: function($$v) {
        _vm.$set(_vm.targetLogData, "incubationOut", $$v)
      },
      expression: "targetLogData.incubationOut"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "# mL/100mL (Dilution)",
      "type": "number",
      "rules": _vm.formRules.dilutionRules
    },
    model: {
      value: (_vm.targetLogData.dilution),
      callback: function($$v) {
        _vm.$set(_vm.targetLogData, "dilution", $$v)
      },
      expression: "targetLogData.dilution"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Fluorometry",
      "type": "number",
      "step": "0.01",
      "rules": _vm.formRules.fluorometryRules
    },
    model: {
      value: (_vm.targetLogData.fluorometry),
      callback: function($$v) {
        _vm.$set(_vm.targetLogData, "fluorometry", $$v)
      },
      expression: "targetLogData.fluorometry"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Turbidity (NTU)",
      "type": "number",
      "step": "0.01",
      "rules": _vm.formRules.turbidityRules
    },
    model: {
      value: (_vm.targetLogData.turbidity),
      callback: function($$v) {
        _vm.$set(_vm.targetLogData, "turbidity", $$v)
      },
      expression: "targetLogData.turbidity"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Conductivity (µS)",
      "type": "number",
      "step": "0.01",
      "rules": _vm.formRules.conductivityRules
    },
    model: {
      value: (_vm.targetLogData.specificConductivity),
      callback: function($$v) {
        _vm.$set(_vm.targetLogData, "specificConductivity", $$v)
      },
      expression: "targetLogData.specificConductivity"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Typical range for Conductivity is 0 - 750")])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content-body__column page-content-body__column--end"
  }, [_c('div', {
    staticClass: "log-data-section-wrapper"
  }, [_c('div', {
    staticClass: "page-content-body__header"
  }, [_vm._v("\n                  Total Coliform\n                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Large Cells",
      "type": "number",
      "rules": _vm.formRules.largeCellsRules
    },
    model: {
      value: (_vm.targetLogData.coliformLargeCells),
      callback: function($$v) {
        _vm.$set(_vm.targetLogData, "coliformLargeCells", $$v)
      },
      expression: "targetLogData.coliformLargeCells"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Small Cells",
      "type": "number",
      "rules": _vm.formRules.smallCellsRules
    },
    model: {
      value: (_vm.targetLogData.coliformSmallCells),
      callback: function($$v) {
        _vm.$set(_vm.targetLogData, "coliformSmallCells", $$v)
      },
      expression: "targetLogData.coliformSmallCells"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "log-data-total"
  }, [_vm._v("Total Coliform (MPN/100mL) = " + _vm._s(_vm.getTotalColiform))]), _vm._v(" "), _c('div', {
    staticClass: "log-data-section-wrapper"
  }, [_c('div', {
    staticClass: "page-content-body__header"
  }, [_vm._v("\n                  E. coli\n                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Large Cells",
      "type": "number",
      "rules": _vm.formRules.largeCellsRules
    },
    model: {
      value: (_vm.ecoliLargeCells),
      callback: function($$v) {
        _vm.ecoliLargeCells = $$v
      },
      expression: "ecoliLargeCells"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Small Cells",
      "type": "number",
      "rules": _vm.formRules.smallCellsRules
    },
    model: {
      value: (_vm.ecoliSmallCells),
      callback: function($$v) {
        _vm.ecoliSmallCells = $$v
      },
      expression: "ecoliSmallCells"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "log-data-total"
  }, [_vm._v("E. coli (MPN/100mL) = " + _vm._s(_vm.getTotalEcoli))]), _vm._v(" "), (_vm.controls.showAdditionalParams === false) ? _c('div', {
    staticClass: "form-input-sub-text",
    on: {
      "click": _vm.toggleAdditionalParmas
    }
  }, [_vm._v("\n                See More Parameters\n              ")]) : _vm._e(), _vm._v(" "), (_vm.controls.showAdditionalParams === true) ? _c('div', {
    staticClass: "form-input-sub-text",
    on: {
      "click": _vm.toggleAdditionalParmas
    }
  }, [_vm._v("\n                Hide More Parameters\n              ")]) : _vm._e(), _vm._v(" "), (_vm.controls.showAdditionalParams === true) ? _c('div', {
    staticClass: "log-data-section-wrapper"
  }, [_c('div', {
    staticClass: "page-content-body__header page-content-body__header--space-above"
  }, [_vm._v("\n                  Additional Parameters\n                ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Air Temperature (*C)",
      "type": "number",
      "rules": _vm.formRules.noNegatives
    },
    model: {
      value: (_vm.targetLogData.airTemp),
      callback: function($$v) {
        _vm.$set(_vm.targetLogData, "airTemp", $$v)
      },
      expression: "targetLogData.airTemp"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Water Temperature (*C)",
      "type": "number",
      "rules": _vm.formRules.noNegatives
    },
    model: {
      value: (_vm.targetLogData.waterTemp),
      callback: function($$v) {
        _vm.$set(_vm.targetLogData, "waterTemp", $$v)
      },
      expression: "targetLogData.waterTemp"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Secchi Depth (meters)",
      "type": "number",
      "rules": _vm.formRules.noNegatives
    },
    model: {
      value: (_vm.targetLogData.secchiDepth),
      callback: function($$v) {
        _vm.$set(_vm.targetLogData, "secchiDepth", $$v)
      },
      expression: "targetLogData.secchiDepth"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Dissolved Oxygen (mg/L)",
      "type": "number",
      "rules": _vm.formRules.noNegatives
    },
    model: {
      value: (_vm.targetLogData.dissolvedOxygen),
      callback: function($$v) {
        _vm.$set(_vm.targetLogData, "dissolvedOxygen", $$v)
      },
      expression: "targetLogData.dissolvedOxygen"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Nitrate (mg/L)",
      "type": "number",
      "rules": _vm.formRules.noNegatives
    },
    model: {
      value: (_vm.targetLogData.nitrate),
      callback: function($$v) {
        _vm.$set(_vm.targetLogData, "nitrate", $$v)
      },
      expression: "targetLogData.nitrate"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Phosphate (mg/L)",
      "type": "number",
      "rules": _vm.formRules.noNegatives
    },
    model: {
      value: (_vm.targetLogData.phosphate),
      callback: function($$v) {
        _vm.$set(_vm.targetLogData, "phosphate", $$v)
      },
      expression: "targetLogData.phosphate"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Ammonium (mg/L)",
      "type": "number",
      "rules": _vm.formRules.noNegatives
    },
    model: {
      value: (_vm.targetLogData.ammonium),
      callback: function($$v) {
        _vm.$set(_vm.targetLogData, "ammonium", $$v)
      },
      expression: "targetLogData.ammonium"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Total Chlorine (mg/L)",
      "type": "number",
      "rules": _vm.formRules.noNegatives
    },
    model: {
      value: (_vm.targetLogData.totalChlorine),
      callback: function($$v) {
        _vm.$set(_vm.targetLogData, "totalChlorine", $$v)
      },
      expression: "targetLogData.totalChlorine"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--limit-height",
    attrs: {
      "label": "Chlorophyll (µg/L)",
      "type": "number",
      "rules": _vm.formRules.noNegatives
    },
    model: {
      value: (_vm.targetLogData.chlorophyll),
      callback: function($$v) {
        _vm.$set(_vm.targetLogData, "chlorophyll", $$v)
      },
      expression: "targetLogData.chlorophyll"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex log-data-btn-row"
  }, [_c('v-btn', {
    staticClass: "btn",
    attrs: {
      "slot": "activator",
      "flat": "",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.close($event)
      }
    },
    slot: "activator"
  }, [_vm._v("\n                  Cancel\n                ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-nww",
    attrs: {
      "slot": "activator",
      "type": "submit"
    },
    nativeOn: {
      "click": function($event) {
        _vm.submitLog($event)
      }
    },
    slot: "activator"
  }, [_vm._v("\n                  Save Data\n                ")])], 1)])])], 1)]), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbar.timeout,
      "error": true
    },
    model: {
      value: (_vm.snackbar.errorVisible),
      callback: function($$v) {
        _vm.$set(_vm.snackbar, "errorVisible", $$v)
      },
      expression: "snackbar.errorVisible"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.snackbar.errorMessage) + "\n      "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar.errorVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbar.timeout,
      "info": true
    },
    model: {
      value: (_vm.snackbar.successVisible),
      callback: function($$v) {
        _vm.$set(_vm.snackbar, "successVisible", $$v)
      },
      expression: "snackbar.successVisible"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbar.successMessage) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar.successVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 449:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#",
      "id": _vm.id_name
    },
    on: {
      "click": _vm.generate
    }
  }, [_vm._t("default", [_vm._v("\n    " + _vm._s(_vm.button_text) + "\n  ")])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 450:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "overlay": false
    },
    model: {
      value: (_vm.controls.showDialog),
      callback: function($$v) {
        _vm.$set(_vm.controls, "showDialog", $$v)
      },
      expression: "controls.showDialog"
    }
  }, [_c('v-btn', {
    staticClass: "site-reports-actions__action site-reports-actions__action--no-margin btn btn-nww",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("\n      Edit\n      "), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), (_vm.targetCollectionSite) ? _c('v-card', [_c('div', {
    staticClass: "page-content-header"
  }, [_c('div', {
    staticClass: "page-content-header__text"
  }, [_vm._v("\n          Edit Collection Site\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "page-content-body"
  }, [_c('form', {
    staticClass: "add-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitForm($event)
      }
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Station Name",
      "required": ""
    },
    model: {
      value: (_vm.targetCollectionSite.stationName),
      callback: function($$v) {
        _vm.$set(_vm.targetCollectionSite, "stationName", $$v)
      },
      expression: "targetCollectionSite.stationName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Logbook Abbreviation",
      "required": ""
    },
    model: {
      value: (_vm.targetCollectionSite.logbookAbbv),
      callback: function($$v) {
        _vm.$set(_vm.targetCollectionSite, "logbookAbbv", $$v)
      },
      expression: "targetCollectionSite.logbookAbbv"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.labSet,
      "item-text": ".value",
      "item-value": ".value",
      "label": "Lab",
      "required": "",
      "bottom": ""
    },
    model: {
      value: (_vm.targetCollectionSite.lab),
      callback: function($$v) {
        _vm.$set(_vm.targetCollectionSite, "lab", $$v)
      },
      expression: "targetCollectionSite.lab"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Latitude (eg. 34.004401)",
      "required": ""
    },
    model: {
      value: (_vm.targetCollectionSite.latitude),
      callback: function($$v) {
        _vm.$set(_vm.targetCollectionSite, "latitude", $$v)
      },
      expression: "targetCollectionSite.latitude"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Longitude (eg. -84.350555)",
      "required": ""
    },
    model: {
      value: (_vm.targetCollectionSite.longitude),
      callback: function($$v) {
        _vm.$set(_vm.targetCollectionSite, "longitude", $$v)
      },
      expression: "targetCollectionSite.longitude"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.hucSet,
      "label": "Subwatershed (HUC 12) Name",
      "autocomplete": "",
      "bottom": ""
    },
    model: {
      value: (_vm.targetCollectionSite.hucName),
      callback: function($$v) {
        _vm.$set(_vm.targetCollectionSite, "hucName", $$v)
      },
      expression: "targetCollectionSite.hucName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Adopt-A-Stream Name"
    },
    model: {
      value: (_vm.targetCollectionSite.adoptAStreamName),
      callback: function($$v) {
        _vm.$set(_vm.targetCollectionSite, "adoptAStreamName", $$v)
      },
      expression: "targetCollectionSite.adoptAStreamName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Adopt-A-Stream 'S' ID (eg. S-4475)",
      "rules": [function (v) { return !!v || 'Enter the 4 numbers after S- only (Leave blank if no ID)'; }]
    },
    model: {
      value: (_vm.targetCollectionSite.aasNumber),
      callback: function($$v) {
        _vm.$set(_vm.targetCollectionSite, "aasNumber", $$v)
      },
      expression: "targetCollectionSite.aasNumber"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "STORET Name"
    },
    model: {
      value: (_vm.targetCollectionSite.storetName),
      callback: function($$v) {
        _vm.$set(_vm.targetCollectionSite, "storetName", $$v)
      },
      expression: "targetCollectionSite.storetName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "STORET Location ID (eg. NWW24)"
    },
    model: {
      value: (_vm.targetCollectionSite.storetId),
      callback: function($$v) {
        _vm.$set(_vm.targetCollectionSite, "storetId", $$v)
      },
      expression: "targetCollectionSite.storetId"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.partnerSet,
      "item-text": ".value",
      "item-value": ".value",
      "label": "Collection Partner",
      "bottom": ""
    },
    model: {
      value: (_vm.targetCollectionSite.collectionPartner),
      callback: function($$v) {
        _vm.$set(_vm.targetCollectionSite, "collectionPartner", $$v)
      },
      expression: "targetCollectionSite.collectionPartner"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": ("" + (_vm.targetCollectionSite.isPrivate ? 'Check this box to hide from map (make private)' : 'Check this box to hide from map (make private)')),
      "success": ""
    },
    model: {
      value: (_vm.targetCollectionSite.isPrivate),
      callback: function($$v) {
        _vm.$set(_vm.targetCollectionSite, "isPrivate", $$v)
      },
      expression: "targetCollectionSite.isPrivate"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('v-btn', {
    staticClass: "btn-nww",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save Site")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn",
    attrs: {
      "flat": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.close($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', [_c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbar.timeout,
      "error": true
    },
    model: {
      value: (_vm.snackbar.errorVisible),
      callback: function($$v) {
        _vm.$set(_vm.snackbar, "errorVisible", $$v)
      },
      expression: "snackbar.errorVisible"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.snackbar.errorMessage) + "\n        "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar.errorVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 451:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "site-reports-wrapper"
  }, [_c('div', {
    staticClass: "collection-sites-header"
  }, [_c('div', {
    staticClass: "collection-sites-header__primary-content"
  }, [_c('div', {
    staticClass: "collection-sites-header__header"
  }, [_vm._v("\n        " + _vm._s(_vm.site ? _vm.site.stationName : '') + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "collection-sites-header__subheader-wrapper"
  }, [_c('router-link', {
    staticClass: "collection-sites-header__subheader--nww",
    attrs: {
      "to": {
        name: 'Collection Sites'
      }
    }
  }, [_vm._v("\n          Back to List of Collection Sites\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "collection-data-group"
  }, [_c('div', {
    staticClass: "collection-data-group__row"
  }, [_c('span', {
    staticClass: "collection-data-group__text--strong"
  }, [_vm._v("\n            Subwatershed (HUC12):\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "collection-data-group__text"
  }, [_vm._v("\n            " + _vm._s(_vm.site ? _vm.site.hucName : '') + "\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "collection-data-group__divider"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', {
    staticClass: "collection-data-group__text--strong"
  }, [_vm._v("\n            Lab:\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "collection-data-group__text"
  }, [_vm._v("\n            " + _vm._s(_vm.site ? _vm.site.lab : '') + "\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "collection-data-group__divider"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', {
    staticClass: "collection-data-group__text--strong"
  }, [_vm._v("\n            Collection Partner:\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "collection-data-group__text"
  }, [_vm._v("\n            " + _vm._s(_vm.site ? _vm.site.collectionPartner : '') + "\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "collection-data-group__divider"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', {
    staticClass: "collection-data-group__text--strong"
  }, [_vm._v("\n            Total Samples:\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "collection-data-group__text"
  }, [_vm._v("\n            " + _vm._s(_vm.site ? _vm.reports.length : '') + "\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "collection-data-group__divider"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', {
    staticClass: "collection-data-group__text--strong"
  }, [_vm._v("\n            First Collection Date:\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "collection-data-group__text"
  }, [_vm._v("\n            " + _vm._s(_vm.site ? _vm.site.firstCollectionDate : '') + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "collection-data-group__row"
  }, [_c('a', {
    staticClass: "collection-data-group__link",
    attrs: {
      "href": _vm.getGoogleMapsUrl,
      "target": "_blank"
    }
  }, [_vm._v("\n            View Site on Google Maps\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "collection-sites-header__secondary-content"
  }, [_c('router-link', {
    staticClass: "log-new-data-btn",
    attrs: {
      "to": {
        name: 'Log Data Id',
        params: {
          'id': _vm.$route.params.siteId
        }
      }
    }
  }, [_c('v-btn', {
    staticClass: "btn-nww--light"
  }, [_vm._v("\n          Log New Data\n        ")])], 1)], 1)]), _vm._v(" "), _c('v-card', [_c('div', {
    staticClass: "site-reports-body"
  }, [_c('div', {
    staticClass: "site-reports-body-toolbar"
  }, [_c('div', {
    staticClass: "site-reports-body-toolbar__primary-content"
  }, [_c('div', {
    staticClass: "site-reports-toolbar-search"
  }, [_c('i', {
    staticClass: "site-reports-toolbar-search__icon material-icons"
  }, [_vm._v("search")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.controls.search),
      expression: "controls.search"
    }],
    staticClass: "site-reports-toolbar-search__input",
    attrs: {
      "placeholder": "Search reports"
    },
    domProps: {
      "value": (_vm.controls.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.controls, "search", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "site-reports-datepickers"
  }, [_c('span', {
    staticClass: "site-reports-body-toolbar__text-content"
  }, [_vm._v("Select export date range:")]), _vm._v(" "), _c('div', {
    staticClass: "site-reports-toolbar-datepicker"
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 0,
      "max-width": "290px"
    },
    model: {
      value: (_vm.controls.startDateModal),
      callback: function($$v) {
        _vm.$set(_vm.controls, "startDateModal", $$v)
      },
      expression: "controls.startDateModal"
    }
  }, [_c('div', {
    staticClass: "site-reports-toolbar-datepicker__activator",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('span', {
    staticClass: "site-reports-toolbar-datepicker__activator-text"
  }, [_vm._v(_vm._s(_vm.startDate ? _vm.startDate : "Start Date"))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-calendar"
  })]), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "actions": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          staticClass: "btn btn-nww",
          nativeOn: {
            "click": function($event) {
              save()
            }
          }
        }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "color": "info"
          },
          nativeOn: {
            "click": function($event) {
              cancel()
            }
          }
        }, [_vm._v("Cancel")])], 1)]
      }
    }]),
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "site-reports-toolbar-datepicker"
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 0,
      "max-width": "290px"
    },
    model: {
      value: (_vm.controls.endDateModal),
      callback: function($$v) {
        _vm.$set(_vm.controls, "endDateModal", $$v)
      },
      expression: "controls.endDateModal"
    }
  }, [_c('div', {
    staticClass: "site-reports-toolbar-datepicker__activator",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('span', {
    staticClass: "site-reports-toolbar-datepicker__activator-text"
  }, [_vm._v(_vm._s(_vm.endDate ? _vm.endDate : "Start Date"))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-calendar"
  })]), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "actions": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          staticClass: "btn btn-nww",
          nativeOn: {
            "click": function($event) {
              save()
            }
          }
        }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "color": "info"
          },
          nativeOn: {
            "click": function($event) {
              cancel()
            }
          }
        }, [_vm._v("Cancel")])], 1)]
      }
    }]),
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "site-reports-body-toolbar__secondary-content"
  }, [_c('div', {
    staticClass: "site-reports-actions"
  }, [(_vm.selected.length === 1) ? _c('edit-log-data', {
    attrs: {
      "table-log-data": _vm.selected[0],
      "reset-selected": _vm.resetSelected,
      "route-collection-site-id": _vm.$route.params.siteId,
      "post-submit-form": _vm.postSubmitForm
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selected.length > 0) ? _c('v-btn', {
    staticClass: "site-reports-actions__action btn btn-nww",
    attrs: {
      "color": "error"
    },
    nativeOn: {
      "click": function($event) {
        _vm.controls.showDeleteDialog = true
      }
    }
  }, [_vm._v("\n                Delete\n              "), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("delete")])], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": ""
    },
    model: {
      value: (_vm.controls.showDeleteDialog),
      callback: function($$v) {
        _vm.$set(_vm.controls, "showDeleteDialog", $$v)
      },
      expression: "controls.showDeleteDialog"
    }
  }, [_c('v-card', {
    staticClass: "card-alert"
  }, [_c('v-card-title', [_c('div', {
    staticClass: "headline log-data-confirm__header"
  }, [_vm._v("Delete Data?")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Please confirm that you would like to permenantly delete this data")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "info",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.controls.showDeleteDialog = false
      }
    }
  }, [_vm._v("\n                    Cancel\n                  ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-nww",
    attrs: {
      "type": "submit"
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteSelected(_vm.selected)
      }
    }
  }, [_vm._v("\n                    Delete Forever\n                  ")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.selected.length === 0) ? _c('div', {
    staticClass: "site-reports-toolbar-export"
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    }
  }, [_c('div', {
    staticClass: "site-reports-toolbar-export__activator",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('div', {
    staticClass: "site-reports-toolbar-export__activator-text"
  }, [_vm._v("\n                  Export\n                ")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_drop_down")])]), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    on: {
      "click": _vm.exportXls
    }
  }, [_c('v-list-tile-title', [_vm._v("\n                    Export as XLS\n                  ")])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.adpotExport
    }
  }, [_c('v-list-tile-title', [_vm._v("\n                    Export for Adopt-A-Stream\n                  ")])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.storetExport
    }
  }, [_c('v-list-tile-title', [_vm._v("\n                    Export for STORET\n                  ")])], 1)], 1)], 1)], 1) : _vm._e()])]), _vm._v(" "), _c('v-card', {
    staticClass: "nww-table nww-table--left-align"
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.reports,
      "pagination": _vm.pagination,
      "search": _vm.controls.search,
      "select-all": "",
      "item-key": ".key"
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "nww-table__header",
          attrs: {
            "active": props.selected
          },
          on: {
            "click": function($event) {
              props.selected = !props.selected
            }
          }
        }, [_c('th', [_c('v-checkbox', {
          attrs: {
            "primary": "",
            "hide-details": "",
            "input-value": props.all,
            "indeterminate": props.indeterminate
          },
          nativeOn: {
            "click": function($event) {
              _vm.toggleAll($event)
            }
          }
        })], 1), _vm._v(" "), _vm._l((props.headers), function(header) {
          return _c('th', {
            key: header.value,
            class: ['text-sm-left', 'column sortable', _vm.pagination.descending ? 'desc' : 'asc', header.value === _vm.pagination.sortBy ? 'active' : ''],
            on: {
              "click": function($event) {
                _vm.changeSort(header.value)
              }
            }
          }, [_vm._v("\n                " + _vm._s(header.text) + "\n                "), _c('v-icon', [_vm._v("arrow_upward")])], 1)
        })], 2)]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          attrs: {
            "active": props.selected
          },
          on: {
            "click": function($event) {
              props.selected = !props.selected
            }
          }
        }, [_c('td', [_c('v-checkbox', {
          attrs: {
            "primary": "",
            "hide-detail": "",
            "input-value": props.selected
          }
        })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.logbookNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.collectionDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.collectionTime))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.analyst))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.totalColiform))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.totalEcoli))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.fluorometry))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.turbidity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.specificConductivity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.precipitation))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.incubationTime))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.dilution))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.incubationTemp))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.incubationOut))]), _vm._v(" "), _c('td', {
          staticClass: "col-long table-cell__truncate--long"
        }, [_vm._v(_vm._s(props.item.notes))])])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)], 1)]), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbar.timeout,
      "error": true
    },
    model: {
      value: (_vm.snackbar.deleteVisible),
      callback: function($$v) {
        _vm.$set(_vm.snackbar, "deleteVisible", $$v)
      },
      expression: "snackbar.deleteVisible"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbar.deleteSuccessMessage) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar.deleteVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 452:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data-page-wrapper"
  }, [_c('filter-sidebar', {
    attrs: {
      "selected-site": _vm.selectedSite,
      "show-sidebar": _vm.controls.sidebar,
      "collection-sites": _vm.collectionSites
    },
    on: {
      "selected": _vm.setActiveSite,
      "toggleside": _vm.toggleSidebar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "data-body",
    class: {
      'data-body--collapsed': _vm.controls.sidebar
    }
  }, [_c('div', {
    staticClass: "data-body__dynamic-column"
  }, [_c('div', {
    staticClass: "data-map"
  }, [_c('data-map-banner', {
    attrs: {
      "selected-site": _vm.selectedSite
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "data-map__menu",
    attrs: {
      "id": "menu"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mapboxgl-ctrl mapboxgl-ctrl-group",
    attrs: {
      "id": "zoomContainer"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "data-map__map",
    attrs: {
      "id": "map"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-body__fixed-column"
  }, [_c('div', {
    staticClass: "controls-card"
  }, [_c('div', {
    staticClass: "controls-card-header"
  }, [_vm._v("\n          Chart Controls\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "controls-card-body"
  }, [_c('div', {
    staticClass: "controls-card-control-group dates",
    class: {
      'controls-card-control-group--collapsed': _vm.controls.selectedControlDates
    }
  }, [_c('div', {
    staticClass: "controls-card-control-group__header",
    on: {
      "click": function($event) {
        _vm.controls.selectedControlDates = !_vm.controls.selectedControlDates
      }
    }
  }, [_vm._v("\n              Date Range\n              "), _c('i', {
    staticClass: "material-icons  filters-toggle__icon ",
    class: {
      'rotated-icon': _vm.controls.selectedControlDates
    }
  }, [_vm._v("\n                arrow_drop_down\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "controls-card-control-group__content"
  }, [_c('span', {
    staticClass: "controls-card-control-group__title"
  }, [_vm._v("Select date range:")]), _vm._v(" "), _c('div', {
    staticClass: "date-picker-wrapper"
  }, [_c('div', {
    staticClass: "site-reports-toolbar-datepicker"
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.controls.startDateModal),
      callback: function($$v) {
        _vm.$set(_vm.controls, "startDateModal", $$v)
      },
      expression: "controls.startDateModal"
    }
  }, [_c('div', {
    staticClass: "site-reports-toolbar-datepicker__activator",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('span', {
    staticClass: "site-reports-toolbar-datepicker__activator-text"
  }, [_vm._v(_vm._s(_vm.startDate ? _vm.startDate : "Start Date"))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-calendar"
  })]), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "actions": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          staticClass: "btn-nww",
          nativeOn: {
            "click": function($event) {
              save()
            }
          }
        }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              cancel()
            }
          }
        }, [_vm._v("Cancel")])], 1)]
      }
    }]),
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "site-reports-toolbar-datepicker"
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.controls.endDateModal),
      callback: function($$v) {
        _vm.$set(_vm.controls, "endDateModal", $$v)
      },
      expression: "controls.endDateModal"
    }
  }, [_c('div', {
    staticClass: "site-reports-toolbar-datepicker__activator",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('span', {
    staticClass: "site-reports-toolbar-datepicker__activator-text"
  }, [_vm._v(_vm._s(_vm.endDate ? _vm.endDate : "End Date"))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-calendar"
  })]), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "actions": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          staticClass: "btn-nww",
          nativeOn: {
            "click": function($event) {
              save()
            }
          }
        }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              cancel()
            }
          }
        }, [_vm._v("Cancel")])], 1)]
      }
    }]),
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "controls-card-control-group download",
    class: {
      'controls-card-control-group--collapsed': _vm.controls.selectedControlReport
    }
  }, [_c('div', {
    staticClass: "controls-card-control-group__header",
    on: {
      "click": function($event) {
        _vm.controls.selectedControlReport = !_vm.controls.selectedControlReport
      }
    }
  }, [_vm._v("\n              Download Data\n              "), _c('i', {
    staticClass: "material-icons",
    class: {
      'rotated-icon': _vm.controls.selectedControlReport
    }
  }, [_vm._v("\n                arrow_drop_down\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "controls-card-control-group__content"
  }, [_c('v-btn', {
    staticClass: "btn md-raised btn-nww--light",
    attrs: {
      "disabled": !_vm.selectedSite
    },
    on: {
      "click": _vm.exportXls
    }
  }, [_vm._v("\n                Download  XLS\n              ")])], 1)])])]), _vm._v(" "), _c('ecoli-chart', {
    attrs: {
      "selected-site": _vm.selectedSite,
      "reports": _vm.reports
    }
  }), _vm._v(" "), _c('turbidity-chart', {
    attrs: {
      "selected-site": _vm.selectedSite,
      "reports": _vm.reports
    }
  }), _vm._v(" "), _c('conductivity-chart', {
    attrs: {
      "selected-site": _vm.selectedSite,
      "reports": _vm.reports
    }
  }), _vm._v(" "), _c('rainfall-chart', {
    attrs: {
      "selected-site": _vm.selectedSite,
      "reports": _vm.reports
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return uploadNewGeoJsonFile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var uploadNewGeoJsonFile = function uploadNewGeoJsonFile(collectionSites) {
  var newFile = _generateJsonObject(collectionSites);
  var storageRef = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.storage().ref();
  var fileRef = storageRef.child('sites.geojson');

  fileRef.put(newFile).then(function (snapshot) {
    console.log('Uploaded new geojson file!');
  });
};

function _generateJsonObject(collectionSites) {
  var features = [];

  __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(collectionSites, function (item) {
    if (!item.isPrivate) {
      var tempObject = {
        'type': 'Feature',
        'geometry': {
          'type': 'Point',
          'coordinates': [item.longitude, item.latitude]
        },
        'properties': {
          'Name': item.stationName
        }
      };
      features.push(tempObject);
    }
  });

  var dataObject = {
    'type': 'FeatureCollection',
    'crs': {
      'type': 'name',
      'properties': {
        'name': 'urn:ogc:def:crs:OGC:1.3:CRS84'
      }
    },
    'features': features
  };

  return new Blob([__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dataObject)], { type: 'application/json' });
}

/***/ }),

/***/ 60:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_CollectionSites__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_CollectionSites___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_admin_CollectionSites__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_CollectionSiteData__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_CollectionSiteData___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_CollectionSiteData__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_LogData__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_LogData___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_LogData__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_main_About__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_main_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_main_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_main_DataPage__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_main_DataPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_main_DataPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_main_SignIn__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_main_SignIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_main_SignIn__);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '*',
    redirect: '/DataPage'
  }, {
    path: '/',
    redirect: '/DataPage'
  }, {
    path: '/DataPage',
    name: 'DataPage',
    component: __WEBPACK_IMPORTED_MODULE_6__components_main_DataPage___default.a
  }, {
    path: '/signIn',
    component: __WEBPACK_IMPORTED_MODULE_7__components_main_SignIn___default.a
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_5__components_main_About___default.a
  }, {
    path: '/collectionSiteData/:siteId',
    name: 'Collection Site Data',
    component: __WEBPACK_IMPORTED_MODULE_3__components_admin_CollectionSiteData___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/logData',
    name: 'Log Data',
    component: __WEBPACK_IMPORTED_MODULE_4__components_admin_LogData___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/collectionSites',
    name: 'Collection Sites',
    component: __WEBPACK_IMPORTED_MODULE_2__components_admin_CollectionSites___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/logData/:id',
    name: 'Log Data Id',
    component: __WEBPACK_IMPORTED_MODULE_4__components_admin_LogData___default.a,
    meta: { requiresAuth: true }
  }]
}));

/***/ })

},[332]);


// WEBPACK FOOTER //
// static/js/app.6cdab91f0599b5c88c0f.js